webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _apis = __webpack_require__(5);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _libFlexible = __webpack_require__(108);
	
	var _libFlexible2 = _interopRequireDefault(_libFlexible);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _vuex = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.mixin({
		data: function data() {
			return {
				isFirstShare: true,
				qrCodeMask: false
			};
		},
	
		methods: {
			authorize: function authorize(url) {
				_axios2.default.get('/authorize', {
					url: encodeURIComponent(url)
				});
			},
			isOwnEmpty: function isOwnEmpty(obj) {
				for (var name in obj) {
					if (obj.hasOwnProperty(name)) {
						return false;
					}
				}
				return true;
			},
			getObjLength: function getObjLength(obj) {
				var length = 0;
				for (var name in obj) {
					if (obj.hasOwnProperty(name)) {
						length++;
					}
				}
				return length;
			},
			oneQrcode: function oneQrcode() {
				this.$data.qrCodeMask = !this.$data.qrCodeMask;
				this.$data.isFirstShare = false;
			},
			GetQueryString: function GetQueryString(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);return null;
			}
		}
	});
	
	
	var app = new _vue2.default({
		store: _store2.default,
		router: _router2.default,
		computed: (0, _vuex.mapState)(['channel_id']),
		created: function created() {
			var that = this;
			if (that.$route.query.channel_id) {
				that.setChannelId(that.$route.query.channel_id);
			}
			if (that.GetQueryString("channel_id")) {
				that.setChannelId(that.GetQueryString("channel_id"));
			}
			that.getWxConfig(that.channel_id);
		},
	
		watch: {
			'channel_id': function channel_id(newVal) {
				this.getWxConfig(newVal);
			}
		},
		methods: {
			getWxConfig: function getWxConfig(channelId) {
				var that = this;
				_axios2.default.get(_apis2.default.wechatData, {
					params: {
						url: location.href.split('#')[0],
						channelId: channelId
					}
				}).then(function (res) {
					var data = res.data.data;
					wx.config({
						debug: false,
						appId: data.appId,
						timestamp: data.timestamp,
						nonceStr: data.nonceStr,
						signature: data.signature,
						jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'showMenuItems'] });
	
					wx.ready(function () {
						wx.hideMenuItems({
							menuList: ['menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari", "menuItem:copyUrl"] });
					});
	
					wx.error(function (res) {
						alert(res);
					});
				}).catch(function (error) {
					console.log(error);
				});
			}
		}
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(140);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _Index = __webpack_require__(119);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _question = __webpack_require__(123);
	
	var _question2 = _interopRequireDefault(_question);
	
	var _funreport = __webpack_require__(121);
	
	var _funreport2 = _interopRequireDefault(_funreport);
	
	var _sharereport = __webpack_require__(124);
	
	var _sharereport2 = _interopRequireDefault(_sharereport);
	
	var _proreport = __webpack_require__(122);
	
	var _proreport2 = _interopRequireDefault(_proreport);
	
	var _download = __webpack_require__(120);
	
	var _download2 = _interopRequireDefault(_download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	
	var router = new _vueRouter2.default({
		routes: [{
			name: '',
			path: '/',
			component: _Index2.default
		}, {
			name: 'index',
			path: '/index',
			component: _Index2.default
		}, {
			name: 'question',
			path: '/question/:questionId',
			component: _question2.default
		}, {
			name: 'funreport',
			path: '/funreport',
			component: _funreport2.default
		}, {
			name: 'sharereport',
			path: '/sharereport/:reportId',
			component: _sharereport2.default
		}, {
			name: 'proreport',
			path: '/proreport/',
			component: _proreport2.default
		}, {
			name: 'download',
			path: '/download',
			component: _download2.default
		}, { path: '*', redirect: '/index' }]
	});
	exports.default = router;

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var env = location.host.split('.')[0].match(/(qc|box)\d?/g);
	var spell = !!env ? env.length > 0 ? '-' + env[0] : '' : '';
	var _domain = '//wx' + spell + '.xinli001.com';
	var LXDOMAIN = '//lingxi' + spell + '.xinli001.com/lingxi/service/';
	var APIS = {
		'isTested': _domain + '/StaticApi/animal/isTested',
		'questions': _domain + '/StaticApi/animal/lists',
		'funreport': _domain + '/StaticApi/animal/create',
		'unlockReport': _domain + '/StaticApi/animal/reportRelease',
		'unlockPeople': _domain + '/StaticApi/animal/statistics',
		'sharereport': _domain + '/StaticApi/animal/shareReport',
		'getSelfReport': _domain + '/StaticApi/animal/getSelfReport',
		'wechatData': LXDOMAIN + 'wx/jsConfig',
		'shouquan': _domain + '/staticApi/common/authorization.html',
		'tagclick': _domain + '/StaticApi/animal/tagclick',
		'buyProReport': _domain + '/StaticApi/order/createFreeOrder',
		'proreport': _domain + '/StaticApi/animal/getReport',
		'friends': _domain + '/StaticApi/animal/friendReport',
		'pay': _domain + '/StaticApi/freeTestOrder/payorder.html' };
	
	exports.default = APIS;

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(107)
	
	/* template */
	var __vue_template__ = __webpack_require__(139)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(1);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _apis = __webpack_require__(5);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _data = __webpack_require__(25);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _qs = __webpack_require__(17);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	
	var shouquan = function shouquan() {
	    window.location.href = _apis2.default.shouquan + '?callback=' + location.href;
	};
	_axios2.default.defaults.withCredentials = true;
	
	var store = new _vuex2.default.Store({
	    state: {
	        busy: false,
	        stayFun: true,
	        channel_id: 1,
	        sex: '1',
	        isTested: undefined,
	        curQuestion: 1,
	        questions: {},
	        questionListLength: 0,
	        answers: {},
	        shareLock: 1,
	        userInfo: {},
	        price: 0,
	        selfResult: null,
	        funreport: null,
	        sharereport: null,
	        friendList: [],
	        shareFrom: null,
	        finishTest: false
	    },
	    mutations: {
	        setSex: function setSex(state, sex) {
	            state.sex = sex;
	        },
	        setStayFun: function setStayFun(state, tof) {
	            state.stayFun = tof;
	        },
	        setChannelId: function setChannelId(state, channel_id) {
	            state.channel_id = channel_id;
	        },
	        setCurQuestion: function setCurQuestion(state, questionIndex) {
	            state.curQuestion = questionIndex;
	        },
	        setAnswer: function setAnswer(state, answer) {
	            state.answer[state.curQuestion] = answer;
	        },
	        setQuestions: function setQuestions(state, questions) {
	            state.questions = questions;
	        },
	        setAnswers: function setAnswers(state, answer) {
	            state.answers[answer.key] = answer.value;
	            state.questions[state.curQuestion].selected = answer.value;
	        },
	        setQuestionListLength: function setQuestionListLength(state, length) {
	            state.questionListLength = length;
	        },
	        setIstested: function setIstested(state, isTested) {
	            state.isTested = isTested;
	        },
	        setFunreport: function setFunreport(state, payload) {
	            state.selfResult = payload.report;
	
	            var type = payload.report.result_type == "" ? 'scmp' : payload.report.result_type;
	            state.funreport = _data2.default[type][payload.report.gender];
	        },
	        setFinishTest: function setFinishTest(state, tof) {
	            state.finishTest = tof;
	        },
	        setBusy: function setBusy(state, tof) {
	            state.busy = tof;
	        },
	        setshareLock: function setshareLock(state) {
	            state.selfResult.unlock = 1;
	        },
	        setUnlockPeople: function setUnlockPeople(state) {
	            if (state.selfResult) {
	                state.selfResult.unlock_num = state.selfResult.unlock_num * 1 + 1;
	            }
	        },
	        setShareReport: function setShareReport(state, payload) {
	            state.selfResult = payload.report;
	            state.sharereport = _data2.default[payload.report.result_type][payload.report.gender];
	        },
	        setFriendList: function setFriendList(state, payload) {
	            state.friendList = payload;
	        },
	        emptyReport: function emptyReport(state) {
	            state.selfResult = null;
	            state.funreport = null;
	            state.sharereport = null;
	            state.finishTest = false;
	            state.curQuestion = 1;
	        },
	        setShareFrom: function setShareFrom(state, fromId) {
	            state.shareFrom = fromId;
	        }
	    },
	    actions: {
	        pullQuestion: function pullQuestion(context, getObjLength) {
	            context.commit('setBusy', true);
	            _axios2.default.get(_apis2.default.questions, {
	                params: {}
	            }).then(function (res) {
	                context.commit('setBusy', false);
	                if (res.data.code == 200) {
	                    context.commit('setQuestions', res.data.data);
	                    context.commit('setQuestionListLength', getObjLength(res.data.data));
	                } else if (res.data.code == 1001) {
	                    shouquan();
	                }
	            }).catch(function (error) {
	                context.commit('setBusy', false);
	                console.log(error);
	            });
	        },
	        pullIstested: function pullIstested(context, getObjLength) {
	            context.commit('setBusy', true);
	            _axios2.default.get(_apis2.default.isTested).then(function (res) {
	                context.commit('setBusy', false);
	                if (res.data.code == 200) {
	                    context.commit('setIstested', res.data.data.is_tested);
	                } else if (res.data.code == 1001) {
	                    shouquan();
	                }
	            }).catch(function (error) {
	                context.commit('setBusy', false);
	                console.log(error);
	            });
	        },
	        createFunReport: function createFunReport(context, data) {
	            var longEnough = data.check(data.dataPack.params);
	            var postData = {
	                gender: data.dataPack.gender,
	                data: (0, _stringify2.default)(data.dataPack.params)
	            };
	            if (context.state.shareFrom != null & context.state.shareFrom != undefined & context.state.shareFrom != '') {
	                postData.activate_id = context.state.shareFrom;
	            }
	            if (longEnough != data.questionListLength) {
	                return false;
	            }
	            context.commit('setBusy', true);
	            _axios2.default.post(_apis2.default.funreport, _qs2.default.stringify(postData)).then(function (res) {
	                context.commit('setBusy', false);
	                if (res.data.code == 200) {
	                    context.dispatch('getSelfReport', {
	                        callback: data.callback
	                    });
	                } else if (res.data.code == 1001) {
	                    shouquan();
	                } else {
	                    console.log('创建报告失败');
	                }
	            }).catch(function (error) {
	                context.commit('setBusy', false);
	                console.log(error);
	            });
	        },
	        getSelfReport: function getSelfReport(context, payload) {
	            _axios2.default.get(_apis2.default.getSelfReport).then(function (res) {
	                if (res.data.code == 200) {
	                    context.commit('setFunreport', {
	                        report: res.data.data
	                    });
	                    context.dispatch('getFriendList', res.data.data.activate_id);
	                    if (payload.callback != undefined & typeof payload.callback == 'function') {
	                        payload.callback();
	                    }
	                } else if (res.data.code == 1001) {
	                    shouquan();
	                }
	            }).catch(function (error) {
	                context.commit('setBusy', false);
	                console.log(error);
	            });
	        },
	        getFriendList: function getFriendList(context, payload) {
	            context.commit('setBusy', true);
	            _axios2.default.get(_apis2.default.friends, {
	                params: {
	                    id: payload
	                }
	            }).then(function (res) {
	                context.commit('setBusy', false);
	                if (res.data.code == 200) {
	                    context.commit('setFriendList', res.data.data);
	                }
	            }).catch(function (error) {
	                context.commit('setBusy', false);
	                console.log(error);
	            });
	        },
	        unLockPeopleAdd: function unLockPeopleAdd(context, id) {
	            context.commit('setBusy', true);
	            _axios2.default.get(_apis2.default.unlockPeople, {
	                params: {
	                    id: id ? id : '11'
	                }
	            }).then(function (res) {
	                context.commit('setBusy', false);
	                if (res.data.code == 200) {
	                    context.commit('setUnlockPeople');
	                }
	            }).catch(function (error) {
	                context.commit('setBusy', false);
	                console.log(error);
	            });
	        },
	        buyProReport: function buyProReport(context, payload) {
	            context.commit('setBusy', true);
	            location.href = _apis2.default.buyProReport + '?test_id=' + (payload.test_id ? payload.test_id : 11) + '&channel_id=' + (payload.channel_id ? payload.channel_id : 1);
	        },
	        unLockReport: function unLockReport(context, id) {
	            context.commit('setBusy', true);
	            _axios2.default.get(_apis2.default.unlockReport, {
	                params: {
	                    id: id
	                }
	            }).then(function (res) {
	                context.commit('setBusy', false);
	                if (res.data.code == 200) {
	                    context.commit('setshareLock');
	                }
	                context.dispatch('getFriendList', id);
	            }).catch(function (error) {
	                context.commit('setBusy', false);
	                console.log(error);
	            });
	        },
	        pullShareInfo: function pullShareInfo(context, data) {
	            context.commit('setBusy', true);
	            _axios2.default.get(_apis2.default.sharereport, {
	                params: {
	                    id: data.id
	                }
	            }).then(function (res) {
	                context.commit('setBusy', true);
	                if (res.data.code == 200) {
	                    context.commit('setShareReport', {
	                        report: res.data.data,
	                        gender: data.gender
	                    });
	                }
	            }).catch(function (error) {
	                context.commit('setBusy', true);
	                console.log(error);
	            });
	        }
	    }
	});
	
	exports.default = store;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(93)
	
	/* script */
	__vue_exports__ = __webpack_require__(56)
	
	/* template */
	var __vue_template__ = __webpack_require__(125)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-099717f6"
	
	module.exports = __vue_exports__


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/funreport-qrcode.351260c.png";

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var data = [{ 'key': 'M',
	  'sex': 'male',
	  'animal': '波斯猫',
	  'animal_en': 'Persiancat',
	  'pic': '../static/funreports/bosimao/animal.png',
	  'tags': '细节控晚期、追求完美、柯南附体、敏感、爱憎分明、斯文、理想主义者、计划者、总有刁民想害朕',
	  'short_description': '波斯猫性格的你给人感觉非常温文尔雅，气质高贵而华丽，在生活里追求完美，和十分爱护自己的毛发的波斯猫有着相似之处。波斯猫性格内敛，举止优雅，很少看到它们玩闹，它们常常安静的呆着，像是在思考着什么，表面上总是安静而慵懒的它们习惯隐匿内心的喜怒哀乐。',
	  'coordinate': '',
	  'basic_discription': '你总体上性格内向，不喜欢把情感表露出来，总是有自己的小心思，思想有深度但看待事物的角度略显悲观，所以喜欢做未雨绸缪的事。<br/><br/>你在工作上非常有主见，有比较苛刻的标准和要求，常常会考究事物发展是否符合你的设想，为了达到比较完美的标准，你可能不会放过任何一个细节，因为在你看来，如果一件事值得去做，那就要做到最好。在这种模式下，如果他人没有达到你的标准，你会对其进行适当督促。<br/><br/>同时，在工作中，你会有一个比较清晰的目标，喜欢有计划地开展和进行工作。喜欢深度分析和思考问题的你，适合研究类的、不与人打交道的工作。但是太要求完美的你，很可能因难以达到你的高标准而陷入抑郁的情绪中。',
	  'in_lover': '在你的女朋友（或将来女朋友）面前，你是一个不太懂人情世故的高智商呆板男朋友。具体参照人物可以参照周星驰，谢耳朵。<br/><br/>在她看来，你是一个非常优秀的人。因为你对自己不断地提出要求和标准，常常在对待工作或学习中一丝不苟，你认真做起事情来的样子会让她非常着迷。<br/><br/>同时，因为你的注意焦点常常在外部事物上，所以人际关系方面的经验相对不足，容易对他人的反应比较敏感。实际上，你内心的情感非常丰富，当现实中没有达到标准时很容易受挫，外在表现比较情绪化。和你在一起，她需要更加懂你，呵护你，开导你的内心。只有这种方式，你们之间才有可能长久。',
	  'in_friends': '朋友眼中的你，爱思考，不浮夸，生活比较理性。如果他人需要进行某项决策，你是一个不错的建议者，因为你擅长分析，并且角度公正。虽然你不太擅长人际关系，但其实你对他人并无恶意。在你的朋友看来，你在人际方面比较单纯而敏感，会受到来自他人的负面信息的影响，因此朋友较少，但是一旦成为朋友，你绝对忠诚而可靠，会为了朋友两肋插刀。',
	  'in_colleagues': '在同事的眼中，你是一个有主见，有立场，有鲜明见解的人。在他们看来，你能透过事情的表象看到问题产生的根源，思维比较有深度，常常能给出比较有根据的意见和建议。<br/><br/>你工作起来有时会废寝忘食，为了让自己满意，你可能会一直揪着某个细节反复斟酌和考量。工作的时候非常有条理和秩序性，会做好计划，也会善始善终。但是，换一个角度，这样的你不太关注自己情绪或情感上的需求，受到挫折时难以自我体谅，可能会陷入崩溃中。',
	  'will_be': '在孩子面前，你是一个权威型的家长，希望孩子一切都能依从自己的标准。对于孩子，你有各种各样的“家规”，孩子需要尽力做一个“别人家的孩子”，不能碰触到你的标准和底线，否则他可能就要经历一场暴风雨了。<br/><br/>权威型的你，常常能把自己的家里打理得井井有条，因为一切脏、乱、差的生活环境在你看来都是不能容忍的。表面上，你是一个“严父”，但背地里你依然会为他收拾东西，为了孩子你很有牺牲精神。',
	  'advantage': '1)你是一个习惯思考的人，看待事情一般不会停留在表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)对待事物比较有主见，处理事情条理也比较清晰，对做事情有自己的标准，容易督促事情向好的方面发展；<br/><br/>3)你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何事情只要你想去做，你就会希望把它做得尽善尽美。举个栗子——周星驰，作为完美型代表，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4)你的衣品比较好，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你得体的着装可能源自你良好的家庭教养。',
	  'shortcoming': '1）具有完美型追求的你有时候会情绪忧郁。因为追求高标准的你可能在现实中难以得到满足，这导致你有时会去钻牛角尖，从而使自己情绪抑郁和低落；<br/><br/>2）天性有消极倾向。对自己的评价经常过于苛刻，常自寻烦恼，有一定程度的自卑；<br/><br/>3）人际关系不够融洽。因为完美型的你对负面的信息比较敏感，容易让你和他人之间产生距离；<br/><br/>4）对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。',
	  'suggest': '1）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以看电视，进行其他活动等来转移注意力；<br/><br/>2）尝试新鲜事物。和平型的你通常喜欢安于现状，拒绝生活的变动。你可以尝试新鲜事物，或许可以发现更多精彩。多参加兴趣小组，接受新的东西是不错的选择；<br/><br/>3）工作中培养锐意进取的心态。有时候虽然你有完美型的计划和目标性，但遇到挫折时你可能会走向放弃的平和性，虽然这能让你在情绪和心态上得到疏解，但有时可能再加上一点点行进的动力，不会更容易达到成功；<br/><br/>4）关注他人的感受，放大自己的视野。你如果过度关注自己目标的达成，有时会忽略身边朋友的情绪情感，因此，与人交往过程中，学会换位思考很重要；<br/><br/>5）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多。',
	  'match_jobs': '学者，分析者，规划者，记录者，科学家，研究员'
	}, { 'key': 'M',
	  'sex': 'female',
	  'animal': '波斯猫',
	  'animal_en': 'Persiancat',
	  'pic': '../static/funreports/bosimao/animal.png',
	  'tags': '细节控晚期、追求完美、柯南附体、敏感、爱憎分明、斯文、理想主义者、计划者、总有刁民想害朕',
	  'short_description': '波斯猫性格的你给人感觉非常温文尔雅，气质高贵而华丽，在生活里追求完美，和十分爱护自己的毛发的波斯猫有着相似之处。波斯猫性格内敛，举止优雅，很少看到它们玩闹，它们常常安静的呆着，像是在思考着什么，表面上总是安静而慵懒的它们习惯隐匿内心的喜怒哀乐。',
	  'coordinate': '',
	  'basic_discription': '你总体上性格内向，不喜欢把情感表露出来，总是有自己的小心思，思想有深度但看待事物的角度略显悲观，所以喜欢做未雨绸缪的事。<br/><br/>你在工作上非常有主见，有比较苛刻的标准和要求，常常会考究事物发展是否符合你的设想，为了达到比较完美的标准，你可能不会放过任何一个细节，因为在你看来，如果一件事值得去做，那就要做到最好。在这种模式下，如果他人没有达到你的标准，你会对其进行适当督促。<br/><br/>同时，在工作中，你会有一个比较清晰的目标，喜欢有计划地开展和进行工作。喜欢深度分析和思考问题的你，适合研究类的、不与人打交道的工作。但是太要求完美的你，很可能因难以达到你的高标准而陷入抑郁的情绪中。',
	  'in_lover': '在你的男朋友（或将来男朋友）面前，你是一个聪明但不太懂人情世故的女生。<br/><br/>在他看来，你是一个非常优秀的人，因为你对自己不断地提出要求和标准，常常在对待工作或学习中一丝不苟，你认真做起事情来的样子让他非常欣赏。<br/><br/>同时，因为你的注意焦点常常在外部事物上，所以人际关系方面的经验相对不足，容易对他人的反应比较敏感。实际上，你内心的情感非常丰富，当现实中没有达到标准时很容易受挫，外在表现比较情绪化。和你在一起，他需要更加懂你，呵护你，开导你的内心。只有这种方式，你们之间才有可能长久。',
	  'in_friends': '朋友眼中的你，爱思考，不浮夸，生活比较理性。如果他人需要进行某项决策，你是一个不错的建议者，因为你擅长分析，并且角度公正。虽然你不太擅长人际关系，但其实你对他人并无恶意。在你的朋友看来，你在人际方面比较单纯而敏感，会受到来自他人的负面信息的影响，因此朋友较少，但是一旦成为朋友，你绝对忠诚而可靠，会为了朋友两肋插刀。',
	  'in_colleagues': '在同事的眼中，你是一个有主见，有立场，有鲜明见解的人。在他们看来，你能透过事情的表象看到问题产生的根源，思维比较有深度，常常能给出比较有根据的意见和建议。<br/><br/>你工作起来有时会废寝忘食，为了让自己满意，你可能会一直揪着某个细节反复斟酌和考量。工作的时候非常有条理和秩序性，会做好计划，也会善始善终。但是，换一个角度，这样的你不太关注自己情绪或情感上的需求，受到挫折时难以自我体谅，可能会陷入崩溃中。',
	  'will_be': '在孩子面前，你是一个权威型的家长，希望孩子一切都能依从自己的标准。对于孩子，你有各种各样的“家规”，孩子需要尽力做一个“别人家的孩子”，不能碰触到你的标准和底线，否则他可能就要经历一场暴风雨了。<br/><br/>权威型的你，常常能把自己的家里打理得井井有条，因为一切脏、乱、差的生活环境在你看来都是不能容忍的。表面上，你是一个“虎妈”，但背地里你依然会为他收拾东西，为了孩子你很有牺牲精神。',
	  'advantage': '1)你是一个习惯思考的人，看待事情一般不会停留在表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)对待事物比较有主见，处理事情条理也比较清晰，对做事情有自己的标准，容易督促事情向好的方面发展；<br/><br/>3)你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何事情只要你想去做，你就会希望把它做得尽善尽美。举个栗子——周星驰，作为完美型代表，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4)你的衣品比较好，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你得体的着装可能源自你良好的家庭教养。',
	  'shortcoming': '1）具有完美型追求的你有时候会情绪忧郁，有悲观倾向。因为追求高标准的你可能在现实中难以得到满足，这导致你有时会去钻牛角尖，从而使自己情绪抑郁和低落；<br/><br/>2）天性有消极倾向。对自己的评价经常过于苛刻，常自寻烦恼，有一定程度的自卑；<br/><br/>3）人际关系不够融洽。因为完美型的你对负面的信息比较敏感，容易让你和他人之间产生距离；<br/><br/>4）完美型对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。',
	  'suggest': '1）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以看电视，进行其他活动等来转移注意力；<br/><br/>2）尝试新鲜事物。和平型的你通常喜欢安于现状，拒绝生活的变动。你可以尝试新鲜事物，或许可以发现更多精彩。多参加兴趣小组，接受新的东西是不错的选择；<br/><br/>3）工作中培养锐意进取的心态。有时候虽然你有完美型的计划和目标性，但遇到挫折时你可能会走向放弃的平和性，虽然这能让你在情绪和心态上得到疏解，但有时可能再加上一点点行进的动力，不会更容易达到成功；<br/><br/>4）关注他人的感受，放大自己的视野。你如果过度关注自己目标的达成，有时会忽略身边朋友的情绪情感，因此，与人交往过程中，学会换位思考很重要；<br/><br/>5）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多。',
	  'match_jobs': '学者，分析者，规划者，记录者，科学家，研究员'
	}, { 'key': 'Mc',
	  'sex': 'male',
	  'animal': '虎鲸',
	  'animal_en': 'Orcinusorca',
	  'pic': '../static/funreports/hujing/animal.png',
	  'tags': '工作狂、深藏blue、有责任感、偏执、独立自主、追求完美、有魄力、最强大脑、颜控、不愿意将就',
	  'short_description': '作为高智商动物，虎鲸将它们的智商用在合作捕猎上。一队虎鲸群通常会把捕猎技术操练几十年，直到从不出错为止，表现出了追求完美的一面。而你也是一个完美主义者，常常执着于自己追求的事物。但追求完美的你有时候说话太过直白，可能会在交流过程中忽略了别人的感受。',
	  'coordinate': '',
	  'basic_discription': '你的性格特点能让你在工作中有所发挥，是个不错的商业人才。对你来说，没有什么是做不来的。对于工作，你很敏锐，通常能神奇地预测到事物的发展和走向，这是因为你对表面的东西能进行深入的分析，不浮于表面，再加上对细节的洞察力，综合这些因素能让你在工作上有所作为。<br/><br/>你在很多方面都很有才华，在穿衣打扮上常常表现为干净整洁，且有品位，对于很多事物的看法注重内涵和质量。如果将完美型的“高标准”、“苛求细节”和“有天赋”等这些特点合理利用，那么很容易有所作为。正如亚里士多德所说：“所有天才都有完美型的特点。”作家、艺术家和音乐家通常都是完美型的。他们天资聪颖，潜能若被恰当地激发，得以发挥，便产生了巨人。',
	  'in_lover': '感情中的你非常挑剔，对另一半的要求很高，喜欢列出你的理想标准并逐条对比。因此，作为你爱情中的对象其实是很辛苦的，因为需要承担来自你各个方面的要求。但同时，成为你的伴侣是很幸福的，在你的影响下，你的伴侣通常也会不断的自我成长来达到你的要求，这段关系会逐渐走向好的方面，双方在关系中也能收获个人成长。<br/><br/>完美主义的你通常情况下在爱情中处于主导的地位，即便一开始没有，后来也会慢慢掌控爱情的决策权。但是你的完美主义也有可能让你显得有些大男子主义，但其实你暗地里为你的另一半简直操碎了心，你的人情味体现在，虽然你对她有各种各样的要求，但你会为她打理很多琐事，有一种霸道总裁式的温柔。不过当你发现感情不再适合时会尽早“止损”，很少拖泥带水。',
	  'in_friends': '你是一个比较慢热的人，因而并不是走到哪里都有很多朋友。但作为一个气场强大的人，你能从工作或其他事物中找到很多乐趣。为了工作你能牺牲很多。虽然你朋友不多，但现有的朋友交往真诚而有深度，这是因为你谨小慎微的性格导致了你交友慎重。作为你的朋友是幸福的，因为你忠实可靠，会为了朋友而甘心听对方的牢骚，为ta解决实际问题。如果你的朋友是感性的，那么ta会从你这里得到很多中肯的建议。',
	  'in_colleagues': '在他人看来，工作上你简直是“细节控”，见到乱、不美观的事物你会非常难受。你在工作中擅长预先做计划，并且目标性强，是强迫性工作者；遇到困难擅长分析和思考，能够理性对待实际的问题，并寻找替代性的解决方法。这对于你的领导来说，你是一个得力的手下干将，Ta会乐于交付你一些重要的事。而对于你的下属来说，除了有时候要求会比较“变态”之外，他们能够清晰明确自己的工作重点和任务，能够帮他们进行良好的锻炼。',
	  'will_be': '作为家长，你绝不容许自己的家里乱糟糟的，那些电视里的各种“熊孩子”几乎不可能在你的家里出现，鉴于你优秀的组织和管理能力，你同样能把家里打造得井井有条。你总是对你的孩子有各方面的要求，如果孩子没有按照你的想法去做，你会非常难受，会想尽办法让对方听从于你。除非出现重要的转折，否则让你放弃你的完美型标准实在很难。但是，你依然有父亲的慈爱，即便你会指责你的孩子邋遢叛逆，但你还是会不断的为ta操心操力。只是如果能换一种表现形式，可能会效果更好。',
	  'advantage': '1）对待工作严肃认真，强调做事情的逻辑性和秩序性，对于工作的一丝不苟受益于儿时父母对你的严格要求。这种良好的做事习惯让你领导放心将工作交付给你；<br/><br/>2）你有衣品，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你的衣品和得体着装的培养来源你良好的家庭教养；<br/><br/>3）你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何只要你想要去做的事情，你就希望把它做得尽善尽美。例如完美型的典型代表周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4）你很有才华，想象力丰富，有创造性。你并不是一个死板，只知道遵循常规的人。为了让自己做到满意，你通常会考虑多方面因素，从多个角度来考虑问题，对问题的思考具有开创性；<br/><br/>5）你对事物有一定的控制力，对事物的发展有较强的掌控欲望，因此处理事情较果断。',
	  'shortcoming': '1）你的完美主义太过极端的话，会导致你容易钻牛角尖，从而引起你情绪低落，容易抑郁；<br/><br/>2）太注重工作等客观事物的你，容易忽视身边的人的感受，难以设身处地站在他人的角度去看待问题。这可能使你在人际关系与他人相处不是百分百融洽，因为你会无形中给人压力，工作中难以找到交心的朋友；<br/><br/>3）你对他人的要求有时候不切实际。虽然了解你的朋友知道，你只是就事论事，只是为了让事物往最好的方向发展而以对自己要求的标准去要求他人，但这在与你不熟的人看来，你是一个冷酷而少有人情味的人；<br/><br/>4）对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。但是这一缺点在力量型的缓和下能有所改善，力量型能一定程度上能帮助促进你事物的进展。',
	  'suggest': '1）学会放松，减轻对别人的压力：追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让我们周围的人产生可怕的压力；<br/><br/>2）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多；<br/><br/>3）适当降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和他人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准；<br/><br/>4）学会自我排解。当工作中你的完美主义已经非常影响你的情绪时，你需要适当进行自我疏导，也可以找朋友聊一聊。如果你是一个非常内敛的人，那么听心理FM，听古典音乐，洗个热水澡或进行一场酣畅淋漓的运动都是有效的。',
	  'match_jobs': '科研方面的工作，专家，分析者，规划者等'
	}, { 'key': 'Mc',
	  'sex': 'female',
	  'animal': '虎鲸',
	  'animal_en': 'Orcinusorca',
	  'pic': '../static/funreports/hujing/animal.png',
	  'tags': '工作狂、深藏blue、有责任感、偏执、独立自主、追求完美、有魄力、最强大脑、颜控、不愿意将就',
	  'short_description': '作为高智商动物，虎鲸将它们的智商用在合作捕猎上。一队虎鲸群通常会把捕猎技术操练几十年，直到从不出错为止，表现出了追求完美的一面。而你也是一个完美主义者，常常执着于自己追求的事物。但追求完美的你有时候说话太过直白，可能会在交流过程中忽略了别人的感受。',
	  'coordinate': '',
	  'basic_discription': '你的性格特点能让你在工作中有所发挥，是个不错的商业人才。对你来说，没有什么是做不来的。对于工作，你很敏锐，通常能神奇地预测到事物的发展和走向，这是因为你对表面的东西能进行深入的分析，不浮于表面，再加上对细节的洞察力，综合这些因素能让你在工作上有所作为。<br/><br/>你在很多方面都很有才华，在穿衣打扮上常常表现为干净整洁，且有品位，对于很多事物的看法注重内涵和质量。如果将完美型的“高标准”、“苛求细节”和“有天赋”等这些特点合理利用，那么很容易有所作为。正如亚里士多德所说：“所有天才都有完美型的特点。”作家、艺术家和音乐家通常都是完美型的。他们天资聪颖，潜能若被恰当地激发，得以发挥，便产生了巨人。',
	  'in_lover': '感情中的你非常挑剔，对另一半的要求很高，喜欢列出你的理想标准并逐条对比。因此，作为你爱情中的对象其实是很辛苦的，因为需要承担来自你各个方面的要求。但同时，成为你的伴侣是很幸福的，在你的影响下，你的伴侣通常也会不断的自我成长来达到你的要求，这段关系会逐渐走向好的方面，双方在关系中也能收获个人成长。<br/><br/>完美主义的你通常情况下在爱情中处于主导的地位，即便一开始不会，后来也会慢慢掌控爱情的决策权。同时，你的完美主义也有可能让你显得有些强势，但其实你暗地里为你的另一半简直操碎了心，你的人情味体现在，虽然你对他有各种各样的要求，但你会为他打理很多琐事，这是你对他的柔情。不过当你发现感情不再适合时会尽早抽离，爱情中敢爱敢恨。',
	  'in_friends': '你是一个比较慢热的人，因而并不是走到哪里都有很多朋友。但作为一个气场强大的人，你能从工作或其他事物中找到很多乐趣。为了工作你能牺牲很多。虽然你朋友不多，但现有的朋友交往真诚而有深度，这是因为你谨小慎微的性格导致了你交友慎重。作为你的朋友是幸福的，因为你忠实可靠，会为了朋友而甘心听对方的牢骚，为ta解决实际问题。如果你的朋友是感性的，那么ta会从你这里得到很多中肯的建议。',
	  'in_colleagues': '在他人看来，工作上你简直是“细节控”，见到乱、不美观的事物你会非常难受。你在工作中擅长预先做计划，并且目标性强，是强迫性工作者；遇到困难擅长分析和思考，能够理性对待实际的问题，并寻找替代性的解决方法。这对于你的领导来说，你是一个得力的手下干将，Ta会乐于交付你一些重要的事。而对于你的下属来说，除了有时候要求会比较“变态”之外，他们能够清晰明确自己的工作重点和任务，能够帮他们进行良好的锻炼。',
	  'will_be': '作为家长，你绝不容许自己的家里乱糟糟的，那些电视里的各种“熊孩子”几乎不可能在你的家里出现，因为你优秀的组织和管理能力，同样能把家里打造得井井有条。你总是对你的孩子有各方面的要求，如果孩子没有按照你的想法去做，你会非常难受，会想尽办法让对方听从于你。除非出现重要的转折，否则让你放弃你的完美型标准实在很难。但是，你依然有母亲的温柔，即便你会指责你的孩子邋遢叛逆，但你还是会不断的为ta操心操力。只是如果能换一种表现形式，可能会效果更好。',
	  'advantage': '1）对待工作严肃认真，强调做事情的逻辑性和秩序性，对于工作的一丝不苟受益于儿时父母对你的严格要求。这种良好的做事习惯让你领导放心将工作交付给你；<br/><br/>2）你有衣品，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你的衣品和得体着装的培养来源你良好的家庭教养；<br/><br/>3）你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何只要你想要去做的事情，你就希望把它做得尽善尽美。例如完美型的典型代表周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4）你很有才华，想象力丰富，有创造性。你并不是一个死板，只知道遵循常规的人。为了让自己做到满意，你通常会考虑多方面因素，从多个角度来考虑问题，对问题的思考具有开创性；<br/><br/>5）你对事物有一定的控制力，对事物的发展有较强的掌控欲望，因此处理事情较果断。',
	  'shortcoming': '1）你的完美主义太过极端的话，会导致你容易钻牛角尖，从而引起你情绪低落，容易抑郁；<br/><br/>2）太注重工作等客观事物的你，容易忽视身边的人的感受，难以设身处地站在他人的角度去看待问题。这可能使你在人际关系与他人相处不是百分百融洽，因为你会无形中给人压力，工作中难以找到交心的朋友；<br/><br/>3）你对他人的要求有时候不切实际。虽然了解你的朋友知道，你只是就事论事，只是为了让事物往最好的方向发展而以对自己要求的标准去要求他人，但这在与你不熟的人看来，你是一个冷酷而少有人情味的人；<br/><br/>4）对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。但是这一缺点在力量型的缓和下能有所改善，力量型能一定程度上能帮助促进你事物的进展。',
	  'suggest': '1）学会放松，减轻对别人的压力：追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让我们周围的人产生可怕的压力；<br/><br/>2）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多；<br/><br/>3）适当降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和他人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准；<br/><br/>4）学会自我排解。当工作中你的完美主义已经非常影响你的情绪时，你需要适当进行自我疏导，也可以找朋友聊一聊。如果你是一个非常内敛的人，那么听心理FM，听古典音乐，洗个热水澡或进行一场酣畅淋漓的运动都是有效的。',
	  'match_jobs': '科研方面的工作，专家，分析者，规划者等'
	}, { 'key': 'Ms',
	  'sex': 'male',
	  'animal': '耳廓狐',
	  'animal_en': 'Vulpeszerda',
	  'pic': '../static/funreports/erkuohu/animal.png',
	  'tags': '乐观的悲观主义者、口嫌体正直、绅士_淑女、注意形象、有魅力、吐槽担当、好奇、闷骚、规划性强',
	  'short_description': '耳廓狐具有强烈的守土护幼意识，会划定各自的领地。但在某些情况下，多个耳廓狐家庭可能生活在一起，共享同一个洞穴。喜欢秩序化的你也喜欢给自己划定“领地”，不喜欢自己的计划被人打乱。但这并不妨碍你和别人相处，必要时，你也能和他人合作得很好。',
	  'coordinate': '',
	  'basic_discription': '一般来说，你在工作或者事务上有一种完美型的要求，会留意到他人较少注意到的细节，对于工作所要达成的效果有自己的要求和标准。但是和典型的完美主义者不同，在工作之余，你乐于与他人交往和互动，与他人交往也比较热情。<br/><br/>如果你受工作的限制比较大，那么你常常给人一种严肃、有追求的印象。但如果环境适宜，你也能释放你的玩心和天性。最重要的是，当你在工作或学习中受到挫折时，你能够通过与他人良好的交往和互动来得到情绪上的疏解。',
	  'in_lover': '作为你的另一半（或将来的另一半），她对你有比较高的期望值。因为在对方看来，你十分完美。你能在恰当的情境下做适宜的事，这种认真的态度很能赢得她的好感；而交往的时候也能侃侃而谈，有时也会像个小孩一样寻求对方的注意，和你在一起不会有太大压力。<br/><br/>你是一个非常有主见、肯思考的人，因此常常能把控关系的进展，能透过事物的表象分析问题，因而，在一些决策性的事情上你能给她一些中肯的意见。这在她看来，你很有内涵。“动静咸宜”的你，既能和她一起聊人生，又能和她一起打打闹闹。她能在你这里看到多方面的你，因而和你在一起的她无法预测你下一步的反应，容易让她对你保持好奇。<br/><br/>但是有一点需要注意，你的情绪可能会随外界而有比较大的起伏，有时候你会表现的情绪很高涨，任何事情在你眼中都可能变得很美好；有时你可能会走入死胡同，导致情绪低落甚至偏向抑郁。如果这时候的她能走进你的内心，知道你那矛盾性的背后所隐藏的真正需求，那这一定是你的真爱，还犹豫什么，娶了吧！',
	  'in_friends': '你的朋友说多不多，说少也不少。一方面你对交友有一套自己的底线或标准，对朋友的选择比较慎重。另一方面，你对陌生人比较友善，不排斥聊天说笑等等。作为你的朋友，Ta有时候难以捉摸你，因为你所表达出来的善意让Ta觉得你是一个很好相处的人，但是真正交往起来之后，会发现你会有很多标准和要求，这种内心的标准和要求有时候会把他人排斥在外。<br/><br/>但是如果表达方式恰当的话，你能让朋友感觉到你的善意，相信你的标准是客观性的，并没有太多的主观和情绪成分，那么你是一个很能督促对方进步的人。同时，在某些情境下，你其实也是一个能和对方狂侃海聊的人。事实上，对待朋友你很有牺牲精神，会忠实的站在朋友的角度上分析解决问题。因而，真正能和你成为好朋友的人，那就很有可能是一辈子的朋友了。',
	  'in_colleagues': '在你的同事眼中，你是一个“靠得住”的人。你对工作有自己的标准和要求，在细节上的处理优于其他人。对于你的领导来说，你是一个得力的手下干将，Ta会乐于交付你一些重要的事。而对于你的同事而言，你是一个他们乐于一起共事的人。事实上，在工作中你虽然有所要求，但你并没有强烈的竞争欲望，在工作之外，你也能和同事们相处良好。需要注意的是，你有时候思维比较跳脱，内敛和外放的风格切换有时会给人一些迷惑，摸不清楚你到底在想什么。',
	  'will_be': '作为轻微“洁癖”的家长，你会给你的孩子订立一些标准。例如，卫生要自己做好，不容许东西随处乱放，学习需要达到XX标准。但是，难道在孩子的眼中，你真的是一个严父吗？未必。你有活泼型的幽默风趣，这是你和孩子交流的有效润滑剂。你的内心保有孩童时的天真，你们之间可以存在跨越年龄的“友谊”。在你的孩子眼中，你有时候是个严苛的老师，有时候又是一个一起玩耍聊天的朋友。',
	  'advantage': '1)你是一个习惯思考的人，看待事情一般不会停留在表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何只要你想要去做的事情，你就希望把它做得尽善尽美。例如完美型的典型代表周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>3）内心比较热情，与人交往时你能活跃气氛，制造或参与话题，给人轻松愉悦的感觉；<br/><br/>4）你的衣品比较好，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你的衣品和得体着装的培养来源你良好的家庭教养。',
	  'shortcoming': '1）完美型和活泼型两种截然不同的性格需要在工作做事和人际相处时进行切换，如果你把工作中的完美主义带到生活中，或者把与人相处时的活泼性带到工作中，都会产生负面的影响；<br/><br/>2）对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。而活泼型的你又常常坐不住，所以事情常常会搁置不前；<br/><br/>3）完美型的你有时会钻牛角尖，做事情喜欢刨根问底，再加上活泼型的“多言”，对事情的过度关注会让你忽视他人的感情，因而容易成为不受人欢迎的人；<br/><br/>4）完美型和活泼型有一个共同的特点，就是情绪化。你的情绪很容易高涨，同时也容易低沉，在与人交往时容易让人对你产生距离，因为对方如果不是太了解你的话，很难摸清楚你的脾气；<br/><br/>5）你的记性有时候很差，活泼型的你经常丢三落四，找不见东西或者记不住名字是常有的事。',
	  'suggest': '1）学会将活泼型和完美型两种不同类型在工作学习或人际交往中完美切换，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当两种状态让你比较迷糊时，你可以通过洗个脸、深吸一口气等小技巧来进行自我调整；<br/><br/>2）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多；<br/><br/>3）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以看电视，进行其他活动等来转移注意力；<br/><br/>4）话少说一半。谈话减半，删除你还想说的另一个故事。当与人交谈时，关注沉闷的信号。当你发现别人开始逃离你的吸引力时，尽量压缩你的谈话内容；<br/><br/>5）与人交往时需要重点记忆对方的名字，因为注意力差的你通常很容易忘记。你可以随身带上你的记忆便签。记忆力差是一个劣势，即使你能合理的解释你为什么记忆力差，也没有人愿意听；<br/><br/>6）学会把他人的需求放在首位。不能把他人愿意成为你的听众而满足，要成为对方真正想要的朋友。',
	  'match_jobs': '体制内工作，讲究规则和秩序的类型，国企'
	}, { 'key': 'Ms',
	  'sex': 'female',
	  'animal': '耳廓狐',
	  'animal_en': 'Vulpeszerda',
	  'pic': '../static/funreports/erkuohu/animal.png',
	  'tags': '乐观的悲观主义者、口嫌体正直、绅士_淑女、注意形象、有魅力、吐槽担当、好奇、闷骚、规划性强',
	  'short_description': '耳廓狐具有强烈的守土护幼意识，会划定各自的领地。但在某些情况下，多个耳廓狐家庭可能生活在一起，共享同一个洞穴。喜欢秩序化的你也喜欢给自己划定“领地”，不喜欢自己的计划被人打乱。但这并不妨碍你和别人相处，必要时，你也能和他人合作得很好。',
	  'coordinate': '',
	  'basic_discription': '一般来说，你在工作或者事务上有一种完美型的要求，会留意到他人较少注意到的细节，对于工作所要达成的效果有自己的要求和标准。但是和典型的完美主义者不同，在工作之余，你乐于与他人交往和互动，与他人交往也比较热情。<br/><br/>如果你受工作的限制比较大，那么你常常给人一种严肃、有追求的印象。但如果环境适宜，你也能释放你的玩心和天性。最重要的是，当你在工作或学习中受到挫折时，你能够通过与他人良好的交往和互动来得到情绪上的疏解。',
	  'in_lover': '作为你的另一半（或将来的另一半），他对你有比较高的期望值。你能赢得对方的尊重，不是那种不懂事，只看表面的浮夸小女生。在对方看来，你十分完美。你能在恰当的情境下做适宜的事，这种认真的态度很能赢得他的好感；而交往的时候也能侃侃而谈，有时也会像个小孩一样寻求对方的注意，和你在一起不会有太大压力。<br/><br/>你是一个非常有主见、肯思考的人，因此常常能把控关系的进展，能透过事物的表象分析问题，在一些决策性的事情上你能提供一些中肯的意见。这在他看来，你很有内涵。“动静咸宜”的你，既能和他一起聊人生，又能和他一起打打闹闹。他能在你这里看到多方面的你，因而和你在一起的他无法预测你下一步的反应，容易让他对你保持好奇。<br/><br/>但是有一点需要注意，你的情绪可能会随外界而有比较大的起伏，有时候你会表现的情绪很高涨，任何事情在你眼中都可能变得很美好；有时你可能会走入死胡同，导致情绪低落甚至偏向抑郁。如果这时候的他能走进你的内心，知道你那矛盾性的背后所隐藏的真正需求，那这一定是你的真爱，还犹豫什么，嫁了吧！',
	  'in_friends': '你的朋友说多不多，说少也不少。一方面你对交友有一套自己的底线或标准，对朋友的选择比较慎重。另一方面，你对陌生人比较友善，不排斥聊天说笑等等。作为你的朋友，Ta有时候难以捉摸你，因为你所表达出来的善意让Ta觉得你是一个很好相处的人，但是真正交往起来之后，会发现你会有很多标准和要求，这种内心的标准和要求有时候会把他人排斥在外。<br/><br/>但是如果表达方式恰当的话，你能让朋友感觉到你的善意，相信你的标准是客观性的，并没有太多的主观和情绪成分，那么你是一个很能督促对方进步的人。同时，在某些情境下，你其实也是一个能和对方狂侃海聊的人。事实上，对待朋友你很有牺牲精神，会忠实的站在朋友的角度上分析解决问题。因而，真正能和你成为好朋友的人，那就很有可能是一辈子的朋友了。',
	  'in_colleagues': '在你的同事眼中，你是一个“靠得住”的人。你对工作有自己的标准和要求，在细节上的处理优于其他人。对于你的领导来说，你是一个得力的手下干将，Ta会乐于交付你一些重要的事。而对于你的同事而言，你是一个他们乐于一起共事的人。事实上，在工作中你虽然有所要求，但你并没有强烈的竞争欲望，在工作之外，你也能和同事们相处良好。需要注意的是，你有时候思维比较跳脱，内敛和外放的风格切换有时会给人一些迷惑，摸不清楚你到底在想什么。',
	  'will_be': '作为轻微“洁癖”的家长，你会给你的孩子订立一些标准。例如，卫生要自己做好，不容许东西随处乱放，学习需要达到XX标准。但是，难道在孩子的眼中，你真的是一个虎妈吗？未必。你有活泼型的幽默风趣，这是你和孩子交流的有效润滑剂。你的内心保有孩童时的天真，你们之间可以存在跨越年龄的“友谊”。在你的孩子眼中，你有时候是个严苛的老师，有时候又是一个一起玩耍聊天的朋友。',
	  'advantage': '1)你是一个习惯思考的人，看待事情一般不会停留在表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何只要你想要去做的事情，你就希望把它做得尽善尽美。例如完美型的典型代表周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>3）内心比较热情，与人交往时你能活跃气氛，制造或参与话题，给人轻松愉悦的感觉；<br/><br/>4）你的衣品比较好，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你的衣品和得体着装的培养来源你良好的家庭教养。',
	  'shortcoming': '1）完美型和活泼型两种截然不同的性格需要在工作做事和人际相处时进行切换，如果你把工作中的完美主义带到生活中，或者把与人相处时的活泼性带到工作中，都会产生负面的影响；<br/><br/>2）对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。而活泼型的你又常常坐不住，所以事情常常会搁置不前；<br/><br/>4）完美型的你有时会钻牛角尖，做事情喜欢刨根问底，再加上活泼型的“多言”，对事情的过度关注会让他人的感情，因而容易成为不受人欢迎的人；<br/><br/>4）完美型和活泼型有一个共同的特点，那就是情绪化。你的情绪很容易高涨，同时也容易低沉，在与人交往时容易让人对你产生距离，因为对方如果不是太了解你的话，很难摸清楚你的脾气；<br/><br/>5）你的记性有时候很差，活泼型的你经常丢三落四，找不见东西或者记不住名字是常有的事。',
	  'suggest': '1）学会将活泼型和完美型两种不同类型在工作学习或人际交往中完美切换，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当两种状态让你比较迷糊时，你可以通过洗个脸、深吸一口气等小技巧来进行自我调整；<br/><br/>2）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多；<br/><br/>3）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以看电视，进行其他活动等来转移注意力；<br/><br/>4）话少说一半。谈话减半，删除你还想说的另一个故事。当与人交谈时，关注沉闷的信号。当你发现别人开始逃离你的吸引力时，尽量压缩你的谈话内容；<br/><br/>5）与人交往时需要重点记忆对方的名字，因为注意力差的你通常很容易忘记。你可以随身带上你的记忆便签。记忆力差是一个劣势，即使你能合理的解释你为什么记忆力差，也没有人愿意听；<br/><br/>6）学会把他人的需求放在首位。不能把他人愿意成为你的听众而满足，要成为对方真正想要的朋友。',
	  'match_jobs': '体制内工作，讲究规则和秩序的类型，国企'
	}, { 'key': 'Mp',
	  'sex': 'male',
	  'animal': '海豚',
	  'animal_en': 'Delphinidae',
	  'pic': '../static/funreports/haitun/animal.png',
	  'tags': '理性派、含蓄内敛、面瘫、理想主义者、细节控、别人家的孩子、三思而后行、头脑冷静',
	  'short_description': '海豚是一种有思想，懂得三思而行的动物，它们对事物需要有强烈的控制感。与此同时，海豚为人所熟知的形象是和善而友好的，它们很少攻击他人，甚至会带领迷失的海员走出困境。而你也像海豚一样喜欢关注生活方方面面的细节，并且温和的你常常能得到他人的喜爱。',
	  'coordinate': '',
	  'basic_discription': '你做事情比较认真，会将问题看得很通透，但同时你并不愿意成为焦点人物。你一方面着重追求自己的标准，另一方面又乐于平稳，不激进也不过分追求。你的高标准与善于待人接物的性格相结合，让你很适合成为教育工作者。不过，过度要求完美的情况下，有时会让你在现实中碰壁，如果盲目采用“无谓”的方式来应对，可能让你对目标摇摆不定，从而对未来产生迷茫。',
	  'in_lover': '成为你的女朋友，应该是经历了某些标准的筛选，毕竟你对自己有着高标准的同时，只有对方对等了，才能入得了你的法眼。从侧面上来说，她是比较优秀的。<br/><br/>你有完美型的自我追求，对待工作或学习常常一丝不苟，你认真做起事情的样子让人非常着迷。同时，你一般不会有情绪上的歇斯底里，这种平和的性格能给彼此的爱情添上防护的外衣。通常恋爱关系中，你处于主导型的位置。<br/><br/>你有时会对对方提出各种要求，这源于你的秩序感和控制感。当关系出现问题时，你可能会通过冷处理的方式，给彼此一个思考的空间，但这种沉默是一种无奈之举。如果这时候她能主动认错，让你敞开心扉，说出心事，如果你能从她那边寻求到心灵上的支持和抚慰，那你们关系会进展平稳。',
	  'in_friends': '你是一个人际关系不错的人。在朋友的眼里，你是一个没什么负面评价的朋友，因为你从来不会在他人面前嚼舌根，并且你是一个不错的倾听者。在人际关系方面，你有一个最大的优点，是“无过”，很少树敌，这种中立又和平淡然的性格能赢得他人的亲近。但其实，你在心里也是“择人而交”，能走进你内心的朋友并不多，因为你有自己的选择标准。',
	  'in_colleagues': '在同事的眼中，你既可以做对工作宏观把控的领导角色，也可以做关注细节，努力配合他人的“拧螺丝”角色。因为完美型要求的你有目标，肯追求，同时和平处事的风格又能让你赢得下属的好感。同事眼中，你比较尊重他人，你从不会在工作中乱嚼舌根，也不会肆意插手他人的事情。你在工作中状态比较平稳，但有时候这只是表象，有时候事物不像你想象中那样发展时，你也会感觉不太良好，只是习惯藏在心里，在表面上云淡风轻罢了。',
	  'will_be': '作为有完美追求的家长，你是希望自己家中能够像工作中那样干净整洁，一切都井然有序的。因而你会给你的孩子适当订立某些标准。例如，家规晚上回家不能超过12点，自己的东西要摆放好之类的。但是，当你的孩子打破了你的规则时，你会心平气和的和Ta说，除非是碰到了你教育的底线，否则你不会对孩子大发雷霆。作为家长，你并没有要求绝对的权威，在孩子眼中，你是一个比较开明的家长。',
	  'advantage': '1)你是一个习惯思考的人，看待事情一般不会停留在表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)对待工作和其他事物你比较有主见，处理事情条理比较清晰，对做事情有自己的标准，容易督促事情向好的方面发展；<br/><br/>3)你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何只要你想要去做的事情，你就希望把它做的尽善尽美。例如完美型的典型代表周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4)你的衣品比较好，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你的衣品和得体着装的培养来源你良好的家庭教养；<br/><br/>5)你懂得与人相处，和平型的淡然处事能为你赢得很多朋友的好感。',
	  'shortcoming': '1）具有完美型追求的你有时候会情绪忧郁，有悲观倾向。因为追求高标准的你可能在现实中难以得到满足，这种挫败传达到你对自我的认知中，有时会导致情绪抑郁和低落；<br/><br/>2）完美型的你如果是因“达不到”而被迫性的“放弃”，则可能会积压一些内心的真实情感，如果没有有效的排解，则可能会不定时出现抑郁，情绪低落等症状；<br/><br/>3）和平型的你喜欢生活的平稳，不太喜欢接受新鲜的事物，不喜欢生活中出现太多变动和改变；<br/><br/>4）完美型对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。',
	  'suggest': '1）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以看电视，进行其他活动等来转移注意力；<br/><br/>2）尝试新鲜事物。和平型的你通常喜欢安于现状，拒绝生活的变动。你可以尝试新鲜事物，或许可以发现更多精彩。多参加兴趣小组，接受新的东西是不错的选择；<br/><br/>3）工作中培养锐意进取的心态。有时候虽然你有完美型的计划和目标性，但遇到挫折时你可能会走向放弃的平和性，虽然这能让你在情绪和心态上得到疏解，但有时可能再加上一点点行进的动力，不会更容易达到成功。',
	  'match_jobs': '教育家，老师，培训师，行政工作者'
	}, { 'key': 'Mp',
	  'sex': 'female',
	  'animal': '海豚',
	  'animal_en': 'Delphinidae',
	  'pic': '../static/funreports/haitun/animal.png',
	  'tags': '理性派、含蓄内敛、面瘫、理想主义者、细节控、别人家的孩子、三思而后行、头脑冷静',
	  'short_description': '海豚是一种有思想，懂得三思而行的动物，它们对事物需要有强烈的控制感。与此同时，海豚为人所熟知的形象是和善而友好的，它们很少攻击他人，甚至会带领迷失的海员走出困境。而你也像海豚一样喜欢关注生活方方面面的细节，并且温和的你常常能得到他人的喜爱。',
	  'coordinate': '',
	  'basic_discription': '你做事情比较认真，会将问题看得很通透，但同时你并不愿意成为焦点人物。你一方面着重追求自己的标准，另一方面又乐于平稳，不激进也不过分追求。你的高标准与善于待人接物的性格相结合，让你很适合成为教育工作者。不过，过度要求完美的情况下，有时会让你在现实中碰壁，如果盲目采用“无谓”的方式来应对，可能让你对目标摇摆不定，从而对未来产生迷茫。',
	  'in_lover': '成为你的男朋友，应该是经历了某些标准的筛选，毕竟你对自己有着高标准的同时，只有对方对等了，才能入得了你的法眼。从侧面上来说，他是比较优秀的。<br/><br/>你有完美型的自我追求，对待工作或学习常常一丝不苟，你认真做起事情的样子让人非常欣赏。同时，你一般不会有情绪上的歇斯底里，这种平和的性格能给彼此的爱情添上防护的外衣。通常恋爱关系中，你处于主导型的位置。<br/><br/>你有时会对对方提出各种要求，这源于你的秩序感和控制感。当关系出现问题时，你可能会通过冷处理的方式，给彼此一个思考的空间，但这种沉默是一种无奈之举。如果这时候她能主动认错，让你敞开心扉，说出心事，如果你能从他那边寻求到心灵上的支持和抚慰，那你们关系会进展平稳。',
	  'in_friends': '你是一个人际关系不错的人。在朋友的眼里，你是一个没什么负面评价的朋友，因为你从来不会在他人面前嚼舌根，并且你是一个不错的倾听者。在人际关系方面，你有一个最大的优点，是“无过”，很少树敌，这种中立又和平淡然的性格能赢得他人的亲近。但其实，你在心里也是“择人而交”，能走进你内心的朋友并不多，因为你有自己的选择标准。',
	  'in_colleagues': '在同事的眼中，你既可以做对工作宏观把控的领导角色，也可以做关注细节，努力配合他人的“拧螺丝”角色。因为完美型要求的你有目标，肯追求，同时和平处事的风格又能让你赢得下属的好感。同事眼中，你比较尊重他人，你从不会在工作中乱嚼舌根，也不会肆意插手他人的事情。你在工作中状态比较平稳，但有时候这只是表象，有时候事物不像你想象中那样发展时，你也会感觉不太良好，只是习惯藏在心里，在表面上云淡风轻罢了。',
	  'will_be': '作为有完美追求的家长，你是希望自己家中能够像工作中那样干净整洁，一切都井然有序的。因而你会给你的孩子适当订立某些标准。例如，家规晚上回家不能超过12点，自己的东西要摆放好之类的。但是，当你的孩子打破了你的规则时，你会心平气和的和Ta说，除非是碰到了你教育的底线，否则你不会对孩子大发雷霆。作为家长，你并没有要求绝对的权威，在孩子眼中，你是一个比较开明的家长。',
	  'advantage': '1)你是一个习惯思考的人，看待事情一般不会停留在表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)对待工作和其他事物你比较有主见，处理事情条理比较清晰，对做事情有自己的标准，容易督促事情向好的方面发展；<br/><br/>3)你肯钻研，对自己要求严格，擅长思考。在你看来，没有无意义的工作。任何只要你想要去做的事情，你就希望把它做得尽善尽美。例如完美型的典型代表周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4)你的衣品比较好，着装整洁而恰当，给人一种自然得体的感觉。从更深层次上看，你的衣品和得体着装的培养来源你良好的家庭教养；<br/><br/>5)你懂得与人相处，和平型的淡然处事能为你赢得很多朋友的好感。',
	  'shortcoming': '1）具有完美型追求的你有时候会情绪忧郁，有悲观倾向。因为追求高标准的你可能在现实中难以得到满足，这种挫败传达到你对自我的认知中，有时会导致情绪抑郁和低落；<br/><br/>2）完美型的你如果是因“达不到”而被迫性的“放弃”，则可能会积压一些内心的真实情感，如果没有有效的排解，则可能会不定时出现抑郁，情绪低落等症状；<br/><br/>3）和平型的你喜欢生活的平稳，不太喜欢接受新鲜的事物，不喜欢生活中出现太多变动和改变；<br/><br/>4）完美型对细节的过度在意会让你有时候工作上停滞不前。有时候要完成一项工作会花费你很长一段时间，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。',
	  'suggest': '1）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以看电视，进行其他活动等来转移注意力；<br/><br/>2）尝试新鲜事物。和平型的你通常喜欢安于现状，拒绝生活的变动。你可以尝试新鲜事物，或许可以发现更多精彩。多参加兴趣小组，接受新的东西是不错的选择；<br/><br/>3）工作中培养锐意进取的心态。有时候虽然你有完美型的计划和目标性，但遇到挫折时你可能会走向放弃的平和性，虽然这能让你在情绪和心态上得到疏解，但有时可能再加上一点点行进的动力，不会更容易达到成功。',
	  'match_jobs': '教育家，老师，培训师，行政工作者'
	}, { 'key': 'C',
	  'sex': 'male',
	  'animal': '虎',
	  'animal_en': 'Pantheratigris',
	  'pic': '../static/funreports/hu/animal.png',
	  'tags': '控制欲、灵魂人物、大冒险家、霸道总裁、kingoftheworld、总攻、先天性耐心缺陷、坦率直接',
	  'short_description': '老虎喜欢单独活动，领地意识十分强烈，一旦发现入侵，会采取严厉的捍卫行动。无论在捕猎还是领土保卫上，老虎都贯彻着雷厉风行的作风，是当之无愧的森林之王。而属于老虎性格的你，有着过人的领导才能，常常能统筹大局，表现出一种王者风范。',
	  'coordinate': '',
	  'basic_discription': '你有非常显著的外向性，行动力强，个性乐观。你具有很强的力量主导身边的人和事，因而，无论在何种的场合中，你总是很容易成为领导者。工作中的你充满自信，立场坚定，在有意见冲突时常常坚守阵地，直到对方同意自己的观点，因而力量型的你有很强的决策力，懂得用最短的时间解决实际的问题，能迅速作出决策。<br/><br/>在与人相处方面，你为人很直率，通常说一不二，很容易成为社交场合上的焦点人物。但是你的领导能力有时在他人看来像是颐指气使，支配感强的你可能会引起一些人的反感，如果能够通过一种更为柔和的形式将你的力量性体现出来可能更好。',
	  'in_lover': '在她眼中，你比较有主见，常常承诺的事情能够做到，感情中说一不二，很少不负责任地给予她承诺。你有天生的领导和支配能力，能主导爱情关系的发展走向，她一般不需要面对爱情的问题。感情中你充满活力，积极主动，能活跃彼此的关系。<br/><br/>但是，需要注意的是，你在感情中容易为一些琐碎的事情惹怒，不太有耐心，会动不动向对方发脾气，没有了工作中果断和干练，常常会被爱情折磨得束手无策。脾气暴躁的你，需要学会管理自己的情绪，选择一种更温和的方式表达出来，适当的时候向对方认错道歉，这样才能有效地维系两个人关系的长久。',
	  'in_friends': '在他人看来，力量型的你似乎不大需要朋友，因为你的注意力永远在工作中，很少关注到身边人的需求。在你的朋友看来，你说话直来直往，有时候是会让人不舒服，但了解你的人都知道，这是你的风格，你并没有恶意。与此同时，你总是从整体和大局出发，很少因为关系而徇私。但是，与人交往时你常常喜欢争辩自己的正确性，有时会伤害他人的感情。',
	  'in_colleagues': '同事眼中的你，简直是个工作狂魔。你有很多优点，能让你在工作中发光发亮。首先，你的组织力很强，而且擅长给不同的人分配不同的工作，有较好的领导能力，常常能带领团队把事情做好。其次，你有很强的目标性，很少做无用的工作。再者，你抗压性良好，外部环境的恶劣能让你越挫越勇，遇到工作问题时，你会努力寻求实际问题的解决方法。总之，你的工作能力很强。但同时，你情绪容易暴躁，对待同事不够耐心，有时给人冷酷无情的感觉。',
	  'will_be': '在孩子眼中，你是无所不能的父亲。你能把工作中的细心和组织能力有效地应用在家庭管理中。你能把家庭管理地井井有条，有明确的家规，良好的秩序性。但同时，你如果不自觉把工作中的领导风格带到家庭中的话，你常会因为经常使用命令式的语气而让你的孩子有叛逆心理。你可以试着对孩子多一些耐心，尊重孩子的自尊心，用平等的语气与孩子进行交流，时不时鼓励和赞扬你的孩子，这些对于孩子的教育以及与孩子关系的处理方面有很大作用。',
	  'advantage': '1）你是强势的领导者。不论在何种场合中，力量型的你都很能赢得他人的注视和焦点，特别是当大家没有注意，乱做一团的时候，你更能显示出自己的领导风范；<br/><br/>2）永远精力旺盛。你好像总有用不完的精力和力量，当身边的人感到力不从心时，你依然充满活力，斗志昂扬；<br/><br/>3）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>4）你的行动力十分强。想到什么就会即刻就做，很少拖泥带水。',
	  'shortcoming': '1）力量型的你工作起来有时候六亲不认，工作的时候任何人都无法转移他们的注意力，有时会忽略亲密他人的感受；<br/><br/>2）力量型的你控制欲望强烈，总想着掌控全局，而且常常固执地认为自己是对的，有时给人一种专横霸道的感觉；<br/><br/>3）力量型的你在人际交往中可能也会带有工作上的理性、强硬的沟通方式，不太懂得变通，使得周围的人不太愿意和你沟通；<br/><br/>4）力量型的你不懂得给自己放松和减压，患心脏病的风险比较高。',
	  'suggest': '1）适当转换视角，从他人的观点中取合理性。力量型的你有时候就是没有错先生，因为你总是能对“不是我的缺点，错在他人”做出合理的解释。适当转换视角，也许你也能看到不一样的东西；<br/><br/>2）学会自我减压和放松。力量型的你热衷于工作或学习，这会让你忽视自己的真实需要，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>3）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>4）保留自己的观点。力量型的你有时很没耐心，总喜欢对他人的行为给以主观的评价。当你意识到自己有这方面倾向时，保留自己的观点，选择低调的方式处理。',
	  'match_jobs': '领导者，支配者，管理，谈判，总监，创业'
	}, { 'key': 'C',
	  'sex': 'female',
	  'animal': '虎',
	  'animal_en': 'Pantheratigris',
	  'pic': '../static/funreports/hu/animal.png',
	  'tags': '控制欲、灵魂人物、大冒险家、霸道总裁、kingoftheworld、总攻、先天性耐心缺陷、坦率直接',
	  'short_description': '老虎喜欢单独活动，领地意识十分强烈，一旦发现入侵，会采取严厉的捍卫行动。无论在捕猎还是领土保卫上，老虎都贯彻着雷厉风行的作风，是当之无愧的森林之王。而属于老虎性格的你，有着过人的领导才能，常常能统筹大局，表现出一种王者风范。',
	  'coordinate': '',
	  'basic_discription': '你有非常显著的外向性，行动力强，个性乐观。你具有很强的力量主导身边的人和事，因而，无论在何种的场合中，你总是很容易成为领导者。工作中的你充满自信，立场坚定，在有意见冲突时常常坚守阵地，直到对方同意自己的观点，因而力量型的你有很强的决策力，懂得用最短的时间解决实际的问题，能迅速作出决策。<br/><br/>在与人相处方面，你为人很直率，通常说一不二，很容易成为社交场合上的焦点人物。但是你的领导能力有时在他人看来像是颐指气使，支配感强的你可能会引起一些人的反感，如果能够通过一种更为柔和的形式将你的力量性体现出来可能更好。',
	  'in_lover': '在他的眼中，你比较有主见，并不会像大多数女生一样，只依赖于男朋友。感情中你比较成熟，常常说什么就是什么，很少跟他算计或耍心眼。虽然你是女生，但你天生的领导和支配能力能让你获得爱情的主导权，多数情况下，都是他跟着你的思路走。积极主动而充满动力的你，通常能给爱情带来很多活力。<br/><br/>但是，需要注意的是，你在感情中容易为一些琐碎的事情惹怒，不太有耐心，会动不动向对方发脾气，没有了工作中果断和干练，常常会被爱情折磨得束手无策。脾气暴躁的你，需要学会管理自己的情绪，选择一种更温和的方式表达出来，适当的时候向对方认错道歉，这样才能有效地维系两个人关系的长久。',
	  'in_friends': '在他人看来，力量型的你似乎不大需要朋友，因为你的注意力永远在工作中，很少关注到身边人的需求。在你的朋友看来，你说话直来直往，有时候是会让人不舒服，但了解你的人都知道，这是你的风格，你并没有恶意。与此同时，你总是从整体和大局出发，很少因为关系而徇私。但是，与人交往时你常常喜欢争辩自己的正确性，有时会伤害他人的感情。',
	  'in_colleagues': '同事眼中的你，简直是个工作狂魔。你有很多优点，能让你在工作中发光发亮。首先，你的组织力很强，而且擅长给不同的人分配不同的工作，有较好的领导能力，常常能带领团队把事情做好。其次，你有很强的目标性，很少做无用的工作。再者，你抗压性良好，外部环境的恶劣能让你越挫越勇，遇到工作问题时，你会努力寻求实际问题的解决方法。总之，你的工作能力很强。但同时，你情绪容易暴躁，对待同事不够耐心，有时给人冷酷无情的感觉。',
	  'will_be': '在孩子眼中，你是无所不能的母亲。你能把工作中的细心和组织能力有效地应用在家庭管理中。你能把家庭管理地井井有条，有明确的家规，良好的秩序性。但同时，你如果不自觉把工作中的领导风格带到家庭中的话，你常会因为经常使用命令式的语气而让你的孩子有叛逆心理。你可以试着对孩子多一些耐心，尊重孩子的自尊心，用平等的语气与孩子进行交流，时不时鼓励和赞扬你的孩子，这些对于孩子的教育以及与孩子关系的处理方面有很大作用。',
	  'advantage': '1）你是强势的领导者。不论在何种场合中，力量型的你都很能赢得他人的注视和焦点，特别是当大家没有注意，乱做一团的时候，你更能显示出自己的领导风范；<br/><br/>2）永远精力旺盛。你好像总有用不完的精力和力量，当身边的人感到力不从心时，你依然充满活力，斗志昂扬；<br/><br/>3）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>4）你的行动力十分强。想到什么就会即刻就做，很少拖泥带水。',
	  'shortcoming': '1）力量型的你工作起来有时候六亲不认，工作的时候任何人都无法转移他们的注意力，有时会忽略亲密他人的感受；<br/><br/>2）力量型的你控制欲望强烈，总想着掌控全局，而且常常固执地认为自己是对的，有时给人一种专横霸道的感觉；<br/><br/>3）力量型的你在人际交往中可能也会带有工作上的理性、强硬的沟通方式，不太懂得变通，使得周围的人不太愿意和你沟通；<br/><br/>4）力量型的你不懂得给自己放松和减压，患心脏病的风险比较高。',
	  'suggest': '1）适当转换视角，从他人的观点中取合理性。力量型的你有时候就是没有错先生，因为你总是能对“不是我的缺点，错在他人”做出合理的解释。适当转换视角，也许你也能看到不一样的东西；<br/><br/>2）学会自我减压和放松。力量型的你热衷于工作或学习，这会让你忽视自己的真实需要，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>3）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>4）保留自己的观点。力量型的你有时很没耐心，总喜欢对他人的行为给以主观的评价。当你意识到自己有这方面倾向时，保留自己的观点，选择低调的方式处理。',
	  'match_jobs': '领导者，支配者，管理，谈判，总监，创业'
	}, { 'key': 'Cs',
	  'sex': 'male',
	  'animal': '棕熊',
	  'animal_en': 'Ursusarctos',
	  'pic': '../static/funreports/zongxiong/animal.png',
	  'tags': '黑色幽默、行动派、先天性耐心缺陷、有bear来、主动进取型、不会读空气、目标追击者、弄潮儿',
	  'short_description': '棕熊实际上是一种凶猛的食肉动物，一旦认准目标就会即刻行动，所以主动出击型的你和棕熊性格最为相似。同时，棕熊在影视作品中常常以可爱的形象出现（如果你听说过小熊维尼的话），而你在生活中则是一个有主见有胆识的人，常能凭此赢得他人的好感。',
	  'coordinate': '',
	  'basic_discription': '你是一个典型的工作狂，具有很强的力量主导身边的人和事，因而，无论在何种的场合中，你总是很容易成为领导者。而活泼型的你能弥补力量型在人际关系上的忽视，因而能调动和指挥他人使其乐于工作。你的领导艺术体现在，能够通过一种温和而亲切的方式感染和号召他人。<br/><br/>在人际相处方面，你给人一种有决断力，踏实稳重的感觉，但做事情有时比较马虎，不太关注和在意细节，会给工作造成一些细微影响。',
	  'in_lover': '在感情中，你通常都是一段关系中的主导者。你有天生的领导和支配能力，能主导爱情关系的发展走向，她一般不需要面对爱情的问题，只需跟着你的步调生活就好。同时，你也会偶尔制造浪漫，用你活泼型的天马行空的想象，为对方制造一些惊喜。性格外倾的你，能和她有很多话题可以聊，一般不会掩饰自己的真实情绪。<br/><br/>但是，需要注意的是，力量型的你在感情中容易为一些琐碎的事情惹怒，不太有耐心，会动不动向对方发脾气，没有了工作中果断和干练，常常会被爱情折磨的束手无策。脾气暴躁的你，需要学会管理自己的情绪，选择一种更温和的方式表达出来，适当的时候向对方认错道歉，这样才能有效地维系两个人关系的长久。',
	  'in_friends': '目标性较强的你，会让很多人一开始和你保持距离。但是相处下来之后，很多人会被你有趣的性格所吸引。你虽然有掌控欲，但同时也具有活泼型的热情和主动，更多时候，这种掌控欲会以一种“润物细无声”的温和方式表现出来，因而不至于让人反感。<br/><br/>再深入交往时，朋友还会发现不仅能和你侃侃交流，而且你真诚直率，公正而不徇私，给人一种踏实稳重的感觉，这能让你赢得一些真正的朋友。但有一点你可能需要注意，外向而善于言谈的你，有时会忽略朋友的情感需求，而把关注点只放在自己身上。这容易给他人留下自私的印象。学会为他人考虑能让你成为一个更好的朋友。',
	  'in_colleagues': '在同事的眼中，你是一个做事雷厉风行，即说即做的行动者。你一般不会患有拖延症，这是让你的同事非常欣赏你的地方。你懂得该做事的时候就立马去做，有优秀的领导力和执行力，这可能与你的高自我控制有关。同时，你的组织能力很强，擅长给不同的人分配不同的工作，善于挖掘不同的人他们的优点。<br/><br/>但你并不是单纯的工作狂，该玩的时候，你也会表现出热情的一面，而这些特点正是你吸引他人，给他人带来好感的一个重要因素。你在做事注重实际行动和工作效率的同时，还能通过天马行空的想象，给工作带来更多的乐趣。值得注意的是，执着于工作的你，有时与他人交往时会表现出情绪易暴躁，不够耐心，有时给人冷酷无情的感觉。',
	  'will_be': '在孩子眼中，你既是标准严明的父亲，偶尔也是可以敞开心扉交流的朋友。你对孩子有明确的要求，会发挥出自己身为家长的权威，支配和控制你的孩子并教导Ta学好。同时，你内心还保留着孩子的童真，偶尔表现出的这一面让你能和自己的孩子打成一片，被孩子们所喜爱。<br/><br/>事实上，你与孩子打成一片的方式也是能让你更好的管理和教育孩子。你一方面保持和孩子的亲密交往，另一方面更注重行使命令的主权，双管齐下，通过你组织和管理的能力把家里打理得井井有条。需要注意的事，有时候你对孩子过度的控制欲会让孩子产生心理上的叛逆，从而拉开你们的心理距离。',
	  'advantage': '1）你有很强的领导能力。力量型的“一工作就废寝忘食”的特点与活泼型的感染和带动能力结合，让你在同事之间有很强的号召能力；<br/><br/>2）你很主动，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>3）你的沟通能力较强，不论是为人还是处事都比较灵活，与人相处时一般不会给人压力；<br/><br/>4）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃。',
	  'shortcoming': '1）力量型的你工作起来有时候六亲不认，工作的时候他人比较难转移你的注意力，有时会忽略生活中的美好；<br/><br/>2）力量型的你控制欲望强烈，虽然活泼的性格特征能比较缓和这一特点，但如果表达方式不够温和委婉的话，仍然会给人留下比较霸道的印象；<br/><br/>3）力量型和活泼型两者都表现出性格外倾的特点，大部分时候追求表达，对自我太过的关注导致你容易忽视他人的感受；<br/><br/>4）脾气暴躁，遇到不顺的事情容易生气，缺乏平和的内心。',
	  'suggest': '1）教育孩子时，适当关注孩子内心的想法，多听一听孩子的心声，而不是一味地表现你的支配和控制欲，有助于孩子的成长；<br/><br/>2）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>3）学会自我减压和放松。力量型一旦陷入工作很可能成为“工作狂”，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>4）保留自己的观点。力量型的你有时很没耐心，或活泼型的叽叽喳喳让你喜欢对他人的行为给以主观的评价。当你意识到自己有这方面倾向时，保留自己的观点，选择低调的方式处理。',
	  'match_jobs': '领导者，经理，项目组长'
	}, { 'key': 'Cs',
	  'sex': 'female',
	  'animal': '棕熊',
	  'animal_en': 'Ursusarctos',
	  'pic': '../static/funreports/zongxiong/animal.png',
	  'tags': '黑色幽默、行动派、先天性耐心缺陷、有bear来、主动进取型、不会读空气、目标追击者、弄潮儿',
	  'short_description': '棕熊实际上是一种凶猛的食肉动物，一旦认准目标就会即刻行动，所以主动出击型的你和棕熊性格最为相似。同时，棕熊在影视作品中常常以可爱的形象出现（如果你听说过小熊维尼的话），而你在生活中则是一个有主见有胆识的人，常能凭此赢得他人的好感。',
	  'coordinate': '',
	  'basic_discription': '你是一个典型的工作狂，具有很强的力量主导身边的人和事，因而，无论在何种的场合中，你总是很容易成为领导者。而活泼型的你能弥补力量型在人际关系上的忽视，因而能调动和指挥他人使其乐于工作。你的领导艺术体现在，能够通过一种温和而亲切的方式感染和号召他人。<br/><br/>在人际相处方面，你给人一种有决断力，踏实稳重的感觉，但做事情有时比较马虎，不太关注和在意细节，会给工作造成一些细微影响。',
	  'in_lover': '在感情中，你通常都是一段关系中的主导者。你有天生的领导和支配能力，能主导爱情关系的发展走向，他常常会被你的节奏带走。同时，你也喜欢浪漫，常会用你活泼型的天马行空的想象，为对方制造一些惊喜。性格外倾的你，能和他有很多话题可以聊，一般不会掩饰自己的真实情绪。<br/><br/>但是，需要注意的是，力量型的你在感情中容易为一些琐碎的事情惹怒，不太有耐心，会动不动向对方发脾气，没有了工作中果断和干练，常常会被爱情折磨的束手无策。脾气暴躁的你，需要学会管理自己的情绪，选择一种更温和的方式表达出来，适当的时候向对方认错道歉，这样才能有效地维系两个人关系的长久。',
	  'in_friends': '目标性较强的你，会让很多人一开始和你保持距离。但是相处下来之后，很多人会被你有趣的性格所吸引。你虽然有掌控欲，但同时也具有活泼型的热情和主动，更多时候，这种掌控欲会以一种“润物细无声”的温和方式表现出来，因而不至于让人反感。<br/><br/>再深入交往时，朋友还会发现不仅能和你侃侃交流，而且你真诚，直率，公正而不徇私，给人一种踏实稳重的感觉，这能让你赢得一些真正的朋友。但有一点你可能需要注意，外向而善于言谈的你，有时会忽略朋友的情感需求，而把关注点只放在自己身上。这容易给他人留下自私的印象。学会为他人考虑能让你成为一个更好的朋友。',
	  'in_colleagues': '在同事的眼中，你是一个做事雷厉风行，即说即做的行动者。你一般不会患有拖延症，这是让你的同事非常欣赏你的地方。你懂得该做事的时候就立马去做，有优秀的领导力和执行力，这可能与你的高自我控制有关。同时，你的组织能力很强，擅长给不同的人分配不同的工作，善于挖掘不同的人他们的优点。<br/><br/>但你并不是单纯的工作狂，该玩的时候，你也会表现出热情的一面，而这些特点正是你吸引他人，给他人带来好感的一个重要因素。你在做事注重实际行动和工作效率的同时，还能通过天马行空的想象，给工作带来更多的乐趣。值得注意的是，执着于工作的你，有时与他人交往时会表现出情绪易暴躁，不够耐心，有时给人冷酷无情的感觉。',
	  'will_be': '在孩子眼中，你既是要求严格的妈妈，偶尔也是可以敞开心扉交流的朋友。你对孩子有明确的要求，会发挥出自己身为家长的权威，支配和控制你的孩子并教导Ta学好。同时，你内心还保留着孩子的童真，偶尔表现出的这一面让你能和自己的孩子打成一片，被孩子们所喜爱。<br/><br/>事实上，你与孩子打成一片的方式也是能让你更好的管理和教育孩子。你一方面保持和孩子的亲密交往，另一方面更注重行使命令的主权，双管齐下，通过你组织和管理的能力把家里打理得井井有条。需要注意的事，有时候你对孩子过度的控制欲会让孩子产生心理上的叛逆，从而拉开你们的心理距离。',
	  'advantage': '1）你有很强的领导能力。力量型的“一工作就废寝忘食”的特点与活泼型的感染和带动能力结合，让你在同事之间有很强的号召能力；<br/><br/>2）你很主动，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>3）你的沟通能力较强，不论是为人还是处事都比较灵活，与人相处时一般不会给人压力；<br/><br/>4）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃。',
	  'shortcoming': '1）力量型的你工作起来有时候六亲不认，工作的时候他人比较难转移你的注意力，有时会忽略生活中的美好；<br/><br/>2）力量型的你控制欲望强烈，虽然活泼的性格特征能比较缓和这一特点，但如果表达方式不够温和委婉的话，仍然会给人留下比较霸道的印象；<br/><br/>3）力量型和活泼型两者都表现出性格外倾的特点，大部分时候追求表达，对自我太过的关注导致你容易忽视他人的感受。<br/><br/>4）脾气暴躁，遇到不顺的事情容易生气，缺乏平和的内心。',
	  'suggest': '1）教育孩子时，适当关注孩子内心的想法，多听一听孩子的心声，而不是一味地表现你的支配和控制欲，有助于孩子的成长；<br/><br/>2）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>3）学会自我减压和放松。力量型一旦陷入工作很可能成为“工作狂”，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>4）保留自己的观点。力量型的你有时很没耐心，或活泼型的叽叽喳喳让你喜欢对他人的行为给以主观的评价。当你意识到自己有这方面倾向时，保留自己的观点，选择低调的方式处理。',
	  'match_jobs': '领导者，经理，项目组长'
	}, { 'key': 'Cm',
	  'sex': 'male',
	  'animal': '猞猁',
	  'animal_en': 'Felislynx',
	  'pic': '../static/funreports/sheli/animal.png',
	  'tags': '控制狂、商业奇才、有气场、心机boy_girl、霸道总裁、坚持不懈、有追求、战斗力强、沉迷工作不能自拔',
	  'short_description': '猞猁（shēlì）习惯离群独居，活跃在广阔的空间里。为了提高捕猎的成功率，它们可以在一个地方蛰居几天不动，或者是连续奔跑十几千米不停不歇。与此同时，猞猁警惕性很高，因而常常能躲过敌人的伤害。以上这些特点都和独立谨慎且自制的你非常相像。',
	  'coordinate': '',
	  'basic_discription': '你是优秀的商业人才，是工作主导的类型。将力量型的领导才能和完美型的敏感聪慧结合起来，会让你所向无敌。你不会停止在对完美型的不断要求和标准设定的想象中，更多会即刻行动以达成你的目的和标准。因而，在工作或学习中，你有较强的执行力和毅力，努力获得更好的效果。但需要注意的是，工作主导的你，对于工作的过度关注会让你比较忽视与身边人的关系。',
	  'in_lover': '在她的眼中，你霸道而强势，在你们之间的关系中，你通常是主导的角色，一般掌握关系的决定权。你有完美主义的标准和要求，这样来看，满足你要求的她本身比较优秀。而对于你自身来说，你是一个内心情感较丰富的人，这种情感比较少外化出来，但你会选择无声无息地给她准备惊喜。在她看来，你们的爱情充满了浪漫的气息。需要明确的是，你有果断勇敢的一面，一旦感情生变，你会决绝的分开。',
	  'in_friends': '在他人看来，要成为你的朋友似乎很难。气场强大的你，生活大部分都是围绕着工作和学习，因而想要赢得你的欣赏和关注，可能需要有较强的工作或学习能力，或者在其他方面有一技之长。其实在他人看来，你似乎不太需要朋友，因为你能从工作或其他事物中找到很多乐趣。<br/><br/>不过在你的内心中，还是渴望有朋友的支持和关注，只是你谨小慎微的性格导致了你交友慎重，要求你的朋友忠诚可靠，这样你才愿意付出你的真心。当和朋友产生争论时，你大多数会坚持自己的看法。但你为了朋友会甘心听他的牢骚，为ta解决实际问题。',
	  'in_colleagues': '在同事的眼中，你有非常优秀的领导才能。工作上，你是目标主导倾向，有统领全局的能力，非常有主见。同时，你善于做工作计划并分配工作，以便让每个人都“有事可做”，善于挖掘不同的人的优点。<br/><br/>在进行工作的过程中，你还能比较细心关注工作的各方面，力求达到满意的效果，即便工作中遇到了挫折和困难，你也敢于面对并寻找解决的具体办法。只是需要注意的是，你将大部分注意力都只关注在对工作等客观事物上，较少关注身边人的需求。因而，你在同事中几乎找不到可以交心的朋友。',
	  'will_be': '作为父母，你不容许自己的家里乱糟糟的。你的组织和管理能力同样能把家里打造得井井有条。你注重你的家长权威性，对子女常使用命令式的语气，但同时你非常具有牺牲精神，虽然表明你会指责你的孩子乱糟糟的，但你还是会不断地为ta操心操力。',
	  'advantage': '1）你有很强的领导能力。力量型的“一工作就废寝忘食”的特点与活泼型的感染能力结合，让你在同事之间有很强的号召能力；<br/><br/>2）你很主动，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>3）你果断、有条理、目标明确，这种类型的你一般有强烈的欲望和决心，当朝着正确的方向进发时，力量型/完美型的你总是最容易成功；<br/><br/>4）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃。',
	  'shortcoming': '1）你工作起来有时候六亲不认，工作的时候他人比较难转移你的注意力，有时会忽略生活中的美好；<br/><br/>2）你的控制欲望比较强烈，目标导向的你希望对事情有绝对的把控力，很有可能带到与人的交往中，容易给人留下比较霸道的印象；<br/><br/>3）在人际交往中你可能也会带有工作上的理性、强硬的沟通方式，不太懂得变通，使得周围的人不太愿意和你沟通；<br/><br/>4）力量型的你不懂得给自己放松和减压，患心脏病的风险比较高。',
	  'suggest': '1）学会放松，减轻对别人的压力：追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让我们周围的人产生可怕的压力；<br/><br/>2）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多。<br/><br/>3）降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和他人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准。',
	  'match_jobs': '做规划和决策性的领导职位，政治家，运动员，宣传员'
	}, { 'key': 'Cm',
	  'sex': 'female',
	  'animal': '猞猁',
	  'animal_en': 'Felislynx',
	  'pic': '../static/funreports/sheli/animal.png',
	  'tags': '控制狂、商业奇才、有气场、心机boy_girl、霸道总裁、坚持不懈、有追求、战斗力强、沉迷工作不能自拔',
	  'short_description': '猞猁（shēlì）习惯离群独居，活跃在广阔的空间里。为了提高捕猎的成功率，它们可以在一个地方蛰居几天不动，或者是连续奔跑十几千米不停不歇。与此同时，猞猁警惕性很高，因而常常能躲过敌人的伤害。以上这些特点都和独立谨慎且自制的你非常相像。',
	  'coordinate': '',
	  'basic_discription': '你是优秀的商业人才，是工作主导的类型。将力量型的领导才能和完美型的敏感聪慧结合起来，会让你所向无敌。你不会停止在对完美型的不断要求和标准设定的想象中，更多会即刻行动以达成你的目的和标准。因而，在工作或学习中，你有较强的执行力和毅力，努力获得更好的效果。但需要注意的是，工作主导的你，对于工作的过度关注会让你比较忽视与身边人的关系。',
	  'in_lover': '在他的眼中，你霸道而强势，在你们之间的关系中，你通常是主导的角色，一般掌握关系的决定权。你有完美主义的标准和要求，这样来看，满足你要求的他本身比较优秀。而对于你自身来说，你是一个内心情感较丰富的人，这种情感比较少外化出来，但你会选择无声无息地给他准备惊喜。在他看来，你们的爱情充满了浪漫的气息。需要明确的是，你有果断勇敢的一面，一旦感情生变，你会决绝的分开。',
	  'in_friends': '在他人看来，要成为你的朋友似乎很难。气场强大的你，生活大部分都是围绕着工作和学习，因而想要赢得你的欣赏和关注，可能需要有较强的工作或学习能力，或者在其他方面有一技之长。其实在他人看来，你似乎不太需要朋友，因为你能从工作或其他事物中找到很多乐趣。<br/><br/>不过在你的内心中，还是渴望有朋友的支持和关注，只是你谨小慎微的性格导致了你交友慎重，要求你的朋友忠诚可靠，这样你才愿意付出你的真心。当和朋友产生争论时，你大多数会坚持自己的看法。但你为了朋友会甘心听他的牢骚，为ta解决实际问题。',
	  'in_colleagues': '在同事的眼中，你有非常优秀的领导才能。工作上，你是目标主导倾向，有统领全局的能力，非常有主见。同时，你善于做工作计划并分配工作，以便让每个人都“有事可做”，善于挖掘不同的人的优点。<br/><br/>在进行工作的过程中，你还能比较细心关注工作的各方面，力求达到满意的效果，即便工作中遇到了挫折和困难，你也敢于面对并寻找解决的具体办法。只是需要注意的是，你将大部分注意力都只关注在对工作等客观事物上，较少关注身边人的需求。因而，你在同事中几乎找不到可以交心的朋友。',
	  'will_be': '作为父母，你不容许自己的家里乱糟糟的。你的组织和管理能力同样能把家里打造得井井有条。你注重你的家长权威性，对子女常使用命令式的语气，但同时你非常具有牺牲精神，虽然表明你会指责你的孩子乱糟糟的，但你还是会不断地为ta操心操力。',
	  'advantage': '1）你有很强的领导能力。力量型的“一工作就废寝忘食”的特点与活泼型的感染能力结合，让你在同事之间有很强的号召能力；<br/><br/>2）你很主动，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>3）你果断、有条理、目标明确，这种类型的你一般有强烈的欲望和决心，当朝着正确的方向进发时，力量型/完美型的你总是最容易成功；<br/><br/>4）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃。',
	  'shortcoming': '1）你工作起来有时候六亲不认，工作的时候他人比较难转移你的注意力，有时会忽略生活中的美好；<br/><br/>2）你的控制欲望比较强烈，目标导向的你希望对事情有绝对的把控力，很有可能带到与人的交往中，容易给人留下比较霸道的印象；<br/><br/>3）在人际交往中你可能也会带有工作上的理性、强硬的沟通方式，不太懂得变通，使得周围的人不太愿意和你沟通。<br/><br/>4）力量型的你不懂得给自己放松和减压，患心脏病的风险比较高。',
	  'suggest': '1）学会放松，减轻对别人的压力：追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让我们周围的人产生可怕的压力；<br/><br/>2）遇错学会道歉：不同的人看到的世界不一样，都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉。这样会让你平易近人很多。<br/><br/>3）降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和他人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准。',
	  'match_jobs': '做规划和决策性的领导职位，政治家，运动员，宣传员'
	}, { 'key': 'Cp',
	  'sex': 'male',
	  'animal': '猎豹',
	  'animal_en': 'Acinonyxjubatus',
	  'pic': '../static/funreports/liebao/animal.png',
	  'tags': '意志坚定、靠得住、谨言慎行、识时务者为俊杰、自食其力、潜力股、不好纷争、冷静、淡定',
	  'short_description': '猎豹是草原上的奔跑能手，一旦瞄准目标，便会立即行动，常常不追到不罢休。但在猫科动物中，猎豹性格谨慎，爱好和平，不惹事生非，也不好杀戮，很少抢劫其他猛兽的食物，一般不会让自己陷入冲突中。猎豹性格的你，做事情很少拖泥带水，极具隐忍力。',
	  'coordinate': '',
	  'basic_discription': '你是明显的工作导向类型，处事讲究效率，做起事情来雷厉风行。但同时你的性格结合了和平型的低调冷静、有耐心，使得你奋发进取的个性能够以一种相对更为温和的形式表现出来。这样的你有能力却表现沉稳，有想法却并不张扬，能无形中给人一种信任感。<br/><br/>他人在与你交往时会感觉很舒适，但同时也能感受到一种低调的气场。需要注意的是，虽然你表面上你能够与人较好，但是缺乏特别交心的朋友。你并不轻易把自己内心的想法表现出来，因而别人很难走进你的内心。',
	  'in_lover': '沉稳而踏实的你，通常是感情的主导者，在一些大的决策上面，往往是你在拿主意。而在小事中，你并不太介意到底听谁的。在她看来，你是一个敢作敢当的人。虽然你并不是很浪漫，但你会真切地为对方作一些考虑，一旦许下承诺，则必定兑现。你对感情十分忠诚，有责任感，这是最吸引她的方面。<br/><br/>虽然生活中有很多琐碎的小事，但你们不太因这些琐事而争吵。即便有一些摩擦，沉稳如你也很少会和她激烈的争吵。当然，如果能偶尔来个惊喜和浪漫的话，那你几乎要要套牢她了！与此同时，你对待感情很少拖泥带水，一旦分手则断得干干净净。',
	  'in_friends': '在朋友眼中，你是一个踏实而可靠的人。通常表现比较冷静的你，能够在朋友六神无主时给予冷静的分析，帮助对方梳理好问题的重难点，甚至给出自己的观点和建议。在事务性问题上，你能设身处地为朋友着想，并且常常能给出一些切实可行的解决方案。但是在人际性问题上，谨慎的你常常会保持客观而中立的态度。虽然耐心的你依然会做朋友忠实的倾听者，但你并不好表明什么态度。你是一个时间观念很强的人，因而面对朋友的一些问题时，你可能会感觉它并不是一个“问题”，不愿浪费时间而采用一种敷衍的态度，可能会引起朋友反感。',
	  'in_colleagues': '在同事眼中，你是一个很懂得管理和执行的人。你目标性很强，通常为了达到目标你会为之努力。但有些人可能会把这种强烈的目的性表现得很明显，有时会让他人反感；而聪明的你具有和平型的沉稳，因此，你有能力通过一种“润物无声”的温和方式达到目标，既不会惹人反感，更不会让人感觉到攻击性。<br/><br/>因此，你的管理能力很强，作为领导，你能够让下属心甘情愿地努力工作，而作为同事，你更能带动大家一起向着目标行进。总之，同事的眼中你具有较良好的威信。当然也有时候，你对自己的高要求可能会影响到团队其他人，给大家的工作带来一定的紧张感。而且你内心的固执让你很难真正接受他人的意见。',
	  'will_be': '在孩子眼中，你会是一个比较有威严的父亲，总带着一本正经的严肃面孔。通常你比较关注孩子的学习成绩，身体健康方面的状况，会为家庭大的方面进行决策，也会从宏观上为孩子作打算。有很强的责任感的你，其实为了家庭会付出很多，但在生活细节上你比较少照顾到，这可能和家庭分工有关。沉稳的你很少会和孩子发火，但同时，相比于母亲，孩子可能和你更不亲近。不过对你来说，努力拼搏，提升家庭的整体幸福是你最大的使命，这样的你会赢得孩子和另一半的尊重。',
	  'advantage': '1）你个性沉稳，做事靠谱，在工作和为人处事方面，都会给他人留下值得信赖的感觉；<br/><br/>2）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>3）你是强势的领导者。不论在何种场合中，力量型的你都很能赢得他人的注视和焦点，特别是当大家没有注意，乱做一团的时候，你更能显示出自己的领导风范；<br/><br/>4）永远精力旺盛。你好像总有用不完的精力和力量，当身边的人感到力不从心时，你依然充满活力，斗志昂扬；<br/><br/>5）虽然你一旦进入工作就会进入一种非常认真的状态，但你对工作绩效和成果的追求会以一种更温和的方式表现出来。',
	  'shortcoming': '1）你控制欲望强烈，总想着掌控全局，而且常常固执的认为自己是对的，有时给人一种专横霸道的感觉；<br/><br/>2）你给人一种呆板，不懂得变通的印象，而且有时候会认死理，不懂得调动气氛，而且他人很难和你开玩笑；<br/><br/>3）虽然你有追求又个性平稳，但沉浸在工作中的你常常不懂得给自己放松和减压，因而患心脏病的风险比较高；<br/><br/>4）你不会轻易向他人坦露自我，表现为对他人有所防备，在谈及自己时，你会比较敏感。',
	  'suggest': '1）适当转换视角，从他人的观点中取合理性。你有时候就是“没有错先生”，有时候在你内心中固执地认为“我没有错，是别人错了”，虽然不会太明显地表露出来。如果能适当转换视角，也许你也能看到不一样的东西；<br/><br/>2）学会自我减压和放松。虽然你热衷于工作或学习，但这会让你忽视自己的真实需要，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>3）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>4）学会沟通的艺术，有些话换一种方式表达，效果会不一样，更让对方接受；<br/><br/>5）适当坦露自己，能让他人觉得你更容易亲近些。',
	  'match_jobs': '政治家，管理层'
	}, { 'key': 'Cp',
	  'sex': 'female',
	  'animal': '猎豹',
	  'animal_en': 'Acinonyxjubatus',
	  'pic': '../static/funreports/liebao/animal.png',
	  'tags': '意志坚定、靠得住、谨言慎行、识时务者为俊杰、自食其力、潜力股、不好纷争、冷静、淡定',
	  'short_description': '猎豹是草原上的奔跑能手，一旦瞄准目标，便会立即行动，常常不追到不罢休。但在猫科动物中，猎豹性格谨慎，爱好和平，不惹事生非，也不好杀戮，很少抢劫其他猛兽的食物，一般不会让自己陷入冲突中。猎豹性格的你，做事情很少拖泥带水，极具隐忍力。',
	  'coordinate': '',
	  'basic_discription': '你是明显的工作导向类型，处事讲究效率，做起事情来雷厉风行。但同时你的性格结合了和平型的低调冷静、有耐心，使得你奋发进取的个性能够以一种相对更为温和的形式表现出来。这样的你有能力却表现沉稳，有想法却并不张扬，能无形中给人一种信任感。<br/><br/>他人在与你交往时会感觉很舒适，但同时也能感受到一种低调的气场。需要注意的是，虽然你表面上你能够与人较好，但是缺乏特别交心的朋友。你并不轻易把自己内心的想法表现出来，因而别人很难走进你的内心。',
	  'in_lover': '在他看来，你是一个沉稳的人，并不像很多女生一样追求浪漫，你更多的是关注对方的成熟度。在和他相处的过程中，你很少因为生活的琐碎小事而和他大吵大闹，因为这对于你来说未免有点幼稚。但是在一些大的感情发展方面，可能会和对方产生一些冲突。原因很简单，因为你的性格决定你在感情中并不弱势，你有较强的控制欲，希望成为感情的主导者，在一些大的决策上能让你来拿主意。<br/><br/>这对于大部分男生来说可能比较难以接受。如果爱情中你能温顺一些，多一些对他的依赖，或者偶尔在生活中给他制造一些浪漫的小惊喜，可能会大大有益于你们之间的感情发展。当然，如果现在的他已经向你妥协了的话，那除了真爱，还能是什么呢？',
	  'in_friends': '在朋友眼中，你是一个踏实而可靠的人。通常表现比较冷静的你，能够在朋友六神无主时给予冷静的分析，帮助对方梳理好问题的重难点，甚至给出自己的观点和建议。在事务性问题上，你能设身处地为朋友着想，并且常常能给出一些切实可行的解决方案。但是在人际性问题上，谨慎的你常常会保持客观而中立的态度。虽然耐心的你依然会做朋友忠实的倾听者，但你并不好表明什么态度。你是一个时间观念很强的人，因而面对朋友的一些问题时，你可能会感觉它并不是一个“问题”，不愿浪费时间而采用一种敷衍的态度，可能会引起朋友反感。',
	  'in_colleagues': '在同事眼中，你是一个很懂得管理和执行的人。你目标性很强，通常为了达到目标你会为之努力。但有些人可能会把这种强烈的目的性表现得很明显，有时会让他人反感；而聪明的你具有和平型的沉稳，因此，你有能力通过一种“润物无声”的温和方式达到目标，既不会惹人反感，更不会让人感觉到攻击性。<br/><br/>因此，你的管理能力很强，作为领导，你能够让下属心甘情愿地努力工作，而作为同事，你更能带动大家一起向着目标行进。总之，同事的眼中你具有较良好的威信。当然也有时候，你对自己的高要求可能会影响到团队其他人，给大家的工作带来一定的紧张感。而且你内心的固执让你很难真正接受他人的意见。',
	  'will_be': '在孩子眼中，你会是一个比较温和又严肃的妈妈。操心命的你，不仅会关注孩子的学习成绩，身体健康等大的方面的状况，也会在生活细节方面关注孩子的成长。因此，在涉及到关于教育、成绩等大的问题时，你可能会比较强硬，有主见，无形中表现出一种不容置疑的气场；但是在生活的小的方面，你能耐心而温和的和孩子进行良好的沟通，很少因孩子犯错而大发雷霆。<br/><br/>如果孩子能够摸清楚你的个性特点，那么你们的亲子关系会非常融洽，他会知道什么情况是“可以商量”，而什么时候是“必须听话”，这种情况下，他的成长和发展一般都不会跑太偏。当然，如果你能适当听听孩子内心的声音，能够综合多方面改进对孩子的教育方案，那么你会更加赢得孩子的尊重。',
	  'advantage': '1）你个性沉稳，做事靠谱，在工作和为人处事方面，都会给他人留下值得信赖的感觉；<br/><br/>2）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>3）你是强势的领导者。不论在何种场合中，力量型的你都很能赢得他人的注视和焦点，特别是当大家没有注意，乱做一团的时候，你更能显示出自己的领导风范；<br/><br/>4）永远精力旺盛。你好像总有用不完的精力和力量，当身边的人感到力不从心时，你依然充满活力，斗志昂扬；<br/><br/>5）虽然你一旦进入工作就会进入一种非常认真的状态，但你对工作绩效和成果的追求会以一种更温和的方式表现出来。',
	  'shortcoming': '1）你控制欲望强烈，总想着掌控全局，而且常常固执的认为自己是对的，有时给人一种专横霸道的感觉；<br/><br/>2）你给人一种呆板，不懂得变通的印象，而且有时候会认死理，不懂得调动气氛，而且他人很难和你开玩笑；<br/><br/>3）虽然你有追求又个性平稳，但沉浸在工作中的你常常不懂得给自己放松和减压，因而患心脏病的风险比较高；<br/><br/>4）你不会轻易向他人坦露自我，表现为对他人有所防备，在谈及自己时，你会比较敏感。',
	  'suggest': '1）适当转换视角，从他人的观点中取合理性。你有时候就是“没有错先生”，有时候在你内心中固执地认为“我没有错，是别人错了”，虽然不会太明显地表露出来。如果能适当转换视角，也许你也能看到不一样的东西；<br/><br/>2）学会自我减压和放松。虽然你热衷于工作或学习，但这会让你忽视自己的真实需要，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>3）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>4）学会沟通的艺术，有些话换一种方式表达，效果会不一样，更让对方接受；<br/><br/>5）适当坦露自己，能让他人觉得你更容易亲近些。',
	  'match_jobs': '政治家，管理层'
	}, { 'key': 'S',
	  'sex': 'male',
	  'animal': '海狮',
	  'animal_en': 'Otarriinae',
	  'pic': '../static/funreports/haishi/animal.png',
	  'tags': '话唠、不羁放纵爱自由、社交达人、感情外露、不记仇、小太阳、健忘、乐观、搞事情',
	  'short_description': '你的性格就像海狮一样，活泼，惹人喜欢。海狮对外界事物充满好奇，喜欢和小伙伴一起快乐玩耍，而且方式很有趣，比方说互相摩擦鼻子，一如爱说话的你，喜欢和人交流。另外，海狮被认为是温顺的动物，很少具有攻击性，而你也从不对他人抱有敌意。',
	  'coordinate': '',
	  'basic_discription': '你就像个永远长不大的孩子，爱冒险，对人总是很友善，与人十分相处融洽。你最大的天性是爱说，爱玩。通常是人未到，声先到，性格特点很有识别度。你是属于情感外露的人，热情奔放，喜欢对事物描绘的绘声绘色。你很迷恋童话，总希望一直生活的很快乐。<br/><br/>此外，你热情而直率，对朋友之间习惯肢体的亲密接触，如拥抱，拍打，抚摸等。单纯的你很少记仇，因为你非常健忘，对于别人伤害过你的事，常常转眼就忘了，并且你的情绪处理能力很强，所以不开心的事在你脑海中经常是“雁过无痕”。',
	  'in_lover': '活泼型的你情感丰富，内心情绪常常翻滚。在她看来，你是个很重感情的人，对感情能投入很多，但是情绪容易外露，男生的这种表现在女生看来可能会降低你的情感吸引力。此外，你的高付出和高投入，让你比较难以接受失恋的痛苦，因而你们吵架时，她会感觉到你的情绪比较激动，起伏较大。<br/><br/>但是同时，你又经常能被其他事物带动情绪，不好的情绪也不会维持太久。总的来说，活泼型的你在感情方面，能给她带来欢乐，在生活细节上能较好的照顾对方，幽默感较强，两个人在一起时不会冷场。但是，你的情绪容易起伏，会给她一种不太沉稳的印象。',
	  'in_friends': '在朋友眼中，你似乎随时都能交上朋友。你很自来熟，能和陌生人聊天儿毫无压力，这来源于你开朗灵动的性格。热爱新鲜事物的你，为人很有趣，通常是朋友圈里的活跃剂。朋友喜欢和你在一起，除了上述原因以外，还因为你容易主动道歉，在相处过程中一般不会有关系僵持的情况出现。<br/><br/>你是个直肠子，从不吝啬赞扬他人，这也是你能吸引很多朋友的一个原因。但是需要注意的是，在与人交往过程中，你可能会“管不住嘴”，有时会夸大对事实的描述，给人一种浮夸感，对待他人有时会随意许下一些承诺，事后又难以达到。',
	  'in_colleagues': '在同事的眼中，你是个工作中难得的“开心果”或烦闷工作的“润滑剂”，因为你擅长从工作中寻找乐趣。在工作中你通常积极而主动，喜欢新鲜事物，因而不会逃避工作中没有尝试过的事情。同时，天性热爱童话，脑海中充满幻想的你，富有创造力，总是能在工作中提出新奇的观点和见解。在团队合作中除了自身的积极踊跃以外，也会鼓励他人参与。',
	  'will_be': '在孩子的你眼中，相比于一个一本正经的父亲，你更像是一个亲切又好玩的朋友。孩子喜欢与你亲近，因为幽默又风趣的你，总能给家庭带来很多欢乐，即便身在困苦中，你也能苦中作乐。有点像“大孩子王”的你不仅被自己的孩子喜爱，在孩子的朋友中，你也颇受欢迎。即便如此，你需要适当地树立自己的家长权威型，否则在孩子的成长管教方面会遇到一些问题。',
	  'advantage': '1）你的个性热情奔放，容易成为朋友群体中的“开心果”，给他人带来欢乐。不论是在多么艰苦的环境下，你都懂得从中寻找乐趣，天性乐观的你，总是能给他人带来惊喜；<br/><br/>2）内心天真没有心机，容易赢得他人的好感，生活中易保持乐观的心态，有情绪通常不会藏着掖着，有助于身心健康；<br/><br/>3）内心天真，喜爱童话，充满幻想和想象，因而工作和生活中都不乏创造力，有时能反常人思维，提出让人耳目一新的观点。',
	  'shortcoming': '1）活泼型的你有时候太关注自己的情绪和话题，对自己的故事津津乐道，在他人看来比较自我中心，较少关注他人的内心需求；<br/><br/>2）活泼型的你虽然对负性的事情比较容易忘记，但也往往喜欢逃避问题，不去直面并解决它，不利于个人成长；<br/><br/>3）活泼型的你到哪里都是能引起焦点，乐于自我表现的性格使得你比较容易引起他人的关注，甚至被认为是“最有可能成功的人”，但你做事有时比较浮躁，有时给人“雷声大雨点小”的不良印象；<br/><br/>4）活泼型的你定力和坚持性不够，做事容易三天打渔两天晒网。',
	  'suggest': '1）话少说一半。谈话减半，删除你还想说的另一个故事。当与人交谈时，关注沉闷的信号。当你发现别人开始逃离你的吸引力时，尽量压缩你的谈话内容；<br/><br/>2）与人交往时需要重点记忆对方的名字，因为注意力差的你通常很容易忘记。你可以随身带上你的记忆便签。记忆力差是一个劣势，即使你能合理的解释你为什么记忆力差，也没有人愿意听；<br/><br/>3）学会把他人的需求放在首位。你不能满足于他人愿意成为你的听众，而要理解对方真正想要的，努力成为对方真正的朋友；<br/><br/>4）工作或学习中要学会踏实做事。该严肃认真的时候不要嘻哈打闹，保证工作的顺利完成之后，你才能赢得他人的信任；<br/><br/>5）谨记实事求是。多言的你有时候管不住自己的舌头，轻易向他人许诺。实事求是才能维系他人对你的好感。',
	  'match_jobs': '迎宾者，主持人，接待员，主席'
	}, { 'key': 'S',
	  'sex': 'female',
	  'animal': '海狮',
	  'animal_en': 'Otarriinae',
	  'pic': '../static/funreports/haishi/animal.png',
	  'tags': '话唠、不羁放纵爱自由、社交达人、感情外露、不记仇、小太阳、健忘、乐观、搞事情',
	  'short_description': '你的性格就像海狮一样，活泼，惹人喜欢。海狮对外界事物充满好奇，喜欢和小伙伴一起快乐玩耍，而且方式很有趣，比方说互相摩擦鼻子，一如爱说话的你，喜欢和人交流。另外，海狮被认为是温顺的动物，很少具有攻击性，而你也从不对他人抱有敌意。',
	  'coordinate': '',
	  'basic_discription': '你就像个永远长不大的孩子，爱冒险，对人总是很友善，与人十分相处融洽。你最大的天性是爱说，爱玩。通常是人未到，声先到，性格特点很有识别度。你是属于情感外露的人，热情奔放，喜欢对事物描绘的绘声绘色。你很迷恋童话，总希望一直生活的很快乐。<br/><br/>此外，你热情而直率，对朋友之间习惯肢体的亲密接触，如拥抱，拍打，抚摸等。单纯的你很少记仇，因为你非常健忘，对于别人伤害过你的事，常常转眼就忘了，并且你的情绪处理能力很强，所以不开心的事在你脑海中经常是“雁过无痕”。',
	  'in_lover': '活泼型的你情感丰富，内心情绪常常翻滚。在他看来，你是个很重感情的人，对感情能投入很多，而且一般心里的情绪都写在了脸上，他很容易通过你的表情推测你内心的想法。你们之间可能常有这样的对话：<br/>“生气了吗？”<br/>“没有”（生气脸）。<br/><br/>对于他来说，这种方式并不能让你说出心事，但是换种方式就可以。比如“看你不开心，是什么让你生气呢？”一般这种方式能让你打开话匣。<br/><br/>在生活方面，你幽默又有趣，两个人在一起基本不会冷场。但是你的情绪太难隐藏，负面的情绪有时也会影响他的心情。',
	  'in_friends': '在朋友眼中，你似乎随时都能交上朋友。你很自来熟，能和陌生人聊天儿毫无压力，这来源于你开朗灵动的性格。热爱新鲜事物的你，为人很有趣，通常是朋友圈里的活跃剂。朋友喜欢和你在一起，除了上述原因以外，还因为你容易主动道歉，在相处过程中一般不会有关系僵持的情况出现。<br/><br/>你是个直肠子，从不吝啬赞扬他人，这也是你能吸引很多朋友的一个原因。但是需要注意的是，在与人交往过程中，你可能会“管不住嘴”，有时会夸大对事实的描述，给人一种浮夸感，对待他人有时会随意许下一些承诺，事后又难以达到。',
	  'in_colleagues': '在同事的眼中，你是个工作中难得的“开心果”或烦闷工作的“润滑剂”，因为你擅长从工作中寻找乐趣。在工作中你通常积极而主动，喜欢新鲜事物，因而不会逃避工作中没有尝试过的事情。同时，天性热爱童话，脑海中充满幻想的你，富有创造力，总是能在工作中提出新奇的观点和见解。在团队合作中除了自身的积极踊跃以外，也会鼓励他人参与。',
	  'will_be': '在孩子的你眼中，相比于一个要求严格的母亲，你更像是一个亲切又好玩的朋友。孩子喜欢与你亲近，因为幽默又风趣的你，总能给家庭带来很多欢乐，即便身在困苦中，你也能苦中作乐。有点像“大孩子王”的你不仅被自己的孩子喜爱，在孩子的朋友中，你也颇受欢迎。你能理解孩子的世界，和孩子之间能有比较良好的交流。即便如此，你需要适当地树立自己的家长权威型，否则在孩子的成长管教方面会遇到一些问题。',
	  'advantage': '1）你的个性热情奔放，容易成为朋友群体中的“开心果”，给他人带来欢乐。不论是在多么艰苦的环境下，你都懂得从中寻找乐趣，天性乐观的你，总是能给他人带来惊喜；<br/><br/>2）内心天真没有心机，容易赢得他人的好感，生活中易保持乐观的心态，有情绪通常不会藏着掖着，有助于身心健康；<br/><br/>3）内心天真，喜爱童话，充满幻想和想象，因而工作和生活中都不乏创造力，有时能反常人思维，提出让人耳目一新的观点。',
	  'shortcoming': '1）活泼型的你有时候太关注自己的情绪和话题，对自己的故事津津乐道，在他人看来比较自我中心，较少关注他人的内心需求；<br/><br/>2）活泼型的你虽然对负性的事情比较容易忘记，但也往往喜欢逃避问题，不去直面并解决它，不利于个人成长；<br/><br/>3）活泼型的你到哪里都是能引起焦点，乐于自我表现的性格使得你比较容易引起他人的关注，甚至被认为是“最有可能成功的人”，但你做事有时比较浮躁，有时给人“雷声大雨点小”的不良印象；<br/><br/>4）活泼型的你定力和坚持性不够，做事容易三天打渔两天晒网。',
	  'suggest': '1）话少说一半。谈话减半，删除你还想说的另一个故事。当与人交谈时，关注沉闷的信号。当你发现别人开始逃离你的吸引力时，尽量压缩你的谈话内容；<br/><br/>2）与人交往时需要重点记忆对方的名字，因为注意力差的你通常很容易忘记。你可以随身带上你的记忆便签。记忆力差是一个劣势，即使你能合理的解释你为什么记忆力差，也没有人愿意听；<br/><br/>3）学会把他人的需求放在首位。你不能满足于他人愿意成为你的听众，而要理解对方真正想要的，努力成为对方真正的朋友；<br/><br/>4）工作或学习中要学会踏实做事。该严肃认真的时候不要嘻哈打闹，保证工作的顺利完成之后，你才能赢得他人的信任；<br/><br/>5）谨记实事求是。多言的你有时候管不住自己的舌头，轻易向他人许诺。实事求是才能维系他人对你的好感。',
	  'match_jobs': '迎宾者，主持人，接待员，主席'
	}, { 'key': 'Sc',
	  'sex': 'male',
	  'animal': '狐獴',
	  'animal_en': 'Suricatasuricatta',
	  'pic': '../static/funreports/humeng/animal.png',
	  'tags': '砍价高手、是谁说我帅、人缘好、活力无限、自来熟、冷场终结者、随机应变、爱要坦荡荡、积极进取、段子手',
	  'short_description': '狐獴有互相救助的习性，在一群狐獴中，会安排成员轮流放哨，通过叫声来提醒所有同伴。拥有狐獴性格的你，不喜欢一个人呆着，喜欢和朋友在一块。再者，狐獴虽然看起来细小，但却是猎蛇高手，捕猎时动作迅速，实力不容小觑，就像你一样，认真起来绝对是一只潜力股。',
	  'coordinate': '',
	  'basic_discription': '不难发现，在很多场合中，你总是人们围绕的中心，你情绪外露，风趣幽默，热情奔放，说起话来手舞足蹈，身体语言很丰富，而你也十分享受被瞩目的感觉，人们也十分喜欢在你身边，因为你就像一个开心果，能让高兴的人更高兴，不高兴的人重新展露笑颜。<br/><br/>对于你来说，最重要的是“有乐趣”，你认为人生就该嘻嘻哈哈地度过，因此，你总是有一千零一个点子让事情变得有趣起来。对待工作也是如此，你能让每一个工作伙伴像你一样投入其中，发挥各自所长，常常涌现出新奇刺激的主意，这样活跃的工作氛围，谁不想和你一起工作呢？',
	  'in_lover': '在感情中，你往往是一段关系中的主导者。她就像你的小粉丝一样，沉迷于你的魅力当中，喜欢跟着你的步调生活。同时，搞怪精灵的你总是有源源不断的浪漫想法。你很少吝啬于情感上的表达，喜欢把自己内心的感受都说给她听。你们之间能有很多可以聊的话题。<br/><br/>但是通常你比较难掩饰自己的情绪，好在情绪来得快去得也快，并且健忘的特点使得你并不会总是和她“翻旧账”，在伴侣眼中，和你在一起心理包袱很小。当一段关系结束之后，你会有刻骨铭心的伤痛感，但很少去死缠烂打。',
	  'in_friends': '很多人会被你有趣的性格所吸引，所以你身边从来就不缺朋友，他们都愿意围绕着你，因为你阳光、有幽默感，总能驱走朋友的愁云，带来欢笑。但有时候，你给人感觉比较自我中心，和朋友聊天时总是会聊到自己。在有些朋友看来，你最关注的只是你自己，你更多的是需要一群观众，接受你的所有滔滔不绝，享受着被聚焦的快感，这种感觉会阻碍你的朋友和你的心理距离，因此你可能比较缺少和你十分交心的朋友。',
	  'in_colleagues': '在同事眼中，你很有组织力和领导力，在你的响应下，每个人都能发挥各自所长，你热爱工作并能使之变得有乐趣，让你的工作从来都不会乏味，脑洞大开的你常常为工作带来新的创意，干劲十足。目标导向的你是任务的推动者，有着果断的决策力，能和团队齐头并进，向目标奋发。',
	  'will_be': '你本身就像个长不大的孩子，因此你总能和自己的孩子打成一片，被孩子们所喜爱，你的家庭总是充满了欢笑声。在教养孩子的事情上，虽然大部分时间你对孩子都比较宽松，但你有你的原则，一旦孩子逾越了这些原则时，你会认真教导，你一边享受着和孩子一起时候的欢乐，一边有意识地对孩子进行管理，你就像一个马戏团的团长，带来快乐的同时，也行使命令的主权，在孩子心中是一个亦师亦友的角色。',
	  'advantage': '1）你是个气氛带动着，有你的地方就绝对不会有冷场，因此和你聊天是一件轻松愉快的事情，对方不用担心没有话题了怎么办，谈话间总是伴随着欢笑声；<br/><br/>2）你像个孩子一样，有天马行空般的想象力，善于打破陈旧思维，总是给人带来惊喜；<br/><br/>3）你很有行动力，接到新任务会如火如荼地开展，与生俱来的领导素质让你通常能成为工作的主导者，有很多的推动力和决断力。',
	  'shortcoming': '1）一旦让你开口，就很难让你停下来了，因为你是那么热爱表达，以致忘了给别人留有展示自己想法的空间，把对方当成听众，把谈话变成独角戏；<br/><br/>2）作为舞台的中心，你关注的从来都是自己，常常忽略别人的内心感受，这也是你朋友看起来很多，但知心的却很少的原因；<br/><br/>3）你容易情绪化，遇到不顺意的事情情绪波动很大，缺乏平和的内心；<br/><br/>4）你很健忘，容易丢三落四，常常忘记履行因为一时高兴而答应别人的事情。',
	  'suggest': '1）你需要适当控制住自己的表演欲，把关注焦点分担到他人身上。你可以从听和看做起，在别人表达完之前，不要急着打断说话，试着去理解和记住他人所说的话，让他人感觉受尊重很重要；<br/><br/>2）不要总是为了自我表达而总是夸夸其谈，学会倾听朋友的需求是必要的，如果你总是健忘，那么试着把你朋友的困难记录在手机备忘里，适当地时候给予对方建议和帮助能够很好的拉近和对方的距离；<br/><br/>3）试着离开支配地位，试着保留自己的观点，接纳别人的想法，喜欢掌握主导权的你脱离控制权会让你感到不自在，但同时你能开始发现身边人的优点，以及会对身边的人坦诚相对；<br/><br/>4）有时候为了把谈话内容变得更有趣，你可能会夸大故事的实际情况，甚至无中生有，要注意保持描述的客观性，适当修饰固然是好，但言过其实就是谎言了哟；<br/><br/>5）不要轻易向他人许诺，答应了事要可以用工具记录下来，实事求是才能维系他人对你的好感。',
	  'match_jobs': '推广、策划、广告、主持人'
	}, { 'key': 'Sc',
	  'sex': 'female',
	  'animal': '狐獴',
	  'animal_en': 'Suricatasuricatta',
	  'pic': '../static/funreports/humeng/animal.png',
	  'tags': '砍价高手、是谁说我帅、人缘好、活力无限、自来熟、冷场终结者、随机应变、爱要坦荡荡、积极进取、段子手',
	  'short_description': '狐獴有互相救助的习性，在一群狐獴中，会安排成员轮流放哨，通过叫声来提醒所有同伴。拥有狐獴性格的你，不喜欢一个人呆着，喜欢和朋友在一块。再者，狐獴虽然看起来细小，但却是猎蛇高手，捕猎时动作迅速，实力不容小觑，就像你一样，认真起来绝对是一只潜力股。',
	  'coordinate': '',
	  'basic_discription': '不难发现，在很多场合中，你总是人们围绕的中心，你情绪外露，风趣幽默，热情奔放，说起话来手舞足蹈，身体语言很丰富，而你也十分享受被瞩目的感觉，人们也十分喜欢在你身边，因为你就像一个开心果，能让高兴的人更高兴，不高兴的人重新展露笑颜。<br/><br/>对于你来说，最重要的是“有乐趣”，你认为人生就该嘻嘻哈哈地度过，因此，你总是有一千零一个点子让事情变得有趣起来。对待工作也是如此，你能让每一个工作伙伴像你一样投入其中，发挥各自所长，常常涌现出新奇刺激的主意，这样活跃的工作氛围，谁不想和你一起工作呢？',
	  'in_lover': '在感情中，你往往是一段关系中的主导者。他就像你的小粉丝一样，沉迷于你的魅力当中，喜欢跟着你的步调生活。同时，搞怪精灵的你总是有源源不断的浪漫想法。你很少吝啬于情感上的表达，喜欢把自己内心的感受都说给她听。你们之间能有很多可以聊的话题。<br/><br/>但是通常你比较难掩饰自己的情绪，好在情绪来得快去得也快，并且健忘的特点使得你并不会总是和他“翻旧账”，在伴侣眼中，和你在一起心理包袱很小。当一段关系结束之后，你会有刻骨铭心的伤痛感，但很少去死缠烂打。',
	  'in_friends': '很多人会被你有趣的性格所吸引，所以你身边从来就不缺朋友，他们都愿意围绕着你，因为你阳光、有幽默感，总能驱走朋友的愁云，带来欢笑。但有时候，你给人感觉比较自我中心，和朋友聊天时总是会聊到自己。在有些朋友看来，你最关注的只是你自己，你更多的是需要一群观众，接受你的所有滔滔不绝，享受着被聚焦的快感，这种感觉会阻碍你的朋友和你的心理距离，因此你可能比较缺少和你十分交心的朋友。',
	  'in_colleagues': '在同事眼中，你很有组织力和领导力，在你的响应下，每个人都能发挥各自所长，你热爱工作并能使之变得有乐趣，让你的工作从来都不会乏味，脑洞大开的你常常为工作带来新的创意，干劲十足。目标导向的你是任务的推动者，有着果断的决策力，能和团队齐头并进，向目标奋发。',
	  'will_be': '你本身就像个长不大的孩子，因此你总能和自己的孩子打成一片，被孩子们所喜爱，你的家庭总是充满了欢笑声。在教养孩子的事情上，虽然大部分时间你对孩子都比较宽松，但你有你的原则，一旦孩子逾越了这些原则时，你会认真教导，你一边享受着和孩子一起时候的欢乐，一边有意识地对孩子进行管理，你就像一个马戏团的团长，带来快乐的同时，也行使命令的主权，在孩子心中是一个亦师亦友的角色。',
	  'advantage': '1）你是个气氛带动着，有你的地方就绝对不会有冷场，因此和你聊天是一件轻松愉快的事情，对方不用担心没有话题了怎么办，谈话间总是伴随着欢笑声；<br/><br/>2）你像个孩子一样，有天马行空般的想象力，善于打破陈旧思维，总是给人带来惊喜；<br/><br/>3）你很有行动力，接到新任务会如火如荼地开展，与生俱来的领导素质让你通常能成为工作的主导者，有很多的推动力和决断力。',
	  'shortcoming': '1）一旦让你开口，就很难让你停下来了，因为你是那么热爱表达，以致忘了给别人留有展示自己想法的空间，把对方当成听众，把谈话变成独角戏；<br/><br/>2）作为舞台的中心，你关注的从来都是自己，常常忽略别人的内心感受，这也是你朋友看起来很多，但知心的却很少的原因；<br/><br/>3）你容易情绪化，遇到不顺意的事情情绪波动很大，缺乏平和的内心；<br/><br/>4）你很健忘，容易丢三落四，常常忘记履行因为一时高兴而答应别人的事情。',
	  'suggest': '1）你需要适当控制住自己的表演欲，把关注焦点分担到他人身上。你可以从听和看做起，在别人表达完之前，不要急着打断说话，试着去理解和记住他人所说的话，让他人感觉受尊重很重要；<br/><br/>2）不要总是为了自我表达而总是夸夸其谈，学会倾听朋友的需求是必要的，如果你总是健忘，那么试着把你朋友的困难记录在手机备忘里，适当地时候给予对方建议和帮助能够很好的拉近和对方的距离；<br/><br/>3）试着离开支配地位，试着保留自己的观点，接纳别人的想法，喜欢掌握主导权的你脱离控制权会让你感到不自在，但同时你能开始发现身边人的优点，以及会对身边的人坦诚相对；<br/><br/>4）有时候为了把谈话内容变得更有趣，你可能会夸大故事的实际情况，甚至无中生有，要注意保持描述的客观性，适当修饰固然是好，但言过其实就是谎言了哟；<br/><br/>5）不要轻易向他人许诺，答应了事要可以用工具记录下来，实事求是才能维系他人对你的好感。',
	  'match_jobs': '推广、策划、广告、主持人'
	}, { 'key': 'Sp',
	  'sex': 'male',
	  'animal': '羊驼',
	  'animal_en': 'Lamapacos',
	  'pic': '../static/funreports/yangtuo/animal.png',
	  'tags': '理想主义者、天然呆、我太受欢迎了怎么办、记忆断片、亲和力满分、健忘、讨厌孤独、爱玩、享乐主义、你开心就好',
	  'short_description': '不说话会死星人说的就是你，你和羊驼一样，讨厌孤独，同时又亲切可爱，让人很喜欢和你在一起，你会像羊驼一样，竖起耳朵，对身边的人表达着关怀，为他们扫除苦恼。',
	  'coordinate': '',
	  'basic_discription': '你身边有很多朋友，因为你待人亲切随和，富含幽默感，和你在一起感觉很轻松，完全不会有冷场压力，你仿佛有说不完的话题，因此你的个性十分吸引人，大家都喜欢和你相处。因为你能很好地调和人际关系，是很多人心中的好朋友，更孩子心中的好父母人选。但是有时候你喜欢随意而为，凡是觉得高兴就好，对目标追求决心不大，缺乏那种锐意进取的精神。',
	  'in_lover': '你是一个不错的伴侣，因为你对待感情认真投入，愿意付出百分百的真心，同时乐天的你总是变着花样地逗得另一半乐呵呵的，和你在一起感觉很让人放松，你不会锋芒过剩，让伴侣感到无所适从，而是像春风一样柔和，沁人心扉。<br/><br/>当一段关系结束之后，你会感到刻骨铭心的伤痛，可能会大哭一场，撕心裂肺到你难以承受。但是如果身边有新的人出现，很有可能会吸引你的注意力，这对于健忘的你来说是忘记伤痛的一剂良药。',
	  'in_friends': '擅于处理人际关系的你，当然有很多朋友围绕在身边，他们被你的个性吸引着，在谈话中你喜欢掌握主导权，正因为你总是说着有趣的内容，所以你身边的听众会越来越多，你也享受这被聚焦的感觉，但你不过过分展露，能给别人流出表达空间，这个时候，你也能扮演好一个听众的角色，给予人相对的尊重，是很好的交友对象。',
	  'in_colleagues': '你适合团队协作的工作，因为你天生有一种号召力，能发动起同事和你一起工作，而且你的点子多到惊人，敢于尝试新的东西，能把无聊的工作变得有趣，有着出色的人际协调能力，能缓和同事间的关系，避免冲突，但对工作安排缺乏合理的规划，常常开头气势如虹，接着却没有承接着起初的冲劲，对目标也没有势在必得的决心，显得过于随意，常常在deadline的时候拼命赶工。',
	  'will_be': '不仅你自己的孩子，别人家的孩子也很喜欢你，比起像一个长辈，你更像他们一个比较年长的朋友，那是因为你自己就像一个长不大的孩子，和孩子打成一片对你来说毫无难度，你对待孩子的教育态度比较宽松，不会设定很多条条框框，给予孩子充分自由的成长空间，你亲和的个性即使在孩子犯错的时候，也不会对孩子严厉地教训，而是以耐心的教育方式。',
	  'advantage': '1）你人缘十分好，待人真诚，热情奔放，你的话题总是充满乐趣，是朋友的开心果，你拥有驱散愁云的力量，总能为身边的人带来欢笑；<br/><br/>2）你内心天真没有心机，容易赢得他人的好感，生活中易保持乐观的心态，有情绪通常不会藏着掖着，有助于身心健康；<br/><br/>3）你擅长处理人际关系，能协调团队气氛，化解团队中的矛盾，是团队中的调和剂；<br/><br/>4）你有较好的情绪协调能力，面对突发事件时不会急得跳脚。',
	  'shortcoming': '1）你有拖延毛病，做事虎头蛇尾，很多事情其实只要你再努力一下就能做到，但你却缺乏持续追求的动力；<br/><br/>2）你缺乏理财能力，由于少规划和随性的个性，你很少对财产进行下意识的管理，赚多少、花多少都没有明确的数字概念；<br/><br/>3）你无限的创意和想象力有时候会导致物极必反的结果，随意的个性导致你无法掌握尺度，有时候会开了过大的玩笑或玩得过火了；<br/><br/>4）你容易健忘，容易丢三落四，常常忘记履行因为一时高兴而答应别人的事情。',
	  'suggest': '1）有时候为了把谈话内容变得更有趣，你可能会夸大故事的实际情况，甚至无中生有，要注意保持描述的客观性，适当修饰固然是好，但言过其实就是谎言了哟；<br/><br/>2）不要轻易向他人许诺，答应了事要可以用工具记录下来，实事求是才能维系他人对你的好感；<br/><br/>3）合理规划工作计划，建议把任务细分为一个个小任务，这能帮你把任务阶段性目标具体化，也能降低完成的难度感，每完成一个阶段，可以给自己一个小小的奖励，更好地激励自己完成下一阶段的任务。',
	  'match_jobs': '外交家、客户经理、销售、行政工作'
	}, { 'key': 'Sp',
	  'sex': 'female',
	  'animal': '羊驼',
	  'animal_en': 'Lamapacos',
	  'pic': '../static/funreports/yangtuo/animal.png',
	  'tags': '理想主义者、天然呆、我太受欢迎了怎么办、记忆断片、亲和力满分、健忘、讨厌孤独、爱玩、享乐主义、你开心就好',
	  'short_description': '不说话会死星人说的就是你，你和羊驼一样，讨厌孤独，同时又亲切可爱，让人很喜欢和你在一起，你会像羊驼一样，竖起耳朵，对身边的人表达着关怀，为他们扫除苦恼。',
	  'coordinate': '',
	  'basic_discription': '你身边有很多朋友，因为你待人亲切随和，富含幽默感，和你在一起感觉很轻松，完全不会有冷场压力，你仿佛有说不完的话题，因此你的个性十分吸引人，大家都喜欢和你相处。因为你能很好地调和人际关系，是很多人心中的好朋友，更孩子心中的好父母人选。但是有时候你喜欢随意而为，凡是觉得高兴就好，对目标追求决心不大，缺乏那种锐意进取的精神。',
	  'in_lover': '你是一个不错的伴侣，因为你对待感情认真投入，愿意付出百分百的真心，同时乐天的你总是变着花样地逗得另一半乐呵呵的，和你在一起感觉很让人放松，你不会锋芒过剩，让伴侣感到无所适从，而是像春风一样柔和，沁人心扉。<br/><br/>当一段关系结束之后，你会感到刻骨铭心的伤痛，可能会大哭一场，撕心裂肺到你难以承受。但是如果身边有新的人出现，很有可能会吸引你的注意力，这对于健忘的你来说是忘记伤痛的一剂良药。',
	  'in_friends': '擅于处理人际关系的你，当然有很多朋友围绕在身边，他们被你的个性吸引着，在谈话中你喜欢掌握主导权，正因为你总是说着有趣的内容，所以你身边的听众会越来越多，你也享受这被聚焦的感觉，但你不过过分展露，能给别人流出表达空间，这个时候，你也能扮演好一个听众的角色，给予人相对的尊重，是很好的交友对象。',
	  'in_colleagues': '你适合团队协作的工作，因为你天生有一种号召力，能发动起同事和你一起工作，而且你的点子多到惊人，敢于尝试新的东西，能把无聊的工作变得有趣，有着出色的人际协调能力，能缓和同事间的关系，避免冲突，但对工作安排缺乏合理的规划，常常开头气势如虹，接着却没有承接着起初的冲劲，对目标也没有势在必得的决心，显得过于随意，常常在deadline的时候拼命赶工。',
	  'will_be': '不仅你自己的孩子，别人家的孩子也很喜欢你，比起像一个长辈，你更像他们一个比较年长的朋友，那是因为你自己就像一个长不大的孩子，和孩子打成一片对你来说毫无难度，你对待孩子的教育态度比较宽松，不会设定很多条条框框，给予孩子充分自由的成长空间，你亲和的个性即使在孩子犯错的时候，也不会对孩子严厉地教训，而是以耐心的教育方式。',
	  'advantage': '1）你人缘十分好，待人真诚，热情奔放，你的话题总是充满乐趣，是朋友的开心果，你拥有驱散愁云的力量，总能为身边的人带来欢笑；<br/><br/>2）你内心天真没有心机，容易赢得他人的好感，生活中易保持乐观的心态，有情绪通常不会藏着掖着，有助于身心健康；<br/><br/>3）你擅长处理人际关系，能协调团队气氛，化解团队中的矛盾，是团队中的调和剂；<br/><br/>5）你有较好的情绪协调能力，面对突发事件时不会急得跳脚。',
	  'shortcoming': '1）你有拖延毛病，做事虎头蛇尾，很多事情其实只要你再努力一下就能做到，但你却缺乏持续追求的动力；<br/><br/>2）你缺乏理财能力，由于少规划和随性的个性，你很少对财产进行下意识的管理，赚多少、花多少都没有明确的数字概念；<br/><br/>3）你无限的创意和想象力有时候会导致物极必反的结果，随意的个性导致你无法掌握尺度，有时候会开了过大的玩笑或玩得过火了；<br/><br/>5）你容易健忘，容易丢三落四，常常忘记履行因为一时高兴而答应别人的事情。',
	  'suggest': '1）有时候为了把谈话内容变得更有趣，你可能会夸大故事的实际情况，甚至无中生有，要注意保持描述的客观性，适当修饰固然是好，但言过其实就是谎言了哟；<br/><br/>2）不要轻易向他人许诺，答应了事要可以用工具记录下来，实事求是才能维系他人对你的好感；<br/><br/>4）合理规划工作计划，建议把任务细分为一个个小任务，这能帮你把任务阶段性目标具体化，也能降低完成的难度感，每完成一个阶段，可以给自己一个小小的奖励，更好地激励自己完成下一阶段的任务。',
	  'match_jobs': '外交家、客户经理、销售、行政工作'
	}, { 'key': 'Sm',
	  'sex': 'male',
	  'animal': '白鲸',
	  'animal_en': 'Delphinapterusleucas',
	  'pic': '../static/funreports/baijing/animal.png',
	  'tags': '创造力丰富、热情友好、户外派、在意别人眼中的自己、贴心小棉袄、情感丰富、喜爱自由、心太软',
	  'short_description': '白鲸体态优雅，极爱干净，喜欢用歌喉和同伴进行交流。它们喜欢玩，一根木头、一片海草就能乐翻天，如同你眼中的世界，你总是不停地寻找乐趣，也乐于把自己打扮得漂漂亮亮的。拥有白鲸性格的你，平时虽然总是大大咧咧无所谓的样子，实际上邪希望自己能交上一份好的成绩。',
	  'coordinate': '',
	  'basic_discription': '大部分时间，你是活泼型人格主导，开朗外向是你给人的印象，但有些时候，你会有内向悲观的表现，显得有些极端，因此你的情绪起伏也很大，如果你准备计划一个派对，你会在策划过程很兴奋，有着很多点子，但有时会备受着完美型对细节追求的影响，会担心最后的成果是否能达到你的期望，但如果这两种情绪能协调得好，对工作保持兴奋，对品质保有追求，会为你带来很出色的成果。',
	  'in_lover': '在感情中，你往往是一段关系的主导者，即使一开始不是，在交往中也会慢慢转变成主导角色，和对待其他事情一样，你对另一半有追求，你会希望伴侣达到你某些特定的期望，有时候的情绪化会让人捉不准你内心的真实想法，但也让人无法估计你什么时候会给人浪漫的惊喜，你充满创意和想象力，总是闲不住的要给伴侣带来欢笑，对待感情认真真挚，但却不会纠缠不清，一段关系结束之后，往往不会过分留恋。',
	  'in_friends': '你对朋友的选择显得有些谨慎，虽然你没有追求结交很多朋友，但你身边总是围绕着人群，因为你幽默健谈的个性十分吸引人，常常把朋友逗乐。但总的来说，你更关注的还是自己，能触及你内心的朋友不多。但是对于朋友而言，你是个忠诚的伙伴，一旦认定了这个人，你就会对他掏心掏肺，毫无保留。',
	  'in_colleagues': '工作中，遇到头脑风暴的时候，你总是最多想法的一个，你的创新精神敢于打破条条框框，热衷尝试新的方法，在职场上功利心不大，没有那种势在必得的决心，通常势头很高涨，但接下来却没有了起初的激情，对工作的推动力不足，全局规划性不足，比较关注于细节部分。',
	  'will_be': '你喜欢和孩子待在一起，愿意花时间和他们做游戏、看动画，通常情况下，你对孩子的教育还是比较宽松的，但实际上你对孩子会有些不着痕迹的要求，譬如说你要求孩子们自己收拾玩具，要在9点之前睡觉等等……平时你家里看起来东西摆放都很随意，但你总是知道想到的东西在哪里，一旦某个时刻你完美型人格爆发，也会突如其来地认真收拾起来。',
	  'advantage': '1）你善交朋友，待人真诚，富含幽默感的你吸引着很多人与你为伴；<br/><br/>2）你情感丰富，创意无限，你脑海里天马行空，想象力爆棚，在你身上总会有让人意想不到的点子；<br/><br/>3）你能找到事物有趣的一面，用一双眼发现美好，在你眼中，世界是奇趣无穷，多姿多彩的。',
	  'shortcoming': '1）多数时候活泼热情，偶尔悲观消极，情绪高涨一段时间之后，可能每隔一段时间，就会出现一个消极的你，会给人有点阴晴不定的印象；<br/><br/>2）一旦让你开口，就很难让你停下来了，因为你是那么热爱表达，以致忘了给别人留有展示自己想法的空间，把对方当成听众，把谈话变成独角戏；<br/><br/>3）工作上你容易有拖延，你的目标通常比较模糊，执着于细节，散漫的个性常常使工作停滞不前。',
	  'suggest': '1）学会将活泼型和完美型两种不同类型在工作学习或人际交往中完美切换，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当两种状态让你比较迷糊时，你可以通过洗个脸、深吸一口气等小技巧来进行自我调整；<br/><br/>2）健谈的你容易成为谈话的中心者，不自觉地会把关注重点转移到自己身上，从而忽略了别人，把关注焦点分担到身边的人身上吧，这不是你一个人的独角戏；<br/><br/>3）对工作细节有追求是好，但忽视了完成度就会前功尽废，在展开任务前，做个详细的工作计划，有助于你在限定时间内完成任务。',
	  'match_jobs': '艺术家、音乐家、'
	}, { 'key': 'Sm',
	  'sex': 'female',
	  'animal': '白鲸',
	  'animal_en': 'Delphinapterusleucas',
	  'pic': '../static/funreports/baijing/animal.png',
	  'tags': '创造力丰富、热情友好、户外派、在意别人眼中的自己、贴心小棉袄、情感丰富、喜爱自由、心太软',
	  'short_description': '白鲸体态优雅，极爱干净，喜欢用歌喉和同伴进行交流。它们喜欢玩，一根木头、一片海草就能乐翻天，如同你眼中的世界，你总是不停地寻找乐趣，也乐于把自己打扮得漂漂亮亮的。拥有白鲸性格的你，平时虽然总是大大咧咧无所谓的样子，实际上邪希望自己能交上一份好的成绩。',
	  'coordinate': '',
	  'basic_discription': '大部分时间，你是活泼型人格主导，开朗外向是你给人的印象，但有些时候，你会有内向悲观的表现，显得有些极端，因此你的情绪起伏也很大，如果你准备计划一个派对，你会在策划过程很兴奋，有着很多点子，但有时会备受着完美型对细节追求的影响，会担心最后的成果是否能达到你的期望，但如果这两种情绪能协调得好，对工作保持兴奋，对品质保有追求，会为你带来很出色的成果。',
	  'in_lover': '在感情中，你往往是一段关系的主导者，即使一开始不是，在交往中也会慢慢转变成主导角色，和对待其他事情一样，你对另一半有追求，你会希望伴侣达到你某些特定的期望，有时候的情绪化会让人捉不准你内心的真实想法，但也让人无法估计你什么时候会给人浪漫的惊喜，你充满创意和想象力，总是闲不住的要给伴侣带来欢笑，对待感情认真真挚，但却不会纠缠不清，一段关系结束之后，往往不会过分留恋。',
	  'in_friends': '你对朋友的选择显得有些谨慎，虽然你没有追求结交很多朋友，但你身边总是围绕着人群，因为你幽默健谈的个性十分吸引人，常常把朋友逗乐。但总的来说，你更关注的还是自己，能触及你内心的朋友不多。但是对于朋友而言，你是个忠诚的伙伴，一旦认定了这个人，你就会对他掏心掏肺，毫无保留。',
	  'in_colleagues': '工作中，遇到头脑风暴的时候，你总是最多想法的一个，你的创新精神敢于打破条条框框，热衷尝试新的方法，在职场上功利心不大，没有那种势在必得的决心，通常势头很高涨，但接下来却没有了起初的激情，对工作的推动力不足，全局规划性不足，比较关注于细节部分。',
	  'will_be': '你喜欢和孩子待在一起，愿意花时间和他们做游戏、看动画，通常情况下，你对孩子的教育还是比较宽松的，但实际上你对孩子会有些不着痕迹的要求，譬如说你要求孩子们自己收拾玩具，要在10点之前睡觉等等……平时你家里看起来东西摆放都很随意，但你总是知道想到的东西在哪里，一旦某个时刻你完美型人格爆发，也会突如其来地认真收拾起来。',
	  'advantage': '1）你善交朋友，待人真诚，富含幽默感的你吸引着很多人与你为伴；<br/><br/>2）你情感丰富，创意无限，你脑海里天马行空，想象力爆棚，在你身上总会有让人意想不到的点子；<br/><br/>4）你能找到事物有趣的一面，用一双眼发现美好，在你眼中，世界是奇趣无穷，多姿多彩的。',
	  'shortcoming': '1）多数时候活泼热情，偶尔悲观消极，情绪高涨一段时间之后，可能每隔一段时间，就会出现一个消极的你，会给人有点阴晴不定的印象；<br/><br/>2）一旦让你开口，就很难让你停下来了，因为你是那么热爱表达，以致忘了给别人留有展示自己想法的空间，把对方当成听众，把谈话变成独角戏；<br/><br/>4）工作上你容易有拖延，你的目标通常比较模糊，执着于细节，散漫的个性常常使工作停滞不前。',
	  'suggest': '1）学会将活泼型和完美型两种不同类型在工作学习或人际交往中完美切换，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当两种状态让你比较迷糊时，你可以通过洗个脸、深吸一口气等小技巧来进行自我调整；<br/><br/>2）健谈的你容易成为谈话的中心者，不自觉地会把关注重点转移到自己身上，从而忽略了别人，把关注焦点分担到身边的人身上吧，这不是你一个人的独角戏；<br/><br/>4）对工作细节有追求是好，但忽视了完成度就会前功尽废，在展开任务前，做个详细的工作计划，有助于你在限定时间内     ',
	  'match_jobs': '艺术家、音乐家、'
	}, { 'key': 'P',
	  'sex': 'male',
	  'animal': '树懒',
	  'animal_en': 'Folivora',
	  'pic': '../static/funreports/shulai/animal.png',
	  'tags': '逃避虽然可耻但是有用、知足常乐、纠结、和平主义者、反应弧长、有耐性、北京瘫、安于现状、懒癌、我已经很满意啦',
	  'short_description': '树懒绝对是慢生活的体验者，生性平和，行动缓慢——像你，无论做任何事情，都显得不慌不躁，仿佛在脑海里要经过一番天人交战的剧烈思考才下决定。你喜欢安于现状，不想改变。性情沉稳的你无论行事还是做人都非常低调，因而也容易获得他人的信任。',
	  'coordinate': '',
	  'basic_discription': '你通常的口头禅是“这没什么大不了”。在他人看来，你是最容易相处一类人：性格低调，令人愉快且没有侵略性；没有哪一点特别突出，但却是人群中的粘合剂；对于你自身来说，你不太喜欢想的太远，常常安于现状，不想改变，所以你很少主动采取行动，处世为人都很低调。<br/><br/>当你面对风暴时能够比较冷静处事，习惯后退一步等一等，然后默默地向正确的方向前进。你不会轻易被愤怒冲昏头脑，也不会为一些其他人感到懊恼的情形而懊恼，真正要让你发起火来比较困难。<br/><br/>大多数情况下，即使你受到刺激，也能保持沉默且有耐心，总能保持相对比较中立的态度，所以人际关系总能处得不错。但是你对生活没有太大的期望和要求，安于生命中的起伏和变化的你，本性中带有消极成分。',
	  'in_lover': '在她的眼中，你就像一片广阔而宁静的大海，不论她有怎样的激烈的情绪，在你这里都能获得平静和包容。你能让她感觉安全、踏实和稳定，这种特质能够为你的形象加分。如果你偶尔心血来潮，问她这个问题：“你喜欢我哪一点？”，她多半是这样回答“我喜欢你的全部”。<br/><br/>在她看来，虽然你看上去没有哪一点特别突出，但同时却非常令人舒畅，友善和随和。即便你觉得自己是个平凡人，但却是人群中必不可少的粘合剂。当然，如果你表白而受到挫折了，通常会被发“好人卡”。被拒绝时可能通常听到的话也是“你人挺好的”，因为对方很难找出你的缺点，但一时又说不出你特别突出的优点。',
	  'in_friends': '虽然你不像活泼型那样朋友很多，但你从来不会“树敌”。在人际交往中，你能与他人好好相处，不制造事端，不干涉他人的客观态度，因此一般不会陷入一段关系的纠葛中；相反，你是缓和纷争的缓冲剂。不论是组织哪个朋友的团体活动，他们都会下意识得邀请你参加，因为你不但是解决矛盾关系的缓冲剂，更是一个忠实的好听众，朋友可以放心向你倾诉。而擅长表达同情和关心的你，总有一票交往真挚的朋友。',
	  'in_colleagues': '在同事的眼中，你似乎是一个不太起眼的人。低调行事的你，总是很少让他人注意到。但在关键的时刻，通常你会被委以重任。沉默而低调的你，懂得与人相处，具备优秀的行政能力；虽然高调处事不是你的性格，但你最难得之处在于“无过”，这是一种难以达到的境界。你是团队工作中必不可少的粘合剂，客观公正而平和的你，能够调和同事之间的摩擦和矛盾。就像《西游记》中的沙僧，大师兄和二师兄吵闹的时候，能够两头游说，最终使团队齐心协力。',
	  'will_be': '作为家长，你似乎不太会流露出自己的喜怒哀乐，不会有太强烈的主观观点。在孩子的眼中，你是一个温和、不太会发脾气的父亲。你不会轻易向你的孩子许诺，而一旦许诺就会践行。在你看来，要么不要讲太好听的话让孩子抱太大期望，要么说过的话就必须做到。总的来说，你在孩子眼中有一定的威信，能受到孩子的信赖。',
	  'advantage': '1）和平型的你是人最伟大的朋友之一，你是他人关系平衡的一个重要因素。你的外在表现冷静，但却不会阴郁，在他人的眼中是一个易于相处的人，和你交谈总会有一种自在的感觉；<br/><br/>2）你对人宽容，性格温和的你，基本很少会和他人争论，能和大多数的人友好相处；<br/><br/>3）你能关注到他人的实际需求，当别人说话时，你会仔细聆听，而不是盲目表达自己的看法。和平型的你，给让他人感觉到尊重，赢得别人的好感；<br/><br/>4）你很冷静，即便在争吵的风暴中仍然有思考的能力，一般不会被情绪带跑。',
	  'shortcoming': '1）你漫不经心的性格是一种缺乏主见的表现。很少流露出自己立场的你，常常没什么亮点，在工作中有时会被忽略；<br/><br/>2）你很懒散，缺少力量型的执行力，有比较严重的拖延症，并且常常你会为你的拖延症寻找借口，其实最大的原因就是懒，只是你不愿意面对而已；<br/><br/>3）外表温和的你，其实内心很固执。虽然你平和的性格让你避免与他人对抗和争吵，但你很少表达自己内心的真实想法，无形中拉开了与他人的心理距离；<br/><br/>4）很好说话的你，比较难拒绝他人，有的时候容易被他人利用；<br/><br/>5）你的性子慢，反应速度不快，有时难以跟上生活的快速节奏。',
	  'suggest': '1）不要过于安于现状，适当去挑战新鲜事物，也许会有新的发现。让自己振奋起来，你可以参加不同的活动小组，通过旅游试着去体验不同的人他们的生活，或其他方式让自己的生活多一些激情；<br/><br/>2）为自己平淡的生活制定一些目标，让每一天都过的有价值。你可以运用电脑桌面软件制定一个日、周、月计划表，要求自己今日事今日毕，必要时接受他人督促；<br/><br/>3）学会说“不”，首先，多想想自己真正想要的是什么，再者学会委婉拒绝的技巧，要知道一味地满足他人的要求或求助是没有主见的表现。',
	  'match_jobs': '教师、学者、医生、工程师，行政职业'
	}, { 'key': 'P',
	  'sex': 'female',
	  'animal': '树懒',
	  'animal_en': 'Folivora',
	  'pic': '../static/funreports/shulai/animal.png',
	  'tags': '逃避虽然可耻但是有用、知足常乐、纠结、和平主义者、反应弧长、有耐性、北京瘫、安于现状、懒癌、我已经很满意啦',
	  'short_description': '树懒绝对是慢生活的体验者，生性平和，行动缓慢——像你，无论做任何事情，都显得不慌不躁，仿佛在脑海里要经过一番天人交战的剧烈思考才下决定。你喜欢安于现状，不想改变。性情沉稳的你无论行事还是做人都非常低调，因而也容易获得他人的信任。',
	  'coordinate': '',
	  'basic_discription': '你通常的口头禅是“这没什么大不了”。在他人看来，你是最容易相处一类人：性格低调，令人愉快且没有侵略性；没有哪一点特别突出，但却是人群中的粘合剂；对于你自身来说，你不太喜欢想的太远，常常安于现状，不想改变，所以你很少主动采取行动，处世为人都很低调。<br/><br/>当你面对风暴时能够比较冷静处事，习惯后退一步等一等，然后默默地向正确的方向前进。你不会轻易被愤怒冲昏头脑，也不会为一些其他人感到懊恼的情形而懊恼，真正要让你发起火来比较困难。<br/><br/>大多数情况下，即使你受到刺激，也能保持沉默且有耐心，总能保持相对比较中立的态度，所以人际关系总能处得不错。但是你对生活没有太大的期望和要求，安于生命中的起伏和变化的你，本性中带有消极成分。',
	  'in_lover': '在他的眼中，你就像一片广阔而宁静的大海，不论他有怎样的激烈的情绪，在你这里都能获得平静和包容。你能让他感觉安全、踏实和稳定，这种特质能够为你的形象加分。如果你偶尔心血来潮，问他这个问题：“你喜欢我哪一点？”，他多半是这样回答“我喜欢你的全部”。<br/><br/>在他看来，虽然你看上去没有哪一点特别突出，但同时却非常令人舒畅，友善和随和。即便你觉得自己是个平凡人，但却是人群中必不可少的粘合剂。当然，如果你表白而受到挫折了，通常会被发“好人卡”。被拒绝时可能通常听到的话也是“你人挺好的”，因为对方很难找出你的缺点，但一时又说不出你特别突出的优点。',
	  'in_friends': '虽然你不像活泼型那样朋友很多，但你从来不会“树敌”。在人际交往中，你能与他人好好相处，不制造事端，不干涉他人的客观态度，因此一般不会陷入一段关系的纠葛中；相反，你是缓和纷争的缓冲剂。不论是组织哪个朋友的团体活动，他们都会下意识得邀请你参加，因为你不但是解决矛盾关系的缓冲剂，更是一个忠实的好听众，朋友可以放心向你倾诉。而擅长表达同情和关心的你，总有一票交往真挚的朋友。',
	  'in_colleagues': '在同事的眼中，你似乎是一个不太起眼的人。低调行事的你，总是很少让他人注意到。但在关键的时刻，通常你会被委以重任。沉默而低调的你，懂得与人相处，具备优秀的行政能力；虽然高调处事不是你的性格，但你最难得之处在于“无过”，这是一种难以达到的境界。你是团队工作中必不可少的粘合剂，客观公正而平和的你，能够调和同事之间的摩擦和矛盾。就像《西游记》中的沙僧，大师兄和二师兄吵闹的时候，能够两头游说，最终使团队齐心协力。',
	  'will_be': '作为家长，你似乎不太会流露出自己的喜怒哀乐，不会有太强烈的主观观点。在孩子的眼中，你是一个温和、不太会发脾气的妈妈。你不会轻易向你的孩子许诺，而一旦许诺就会践行。在你看来，要么不要讲太好听的话让孩子抱太大期望，要么说过的话就必须做到。总的来说，你在孩子眼中有一定的威信，能受到孩子的信赖。',
	  'advantage': '1）和平型的你是人最伟大的朋友之一，你是他人关系平衡的一个重要因素。你的外在表现冷静，但却不会阴郁，在他人的眼中是一个易于相处的人，和你交谈总会有一种自在的感觉；<br/><br/>2）你对人宽容，性格温和的你，基本很少会和他人争论，能和大多数的人友好相处；<br/><br/>3）你能关注到他人的实际需求，当别人说话时，你会仔细聆听，而不是盲目表达自己的看法。和平型的你，给让他人感觉到尊重，赢得别人的好感；<br/><br/>4）你很冷静，即便在争吵的风暴中仍然有思考的能力，一般不会被情绪带跑。',
	  'shortcoming': '1）你漫不经心的性格是一种缺乏主见的表现。很少流露出自己立场的你，常常没什么亮点，在工作中有时会被忽略；<br/><br/>2）你很懒散，缺少力量型的执行力，有比较严重的拖延症，并且常常你会为你的拖延症寻找借口，其实最大的原因就是懒，只是你不愿意面对而已；<br/><br/>3）外表温和的你，其实内心很固执。虽然你平和的性格让你避免与他人对抗和争吵，但你很少表达自己内心的真实想法，无形中拉开了与他人的心理距离；<br/><br/>4）很好说话的你，比较难拒绝他人，有的时候容易被他人利用；<br/><br/>5）你的性子慢，反应速度不快，有时难以跟上生活的快速节奏。',
	  'suggest': '1）不要过于安于现状，适当去挑战新鲜事物，也许会有新的发现。让自己振奋起来，你可以参加不同的活动小组，通过旅游试着去体验不同的人他们的生活，或其他方式让自己的生活多一些激情；<br/><br/>2）为自己平淡的生活制定一些目标，让每一天都过的有价值。你可以运用电脑桌面软件制定一个日、周、月计划表，要求自己今日事今日毕，必要时接受他人督促；<br/><br/>3）学会说“不”，首先，多想想自己真正想要的是什么，再者学会委婉拒绝的技巧，要知道一味地满足他人的要求或求助是没有主见的表现。',
	  'match_jobs': '教师、学者、医生、工程师，行政职业'
	}, { 'key': 'Pc',
	  'sex': 'male',
	  'animal': '座头鲸',
	  'animal_en': 'Megapteranovaeangliae',
	  'pic': '../static/funreports/zuotoujing/animal.png',
	  'tags': '我只想发达、低调、沉得住气、倔强、脾气好、适应力强、情商高、意志坚定',
	  'short_description': '座头鲸体型庞大，但性情却十分温顺，游泳速度不快，这也是你大部分时间的状态——平静，友好。但兔子急了也会咬人，必要时，你会像座头鲸遇敌战斗时那样，展开猛烈攻击，对目标有着较好的执行力。',
	  'coordinate': '',
	  'basic_discription': '你总体来说是一种人际关系主导的性格类型，基本上在任何群体中都吃得香。在社交场合中，大家都喜欢和你进行交谈，与你在一起能够感到轻松自然的氛围。<br/><br/>你乐于助人，是一个很好的聆听者，同时你很有自己的见解，所以大家遇到问题的时候很可能会求助于你，而你一般都能给出中肯的建议。和你熟悉的人会发现，其实你的随和性格在某些情况下会变得固执起来，对于自己的见解或想法有一定的坚持，甚至会尝试说服他人或者执意把你认定的事情进行下去。',
	  'in_lover': '在感情方面，你渴望平静、安全，比起打打闹闹的恋爱，你更倾向于选择一段平凡琐碎的感情。在另一半眼中，你随和、有耐心，和你在一起并不会有太多争吵或者恼火的事情发生，即使真的发生争吵，你也不会有太大的情绪反应，更多的是选择无声抵抗或者冷处理。<br/><br/>你为对方着想，在生活中的一些小细节总能透露出你对她的爱，但这些感动需要很用心才能体会到。相处的时间久了，你的寡言、平淡，很容易引起她对你的抱怨。你的性格温和，但是并不代表你没有自己的想法，尤其是在一些重要决策方面，你可能会表现出有点大男人主义，拿出一家之主的风范来要求对方迎合自己的观点。',
	  'in_friends': '你是一个很注重他人感受的人，愿意从朋友的立场为其着想。你为人说到做到，只要答应朋友的事情，你都会拿出行动尽力去帮忙。你的性格低调，很多时候为他人做事，都是默默地在做，不求回报。虽然你在朋友当中并不太起眼，甚至你的安静会让朋友觉得无聊，但你温和的个性还是会吸引不少朋友在身边，因为他们和你呆在一起会有一种舒服自在的感觉。',
	  'in_colleagues': '在同事看来，你是没有特殊的工作方式，能够随着环境的变化而转变，这往往会让人对你有一种你啥都能做，但是却没有特别擅长的感觉。你偏好选择不用承担太多压力的工作，你求上进的动力不强，往往需要外部的推力，如果你被指定某项任务，你的责任感会驱使你把任务完成得很好。在外力的推动下，你也是能够为心中的目标而一点一点计划地去实现。',
	  'will_be': '在子女眼中，你的父亲形象会比较严肃，和中国大多数的父亲一样，在子女面前不太善言辞，很少会流露出自己的喜怒哀乐。你基本不会在子女面前发脾气，但是如果子女没有达到你的某些要求，你可能会苛责子女，不过这些都只是因为你希望孩子有更出色的表现。<br/><br/>你是一个以身作则、说到做到的家长，你对子女的要求，一般也是对自己的要求，并不会在子女面前作不好的榜样，同时，虽然你不太会对子女承诺太多，一旦你答应了，你就会做到。总的来说，你在子女眼中有一定的威信，能得到子女的信赖。',
	  'advantage': '1）表面上你安静而不起眼，但这只是因为你不愿引起他人注意，实际上你头脑清醒，总能注意到他人忽略的细节，在风暴之中仍然能保持冷静；<br/><br/>2）你通常保持中立的态度，能与他人好好相处，不制造事端；当出现纷争时，你能坐下来给一个相对客观的意见来缓和它；<br/><br/>3）你的性格低调，令人愉快且没有侵略性，能够很好融入群体当中。',
	  'shortcoming': '1）你的身上有着一种慵懒的特质，只要没有外部的动力推动，你会选择默默呆着，常会在一些困难面前选择退缩；<br/><br/>2）你对新鲜的事物不太感冒，不喜欢变化，过于安于现状，当生活或工作中发生些变化，你会显得有点难以招架；<br/><br/>3）你性格固执，一旦被拒绝了，如果没有得到满意的理由，你一定会感觉难以接受。同时，如果你个人非常认可的观点被挑战了，你的固执性格很可能会让你与他人发生一场争论，然而这并不是你所擅长的；<br/><br/>4）你性子慢，反应速度不够快，可能会跟不上快节奏的工作或生活。',
	  'suggest': '1）遇到问题或挫折想要退缩，这是人的本能。但是一个人是在面对问题，解决问题的过程中成长的。下次遇到困难时，尝试把心中的“想要逃”转变成“我试试”，通过心理暗示获得迎难而上的信心；<br/><br/>2）有的时候，需要注意克制自己的抵触情绪以及无礼的言语和行为，加强自我调控，学会使用感情转化的心理调适方法来面对在观点不一发生争论的情况；<br/><br/>3）一定要保持学习，及时地更新你的知识系统，不然你在和朋友交往中会落伍。对你来说，向朋友学习是比较好的一种方式，保持开放的态度，学会大胆地尝试一些新事物。',
	  'match_jobs': '心理医生、办公室文员、行政工作'
	}, { 'key': 'Pc',
	  'sex': 'female',
	  'animal': '座头鲸',
	  'animal_en': 'Megapteranovaeangliae',
	  'pic': '../static/funreports/zuotoujing/animal.png',
	  'tags': '我只想发达、低调、沉得住气、倔强、脾气好、适应力强、情商高、意志坚定',
	  'short_description': '座头鲸体型庞大，但性情却十分温顺，游泳速度不快，这也是你大部分时间的状态——平静，友好。但兔子急了也会咬人，必要时，你会像座头鲸遇敌战斗时那样，展开猛烈攻击，对目标有着较好的执行力。',
	  'coordinate': '',
	  'basic_discription': '你总体来说是一种人际关系主导的性格类型，基本上在任何群体中都吃得香。在社交场合中，大家都喜欢和你进行交谈，与你在一起能够感到轻松自然的氛围。<br/><br/>你乐于助人，是一个很好的聆听者，同时你很有自己的见解，所以大家遇到问题的时候很可能会求助于你，而你一般都能给出中肯的建议。和你熟悉的人会发现，其实你的随和性格在某些情况下会变得固执起来，对于自己的见解或想法有一定的坚持，甚至会尝试说服他人或者执意把你认定的事情进行下去。',
	  'in_lover': '在感情方面，你渴望平静、安全，比起打打闹闹的恋爱，你更倾向于选择一段平凡琐碎的感情。虽然如此，你的内心对浪漫还是有些许期待与小激动的。在另一半眼中，你随和、有耐心，和你在一起并不会有太多争吵或者恼火的事情发生，即使真的发生争吵，你也不会有太大的情绪反应，更多的是选择无声抵抗或者冷处理。<br/><br/>你为对方着想，在生活中的一些小细节总能透露出你对他的爱，但这些感动需要很用心才能体会到。你比较独立，不太粘人，这可能会让他觉得你们之间的关系不够亲近。你的性格温和，但是并不代表你没有自己的想法，有的时候在某些重要的决策方面，你也会表现出自己的坚持。',
	  'in_friends': '你是一个很注重他人感受的人，愿意从朋友的立场为其着想。你为人说到做到，只要答应朋友的事情，你都会拿出行动尽力去帮忙。你的性格低调，很多时候为他人做事，都是默默地在做，不求回报。虽然你在朋友当中并不太起眼，甚至你的安静会让朋友觉得无聊，但你温和的个性还是会吸引不少朋友在身边，因为他们和你呆在一起会有一种舒服自在的感觉。',
	  'in_colleagues': '在同事看来，你是没有特殊的工作方式，能够随着环境的变化而转变，这往往会让人对你有一种你啥都能做，但是却没有特别擅长的感觉。你偏好选择不用承担太多压力的工作，你求上进的动力不强，往往需要外部的推力，如果你被指定某项任务，你的责任感会驱使你把任务完成得很好。在外力的推动下，你也是能够为心中的目标而一点一点计划地去实现。',
	  'will_be': '在子女眼中，你的母亲形象是比较严肃的，很少会流露出自己的喜怒哀乐。你基本不会在子女面前发脾气，但是如果子女没有达到你的某些要求，你可能会苛责子女，不过这些都只是因为你希望孩子有更出色的表现。<br/><br/>你是一个以身作则、说到做到的家长，你对子女的要求，一般也是对自己的要求，并不会在子女面前作不好的榜样，同时，虽然你不太会对子女承诺太多，一旦你答应了，你就会做到。总的来说，你在子女眼中有一定的威信，能得到子女的信赖。',
	  'advantage': '1）表面上你安静而不起眼，但这只是因为你不愿引起他人注意，实际上你头脑清醒，总能注意到他人忽略的细节，在风暴之中仍然能保持冷静；<br/><br/>2）你通常保持中立的态度，能与他人好好相处，不制造事端；当出现纷争时，你能坐下来给一个相对客观的意见来缓和它；<br/><br/>3）你的性格低调，令人愉快且没有侵略性，能够很好融入群体当中。',
	  'shortcoming': '1）你的身上有着一种慵懒的特质，只要没有外部的动力推动，你会选择默默呆着，常会在一些困难面前选择退缩；<br/><br/>2）你对新鲜的事物不太感冒，不喜欢变化，过于安于现状，当生活或工作中发生些变化，你会显得有点难以招架；<br/><br/>3）你性格固执，一旦被拒绝了，如果没有得到满意的理由，你一定会感觉难以接受。同时，如果你个人非常认可的观点被挑战了，你的固执性格很可能会让你与他人发生一场争论，然而这并不是你所擅长的；<br/><br/>4）你性子慢，反应速度不够快，可能会跟不上快节奏的工作或生活。',
	  'suggest': '1）遇到问题或挫折想要退缩，这是人的本能。但是一个人是在面对问题，解决问题的过程中成长的。下次遇到困难时，尝试把心中的“想要逃”转变成“我试试”，通过心理暗示获得迎难而上的信心；<br/><br/>2）有的时候，需要注意克制自己的抵触情绪以及无礼的言语和行为，加强自我调控，学会使用感情转化的心理调适方法来面对在观点不一发生争论的情况；<br/><br/>3）一定要保持学习，及时地更新你的知识系统，不然你在和朋友交往中会落伍。对你来说，向朋友学习是比较好的一种方式，保持开放的态度，学会大胆地尝试一些新事物。',
	  'match_jobs': '心理医生、办公室文员、行政工作'
	}, { 'key': 'Ps',
	  'sex': 'male',
	  'animal': '海獭',
	  'animal_en': 'Enhydralutris',
	  'pic': '../static/funreports/hailai/animal.png',
	  'tags': '随遇而安、三天打鱼两天晒网、愿望是世界和平、loveandpeace、人畜无害、做人咧最紧要开心、脾气好、心太软、天然呆',
	  'short_description': '海獭喜欢安定的生活，生活日常就是吃吃吃和梳理自己毛发，白天和小伙伴嬉闹，晚上还会手牵着手一起睡觉（其实是怕被海浪冲散）。你就像这样一个平和的小家伙，凭着友好随和的优势，你能很好融入群体，十分受人欢迎。',
	  'coordinate': '',
	  'basic_discription': '你性格温和有耐心，能很容易融入各种群体当中，甚至可以说，你到哪都讨人喜欢，受到大家欢迎。一开始接触，你的随和但不多言，会让他人误以为你是一个“安静的美男子”，但是久而久之，你的活跃个性开始在熟悉的人群中渐渐暴露，其实你也是一个多话的人。此外，你同情心强，很容易能感受他人的情绪，是一个不错的聆听者。在你的内心，害怕面对困难，常会有逃避的心态，往往很难坚持做好一件事情。',
	  'in_lover': '在感情方面，你是一个好好先生。脾气好、性格好，平和有耐心，总会安静地聆听对方，这让她感受到你满满真诚与爱意，自己是被尊重的。平常你们彼此的互动是比较平和的，没有什么吵吵闹闹，也没什么波澜壮阔。<br/><br/>不过你有时还是会做一些让她感觉浪漫感动的事情，给你们的感情来点小惊喜，尤其会在对方不开心的时候，想法设法帮她恢复好心情。虽然你比较崇尚自由，但你看重婚姻，只要认定了对方，你就会产生与对方步入婚姻殿堂的想法，因为你的内心是渴望家的温暖与安定。',
	  'in_friends': '在朋友眼中，你的个性很好，随和、耐心，但又不失风趣，从来都不会轻易骚扰朋友的生活。对朋友来说，你的存在总能让当下的氛围变得恰到好处，既不沉闷但却不过于喧闹。你善于聆听他人，也不乏表达的能力，能与大多类型的人进行良好的交往。同时，你的共情能力不错，懂得关心他人的感受，不过有的时候可能会成为朋友“坏情绪”的垃圾桶哦。',
	  'in_colleagues': '你能够很好地与其他同事相处，基本上你不会和他人发生冲突。当你看到其他同事需要帮助，甚至会主动去帮对方，所以一般在你需要求助的时候，好人缘的你总能在他人的帮助下顺利解决问题。此外，你活泼的性格能让团队紧张的氛围变得缓和轻松，促进团队的良好运作。<br/><br/>不过你的易妥协、难以做决定的个性，比较难承担那种最后阶段需要做决策的任务。另外，你的上进心不强，比起独立工作，你更愿意在他人的指导与安排下工作，不会主动去承担有挑战性的工作。',
	  'will_be': '在子女眼中，你的父亲形象是慈爱的，从不大声和子女说话。你崇尚民主，会主动倾听他们内心的声音。虽然你不会轻易子女做出承诺，但是一般你答应的事情都会说到做到，这样的你在子女心中比较有威信。但是你也有爱玩、孩子气的一面，这一面能让你的子女在心理上与你更加接近，是你受到他们喜爱的法宝。',
	  'advantage': '1）你的性格动静结合，该认真起来的时候，你能够安静地做事，在社交场合，你的活泼个性能让你在人群中混得开、吃得香；<br/><br/>2）你个性善良、愿意为人着想；<br/><br/>3）你善于把握与他人交往的距离，既不会过于侵犯他人的边界，但又不会与他人过于疏远；<br/><br/>4）你崇尚表达的自由，不干涉他人的客观态度，基本很少会和他人发生争吵；<br/><br/>5）你善于调节问题，充当“和事佬”的角色，保持着中立的态度。',
	  'shortcoming': '1）你容易在困难面前却步，只要事情有些阻力，你可能就立马产生放弃的念头，比较难坚持做一件事；<br/><br/>2）平日里你是个小懒虫，有很多事情你都懒得去想，懒得去理；<br/><br/>3）很好说话的你，比较难拒绝他人，有的时候容易被他人利用；<br/><br/>4）没有主见，容易受他人的影响而左右摇摆，要你做决定的时候纠结得要死。',
	  'suggest': '1）遇到问题或挫折想要退缩，这是人的本能。但是一个人是在面对问题，解决问题的过程中成长的。下次遇到困难时，尝试把心中的“想要逃”转变成“我试试”，通过心理暗示获得迎难而上的信心；<br/><br/>2）为自己平淡的生活制定一些目标，让每一天都过的有价值。你可以运用电脑桌面软件制定一个日、周、月计划表，要求自己今日事今日毕，必要时接受他人督促；<br/><br/>3）学会说“不”，首先，多想想自己真正想要的是什么，再者学会委婉拒绝的技巧，要知道一味地满足他人的要求或求助是没有主见的表现。',
	  'match_jobs': '心理医生，行政人员，公务员，老师'
	}, { 'key': 'Ps',
	  'sex': 'female',
	  'animal': '海獭',
	  'animal_en': 'Enhydralutris',
	  'pic': '../static/funreports/hailai/animal.png',
	  'tags': '随遇而安、三天打鱼两天晒网、愿望是世界和平、loveandpeace、人畜无害、做人咧最紧要开心、脾气好、心太软、天然呆',
	  'short_description': '海獭喜欢安定的生活，生活日常就是吃吃吃和梳理自己毛发，白天和小伙伴嬉闹，晚上还会手牵着手一起睡觉（其实是怕被海浪冲散）。你就像这样一个平和的小家伙，凭着友好随和的优势，你能很好融入群体，十分受人欢迎。',
	  'coordinate': '',
	  'basic_discription': '你性格温和有耐心，能很容易融入各种群体当中，甚至可以说，你到哪都讨人喜欢，受到大家欢迎。一开始接触，你的随和但不多言，会让他人误以为你是一个“安静的美男子”，但是久而久之，你的活跃个性开始在熟悉的人群中渐渐暴露，其实你也是一个多话的人。此外，你同情心强，很容易能感受他人的情绪，是一个不错的聆听者。在你的内心，害怕面对困难，常会有逃避的心态，往往很难坚持做好一件事情。',
	  'in_lover': '在感情方面，你是一个好说话的人，脾气好、性格好，平和有耐心，总会安静地聆听对方，这让他感受到你满满真诚与爱意，自己是被尊重的。平常你们彼此的互动是比较平和的，没有什么吵吵闹闹，也没什么波澜壮阔。<br/><br/>不过你有时还是会做一些让他感觉浪漫感动的事情，给你们的感情来点小惊喜，尤其会在对方不开心的时候，想法设法帮他恢复好心情。虽然你比较崇尚自由，但你看重婚姻，只要认定了对方，你就会产生与对方步入婚姻殿堂的想法，因为你的内心是渴望家的温暖与安定。',
	  'in_friends': '在朋友眼中，你的个性很好，随和、耐心，但又不失风趣，从来都不会轻易骚扰朋友的生活。对朋友来说，你的存在总能让当下的氛围变得恰到好处，既不沉闷但却不过于喧闹。你善于聆听他人，也不乏表达的能力，能与大多类型的人进行良好的交往。同时，你的共情能力不错，懂得关心他人的感受，不过有的时候可能会成为朋友“坏情绪”的垃圾桶哦。',
	  'in_colleagues': '你能够很好地与其他同事相处，基本上你不会和他人发生冲突。当你看到其他同事需要帮助，甚至会主动去帮对方，所以一般在你需要求助的时候，好人缘的你总能在他人的帮助下顺利解决问题。此外，你活泼的性格能让团队紧张的氛围变得缓和轻松，促进团队的良好运作。<br/><br/>不过你的易妥协、难以做决定的个性，比较难承担那种最后阶段需要做决策的任务。另外，你的上进心不强，比起独立工作，你更愿意在他人的指导与安排下工作，不会主动去承担有挑战性的工作。',
	  'will_be': '在子女眼中，你的母亲形象是慈爱的，从不大声和子女说话。你崇尚民主，会主动倾听他们内心的声音。虽然你不会轻易子女做出承诺，但是一般你答应的事情都会说到做到，这样的你在子女心中比较有威信。但是你也有爱玩、孩子气的一面，这一面能让你的子女在心理上与你更加接近，是你受到他们喜爱的法宝。',
	  'advantage': '1）你的性格动静结合，该认真起来的时候，你能够安静地做事，在社交场合，你的活泼个性能让你在人群中混得开、吃得香；<br/><br/>2）你个性善良、愿意为人着想；<br/><br/>3）你善于把握与他人交往的距离，既不会过于侵犯他人的边界，但又不会与他人过于疏远；<br/><br/>4）你崇尚表达的自由，不干涉他人的客观态度，基本很少会和他人发生争吵；<br/><br/>5）你善于调节问题，充当“和事佬”的角色，保持着中立的态度。',
	  'shortcoming': '1）你容易在困难面前却步，只要事情有些阻力，你可能就立马产生放弃的念头，比较难坚持做一件事；<br/><br/>2）平日里你是个小懒虫，有很多事情你都懒得去想，懒得去理；<br/><br/>3）很好说话的你，比较难拒绝他人，有的时候容易被他人利用；<br/><br/>4）没有主见，容易受他人的影响而左右摇摆，要你做决定的时候纠结得要死。',
	  'suggest': '1）遇到问题或挫折想要退缩，这是人的本能。但是一个人是在面对问题，解决问题的过程中成长的。下次遇到困难时，尝试把心中的“想要逃”转变成“我试试”，通过心理暗示获得迎难而上的信心；<br/><br/>2）为自己平淡的生活制定一些目标，让每一天都过的有价值。你可以运用电脑桌面软件制定一个日、周、月计划表，要求自己今日事今日毕，必要时接受他人督促；<br/><br/>3）学会说“不”，首先，多想想自己真正想要的是什么，再者学会委婉拒绝的技巧，要知道一味地满足他人的要求或求助是没有主见的表现。',
	  'match_jobs': '心理医生，行政人员，公务员，老师'
	}, { 'key': 'Pm',
	  'sex': 'male',
	  'animal': '小熊猫',
	  'animal_en': 'Ailurusfulgens',
	  'pic': '../static/funreports/xiaoxiongmao/animal.png',
	  'tags': '选择困难、吃瓜群众、被动型、后知后觉、慢半拍、斯斯文文、低调、有自己的小天地、温和不刺激、天然无伤害',
	  'short_description': '小熊猫性情温顺，很少出声，有着固定的活动地点。它们喜爱清洁，常常整理自己皮毛，而你也习惯在人群中保持低调的个性，同时喜欢规律生活，甚至到了有点完美主义的地步。虽然看上去你像小熊猫一样有点天然呆，但是环境的适应性却十分好！',
	  'coordinate': '',
	  'basic_discription': '你和善、有耐心，能获得大多数人的好感，再加上有组织、有秩序的一面，你能够在群体中很好地融入进去。你为人低调，基本上不会在团队中承担重要的角色，不过这也迎合了你不愿成为焦点人物的心态。你的冷静往往在行为上表现为比别人慢半拍。虽然你不多言，但你的内心其实很多事情都清楚，甚至能够看到别人容易忽略的部分。',
	  'in_lover': '在感情方面，你崇尚的是一段和平、安静的关系，不适合打打闹闹的恋爱，更愿意从琐碎的生活中体会你们的爱情。在你的另一半看来，你是一个过日子的人，脾气好、性格也不错，会打从内心里为她着想，体贴人，但是就是少了点浪漫。其实你的内心还是有些期许和激动，只是不善于表达而已。你的情感挺细腻，会对某些反应敏感，有的时候会莫名地情绪低落，会让对方有些难以捉摸。',
	  'in_friends': '对于朋友而言，你是一个为人平和、善良的人，和你在一起会感到舒适自在。你不算多话，一开始可能会觉得你比较“冷”，但是接触下来会发现你只是比较慢热，熟络后会发现你的心地善良，很为他人着想，也常帮助身边的朋友。你是一个不错的聆听者，不少朋友都愿意和你交心。平常的你很平和，但是如果他人在重要的事情上冒犯了你，你可能会反应比较大。你的心情比较容易受到外界影响而波动，情绪上来的时候，会让朋友不知道如何和你相处。',
	  'in_colleagues': '你懂得与同事如何相处，总能和他们保持着良好的关系，很少会和其他同事发生争吵，秉承着和平相处，不惹事端的态度待人处事。你是团队中的聆听者，协调者，往往在团队中发生分歧或前进方向不明朗的时候，你能够把握好细节，给出的建议能够切中要害，非常实用。不过比起主动承担或主导重要的任务，你更愿意协助其他人，把事情做好。在领导眼中，难免会显得不够上进。',
	  'will_be': '在子女的眼中，你是一个比较亲和、安静的父亲，你的眼光总是充满慈爱，即使子女犯错了，你也比较少会斥责他们，但不代表你对他们没有要求，作为轻微“洁癖”的家长，你会给你的孩子订立一些标准。例如，卫生要自己做好，不容许东西随处乱放，学习需要达到XX标准。另外，你不会轻易子女做出承诺，但是一般你答应的事情都会说到做到，这样的你在子女心中比较有威信。',
	  'advantage': '1）你的外在表现冷静，但却不会阴郁，在他人的眼中是一个易于相处的人，和你交谈总会有一种自在的感觉；<br/><br/>2）你对人宽容，性格温和的你，基本很少会和他人争论，能和大多数的人友好相处；<br/><br/>3）你热心助人，对别人关心体贴，容易发现他人的难处并主动帮助。',
	  'shortcoming': '1）在做决定的时候，显得困难，在这方面比较迟缓，甚至会因此耽搁事情；<br/><br/>2）内向的你容易在某些时候表现沉默，这让他人会感觉与你距离较远；<br/><br/>3）你的性子慢，反应速度不快，有时难以跟上生活的快速节奏；<br/><br/>4）你常常想的太多，却缺乏做事情的行动力。',
	  'suggest': '1）你需要学会提高自己的决策能力，克服自己遇事逃避的缺点，勇于开始，对失败持有正确的观念；<br/><br/>2）你可以多与他人进行沟通，不要隐藏自己的意见或内心感受，过多的沉默会把你与他人的距离拉开得更远；<br/><br/>3）在与他人相处的时候，你可以多些不一样的改变，尽力去尝试些新鲜事物，这样会给你的人际或感情生活带来不一样的体验。',
	  'match_jobs': '行政人员、教师、艺术家、画家'
	}, { 'key': 'Pm',
	  'sex': 'female',
	  'animal': '小熊猫',
	  'animal_en': 'Ailurusfulgens',
	  'pic': '../static/funreports/xiaoxiongmao/animal.png',
	  'tags': '选择困难、吃瓜群众、被动型、后知后觉、慢半拍、斯斯文文、低调、有自己的小天地、温和不刺激、天然无伤害',
	  'short_description': '小熊猫性情温顺，很少出声，有着固定的活动地点。它们喜爱清洁，常常整理自己皮毛，而你也习惯在人群中保持低调的个性，同时喜欢规律生活，甚至到了有点完美主义的地步。虽然看上去你像小熊猫一样有点天然呆，但是环境的适应性却十分好！',
	  'coordinate': '',
	  'basic_discription': '你和善、有耐心，能获得大多数人的好感，再加上有组织、有秩序的一面，你能够在群体中很好地融入进去。你为人低调，基本上不会在团队中承担重要的角色，不过这也迎合了你不愿成为焦点人物的心态。你的冷静往往在行为上表现为比别人慢半拍。虽然你不多言，但你的内心其实很多事情都清楚，甚至能够看到别人容易忽略的部分。',
	  'in_lover': '在感情方面，你崇尚的是一段和平、安静的关系，不适合打打闹闹的恋爱，更愿意从琐碎的生活中体会你们的爱情。在你的另一半看来，你是一个过日子的人，脾气好、性格也不错，会打从内心里为他着想，体贴人，但是就是少了点浪漫。其实你的内心还是有些期许和激动，只是不善于表达而已。你的情感挺细腻，会对某些反应敏感，有的时候会莫名地情绪低落，会让对方有些难以捉摸。',
	  'in_friends': '对于朋友而言，你是一个为人平和、善良的人，和你在一起会感到舒适自在。你不算多话，一开始可能会觉得你比较“冷”，但是接触下来会发现你只是比较慢热，熟络后会发现你的心地善良，很为他人着想，也常帮助身边的朋友。你是一个不错的聆听者，不少朋友都愿意和你交心。平常的你很平和，但是如果他人在重要的事情上冒犯了你，你可能会反应比较大。你的心情比较容易受到外界影响而波动，情绪上来的时候，会让朋友不知道如何和你相处。',
	  'in_colleagues': '你懂得与同事如何相处，总能和他们保持着良好的关系，很少会和其他同事发生争吵，秉承着和平相处，不惹事端的态度待人处事。你是团队中的聆听者，协调者，往往在团队中发生分歧或前进方向不明朗的时候，你能够把握好细节，给出的建议能够切中要害，非常实用。不过比起主动承担或主导重要的任务，你更愿意协助其他人，把事情做好。在领导眼中，难免会显得不够上进。',
	  'will_be': '在子女的眼中，你是一个比较亲和、安静的妈妈，你的眼光总是充满慈爱，即使子女犯错了，你也比较少会斥责他们，但不代表你对他们没有要求，作为轻微“洁癖”的家长，你会给你的孩子订立一些标准。例如，卫生要自己做好，不容许东西随处乱放，学习需要达到XX标准。另外，你不会轻易子女做出承诺，但是一般你答应的事情都会说到做到，这样的你在子女心中比较有威信。',
	  'advantage': '1）你的外在表现冷静，但却不会阴郁，在他人的眼中是一个易于相处的人，和你交谈总会有一种自在的感觉；<br/><br/>2）你对人宽容，性格温和的你，基本很少会和他人争论，能和大多数的人友好相处；<br/><br/>3）你热心助人，对别人关心体贴，容易发现他人的难处并主动帮助。',
	  'shortcoming': '1）在做决定的时候，显得困难，在这方面比较迟缓，甚至会因此耽搁事情；<br/><br/>2）内向的你容易在某些时候表现沉默，这让他人会感觉与你距离较远；<br/><br/>3）你的性子慢，反应速度不快，有时难以跟上生活的快速节奏；<br/><br/>4）你常常想的太多，却缺乏做事情的行动力。',
	  'suggest': '1）你需要学会提高自己的决策能力，克服自己遇事逃避的缺点，勇于开始，对失败持有正确的观念；<br/><br/>2）你可以多与他人进行沟通，不要隐藏自己的意见或内心感受，过多的沉默会把你与他人的距离拉开得更远；<br/><br/>3）在与他人相处的时候，你可以多些不一样的改变，尽力去尝试些新鲜事物，这样会给你的人际或感情生活带来不一样的体验。',
	  'match_jobs': '行政人员、教师、艺术家、画家'
	}, { 'key': 'mc',
	  'sex': 'male',
	  'animal': '狼',
	  'animal_en': 'Canislupus',
	  'pic': '../static/funreports/lang/animal.png',
	  'tags': '最长的路是你的套路、高冷、干(丧)得(心)漂(病)亮(狂)、大BOSS、幕后指挥、毒舌、条理清晰、契约精神',
	  'short_description': '狼严格恪守着狼群的规则和等级制度，而你则和狼一样，对待事物谨慎细致，对于目标有追求有决心，在团队中有着高度的纪律性和组织性，一旦决定了方向，你总能达到目的。',
	  'coordinate': '',
	  'basic_discription': '在工作事务和人际关系两者中，你是工作事务导向型，也就是说，比起搞好人际关系，你认为做好实事才是更为重要的。完美型与力量型结合的你是最佳的商业人才，一方面，你善于分析、对细节敏感、头脑清晰有条理；而另一方面，你具备领导才能，有着自己的目标和野心。对你来说，没有什么事情是做不来的，在工作上，你有时会有近乎变态的完美主义苛求，但好在你具有坚定的目标和执行力，这在很大程度上能帮助你达成愿望。当朝着正确的方向进发时，力量型/完美型的你总是最容易成功的。',
	  'in_lover': '感情中比较挑剔，情感很丰富，对另一半的要求很高，喜欢清单式列出你的理想标准并逐条对比。在爱情关系中占据支配和把控的地位。同时，你的理想主义也伴随着牺牲精神，但这会在关系决断时戛然而止，爱情中敢爱敢恨，不拖泥带水。',
	  'in_friends': '你不是那种和其他人都自来熟，走到哪里都有很多朋友的人。但作为一个气场强大的人，你能从工作或其他事物中找到很多乐趣。为了工作你能牺牲很多。虽然你朋友不多，但现有的朋友交往真诚而有深度，这是因为你谨小慎微的性格导致了你交友慎重。成为你的朋友其实是幸福的，因为你忠实可靠，会为了朋友而甘心听对方的牢骚，为Ta解决实际问题。如果你的朋友是个感性的人，那么Ta会从你这里得到很多中肯的建议。',
	  'in_colleagues': '工作上你简直是“细节控”，见到乱、不美观的事物你会非常难受。工作中你擅长预先做计划，并且目标性强，是强迫性工作者，遇到困难擅长分析和思考，能够理性对待实际的问题，并寻找替代性的解决方法。',
	  'will_be': '作为父母，你绝不容许自己的家里乱糟糟的。对干净和整洁的高要求让你显得具有轻微强迫症。你的组织和管理能力同样适用于家里，能把家里打造得井井有条。你很注重你的家长权威性，对子女常使用命令式的语气，但同时你非常具有自我牺牲精神，虽然会批评或指责孩子，但你还是会不断的为Ta操心操力。',
	  'advantage': '1）你是天生的思考者，看待事物不会只停留在表面，常常能分析深层的原理，因而你能看到比一般人更多的内涵和内容；<br/><br/>2）你对工作有着自己的主见和看法，常常能坚持自己的原则与立场，不会轻易被他人左右；<br/><br/>3）工作上有目的，有条理的你能提高组织的工作效率，常能因此赢得他人的尊重。',
	  'shortcoming': '1）若你的完美主义太过极端，你会很容易钻牛角尖，进而可能会引起情绪低落，容易抑郁；<br/><br/>2）太注重工作等客观事物的你，容易忽视身边的人的感受，难以设身处地站在他人的角度去看待问题。这可能会使你的人际关系不是十分融洽，因为你会无形中给人压力，工作中难以找到交心的朋友；<br/><br/>3）你对他人的要求有时候不切实际。这在与你不熟的人看来，你是一个冷酷而很少人情味的人，但是了解你的朋友知道，你只是就事论事，这源于你对自己的严苛要求，所以你会以同样的标准去要求他人，目的是让事物往最好的方向发展；<br/><br/>4）对细节的过度在意有时候会让你在工作上停滞不前，或是花费很长一段时间来完成一项工作，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。但是这一缺点在力量型性格的缓和下能有所改善，你的执行力能帮助你促进事物的进展；<br/><br/>5）处事过于果断容易让你在他人的眼中形成专横和傲慢的不良印象。',
	  'suggest': '1）学会放松，减轻对别人的压力。追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让你周围的人产生可怕的压力；<br/><br/>2）遇错学会道歉。不同的人看到的世界不一样，这都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉，会让你显得更为平易近人；<br/><br/>3）降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和他人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准；<br/><br/>4）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以通过看电视，进行其他活动等来转移注意力。',
	  'match_jobs': '科研方面的工作，专家，分析者，规划者，记录者，律师等'
	}, { 'key': 'mc',
	  'sex': 'female',
	  'animal': '狼',
	  'animal_en': 'Canislupus',
	  'pic': '../static/funreports/lang/animal.png',
	  'tags': '最长的路是你的套路、高冷、干(丧)得(心)漂(病)亮(狂)、大BOSS、幕后指挥、毒舌、条理清晰、契约精神',
	  'short_description': '狼严格恪守着狼群的规则和等级制度，而你则和狼一样，对待事物谨慎细致，对于目标有追求有决心，在团队中有着高度的纪律性和组织性，一旦决定了方向，你总能达到目的。',
	  'coordinate': '',
	  'basic_discription': '在工作事务和人际关系两者中，你是工作事务导向型，也就是说，比起搞好人际关系，你认为做好实事才是更为重要的。完美型与力量型结合的你是最佳的商业人才，一方面，你善于分析、对细节敏感、头脑清晰有条理；而另一方面，你具备领导才能，有着自己的目标和野心。对你来说，没有什么事情是做不来的，在工作上，你有时会有近乎变态的完美主义苛求，但好在你具有坚定的目标和执行力，这在很大程度上能帮助你达成愿望。当朝着正确的方向进发时，力量型/完美型的你总是最容易成功的。',
	  'in_lover': '感情中比较挑剔，情感很丰富，对另一半的要求很高，喜欢清单式列出你的理想标准并逐条对比。在爱情关系中占据支配和把控的地位。同时，你的理想主义也伴随着牺牲精神，但这会在关系决断时戛然而止，爱情中敢爱敢恨，不拖泥带水。',
	  'in_friends': '你不是像交际花一样的人，因而并不是走到哪里都有很多朋友。但作为一个气场强大的人，你能从工作或其他事物中找到很多乐趣。为了工作你能牺牲很多。你朋友不多，但现有的朋友交往真诚而有深度，这是因为你谨小慎微的性格导致了你交友慎重。作为你的朋友实际幸福的，因为你忠实可靠，会为了朋友会甘心听对方的牢骚，为Ta解决实际问题。如果你的朋友时感性的，那么Ta会从你这里得到很多中肯的建议。',
	  'in_colleagues': '工作上你简直是“细节控”，见到乱、不美观的事物你会非常难受。工作中你擅长预先做计划，并且目标性强，是强迫性工作者，遇到困难擅长分析和思考，能够理性对待实际的问题，并寻找替代性的解决方法。',
	  'will_be': '作为父母，你绝不容许自己的家里乱糟糟的。对干净和整洁的高要求让你显得具有轻微强迫症。你的组织和管理能力同样适用于家里，能把家里打造得井井有条。你很注重你的家长权威性，对子女常使用命令式的语气，但同时你非常具有自我牺牲精神，虽然会批评或指责孩子，但你还是会不断的为Ta操心操力。',
	  'advantage': '1）你是天生的思考者，看待事物不会只停留在表面，常常能分析深层的原理，因而你能看到比一般人更多的内涵和内容；<br/><br/>2）你对工作有着自己的主见和看法，常常能坚持自己的原则与立场，不会轻易被他人左右；<br/><br/>4）工作上有目的，有条理的你能提高组织的工作效率，常能因此赢得他人的尊重。',
	  'shortcoming': '1）若你的完美主义太过极端，你会很容易钻牛角尖，进而可能会引起情绪低落，容易抑郁；<br/><br/>2）太注重工作等客观事物的你，容易忽视身边的人的感受，难以设身处地站在他人的角度去看待问题。这可能会使你的人际关系不是十分融洽，因为你会无形中给人压力，工作中难以找到交心的朋友；<br/><br/>3）你对他人的要求有时候不切实际。这在与你不熟的人看来，你是一个冷酷而很少人情味的人，但是了解你的朋友知道，你只是就事论事，这源于你对自己的严苛要求，所以你会以同样的标准去要求他人，目的是让事物往最好的方向发展；<br/><br/>4）对细节的过度在意有时候会让你在工作上停滞不前，或是花费很长一段时间来完成一项工作，如果事情没有达到你的要求，你会一直反复修改，直到你满意为止。但是这一缺点在力量型性格的缓和下能有所改善，你的执行力能帮助你促进事物的进展；<br/><br/>5）处事过于果断容易让你在他人的眼中形成专横和傲慢的不良印象。',
	  'suggest': '1）学会放松，减轻对别人的压力。追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让你周围的人产生可怕的压力；<br/><br/>2）遇错学会道歉。不同的人看到的世界不一样，这都是受各自的经验所限，没有绝对的对与错之分。当自己的确做错或说错了某件事时，承认它并放低姿态道歉，会让你显得更为平易近人；<br/><br/>3）降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和他人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准；<br/><br/>4）多从正面去看待问题，认识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，让你的思维暂停，不要陷入到循环的冗思中。你可以通过看电视，进行其他活动等来转移注意力。',
	  'match_jobs': '科研方面的工作，专家，分析者，规划者，记录者，律师等'
	}, { 'key': 'ms',
	  'sex': 'male',
	  'animal': '苏格兰牧羊犬',
	  'animal_en': 'RoughCollie',
	  'pic': '../static/funreports/sumu/animal.png',
	  'tags': '闷骚、外冷内热、好奇、吐槽担当、口嫌体正直、难以捉摸、艺术气质、规划性强',
	  'short_description': '苏格兰牧羊犬擅长交际，平常完全不会显露出软弱或攻击性的一面，和待人友好的你有着相似的一面。而当工作时，苏牧十分警觉，前倾的耳朵能听见半公里以外的声音，这种专注工作、对细节严苛的性格也和你极为相像。',
	  'coordinate': '',
	  'basic_discription': '一般来说，你在工作或者事务上有着近乎完美的要求，会留意到他人较少注意到的细节，对于工作所要达成的效果有自己的要求和标准。但是你并不完全是典型的完美主义者，主要表现在你并不内敛沉闷，在工作之余，你乐于与他人交往和互动，与他人交往也是友好而亲切的，尤其在朋友面前，你热衷于自我表达，讲起话来可以滔滔不绝。',
	  'in_lover': '作为你的另一半（或将来的另一半），她可能时常会在你这边收获惊喜。你看问题比较深刻，如果你恰好爱好读书或者看电影，那么她很容易对你心生崇拜，因为你总能讲出电影中她不曾注意的细节，或者你能够解答她没有理清楚的逻辑。<br/><br/>同时，她和你在一起很难冷场，因为你是一个“动静咸宜”的人，既能和她一起聊人生，又能和她一起打打闹闹。她能在你这里看到多方面的你，因而和你在一起的她会收获很多惊喜。<br/><br/>但是有一点需要注意，你的情绪可能会随外界而有比较大的起伏，有时候你会表现得情绪高涨，任何事情在你眼中都可能变得很美好；有时你可能会走入死胡同，导致情绪低落甚至偏向抑郁。如果这时候的她能体谅你，读懂你，那她一定是你的真爱，还犹豫什么，娶了吧！',
	  'in_friends': '你的朋友说多不多，说少也不少。一方面你对交友有一套自己的底线或标准，对朋友的选择比较慎重。另一方面，你很容易对他人表达你的善意。作为你的朋友，Ta有时候难以捉摸你，因为你所表达出来的善意让Ta觉得你是一个很好相处的人，但是真正交往起来之后，会发现你会有很多标准和要求，而这种标准你会通过很多言语或非言语性方式表达出来。比如，他看到你工作台很乱，可能会说，你就不能把这里弄整洁一点吗？有时候你的标准和要求能让你的朋友信服，从而加以改进，但有时候当你的这种标准太严苛和主观时会给人方案，这种主观性有时候表现在聊天交友的角色定位中，如果你一直只关注自己想要的聊天内容而忽视对方的感受的话，那么你需要警惕了，适当站在对方的角度上思考是必要的。',
	  'in_colleagues': '在你的同事眼中，你是一个“靠得住”的人。你对工作有自己的标准和要求，在细节上的处理优于其他人，对领导来说是一个得力的手下干将，Ta会乐于交付你一些重要的事。而对于你的同事而言，你是一个他们乐于一起共事的人。事实上，在工作中你虽然有所要求，但你并没有强烈的竞争欲望，在工作之外，你也能和同事们相处良好。需要注意的是，你的思维比较跳脱，内敛和外放的风格切换有时会给人带来一些困惑。',
	  'will_be': '作为轻微“洁癖”的家长，你会给你的孩子订立一些标准。例如，卫生要自己做好，东西不能随处乱放，学习需要达到XX标准。但是，难道在孩子的眼中，你真的是一个严父吗？未必。你有活泼型的幽默风趣，这是你和孩子交流的有效润滑剂。<br/><br/>你的内心保有孩童时的天真，你们之间有跨越年龄的“友谊”。当另一半比较严肃的时候，孩子很有可能和你打成阵营。在你的孩子眼中，你既是严师，也是益友，如果你能让孩子明白哪些事情可以开玩笑，哪些事情需要严肃对待，那么你和孩子的关系将更加和睦融洽。',
	  'advantage': '1)你是一个习惯思考的人，看待事物不会浮于表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)对待工作和其他事物你比较有主见，处理事情条理也比较清晰，对做事情有自己的标准，容易督促事情向好的方面发展；<br/><br/>3）内心比较热情，与人交往时，你能通过制造或参与话题来活跃气氛，给人轻松愉悦的感觉。',
	  'shortcoming': '1）如果你把工作中的完美主义带到生活中，你可能会难以得到他人理解；而如果你把与人相处时的活泼性带到工作中，则可能导致工作无法很好地完成。同时，如果不能顺畅切换，你也容易经常陷入自我纠结；<br/><br/>2）对细节的过度在意有时候会让你工作上停滞不前，假如事情没有达到你的设想的标准，你会修改到你满意为止。而你又常常坐不住，所以事情往往会搁置不前；<br/><br/>3）关注自我的你，有时候会过于关注自己想要聊的话题，只顾着自己滔滔不绝，却忽略了其他人的感受；<br/><br/>4）你比较容易情绪化，情绪容易高涨，也容易低沉，在与人交往时会让人对你产生距离。因为对方如果不是太了解你的话，很难摸清楚你的脾气；<br/><br/>5）当你的完美主义太过极端，你会容易钻牛角尖，从而引起情绪低落，容易抑郁；<br/><br/>6）你的记性有时候很差，经常丢三落四，找不见东西或记不住名字是常有的事。',
	  'suggest': '1）学会合理运用完美型和活泼型两种不同的特质，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当需要你在工作和交往两种状态中过渡时，你可能感觉到困惑，无法专心于工作或是对他人表现出冷淡严谨的一面，建议你先静下心来，学会自我调整；<br/><br/>2）遇错学会道歉。每个人的观点都是基于各自的经验形成的，没有绝对的对错之分。当你确实做了不恰当的事情时，不妨放下你的执拗，勇敢承认它并放低姿态道歉；<br/><br/>3）积极看待问题，意识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，避免陷入到死循环中；<br/><br/>4）说话讲重点，就事论事。当与人交谈时，关注对方发出的的信号，当你发现别人试图绕开你的聊天内容时，对方可能对你想要讲的话题缺乏兴趣，这时请尽量压缩你的谈话内容；<br/><br/>5）结识新人时多花点功夫记忆对方的名字。你需要意识到，当你见面不久就能叫出别人的名字，对方会感到被尊重，乐于与你交往；但总也记不住别人的名字则会让人觉得你没把Ta当回事。对于容易忘事的你来说，将对方的名字和对应特征记在便签上不失为一个办法；<br/><br/>6）适当关注他人的需求。要成为对方真正想要的朋友，你就不能仅仅把他人当成你的听众，而要学会倾听对方。',
	  'match_jobs': '全能'
	}, { 'key': 'ms',
	  'sex': 'female',
	  'animal': '苏格兰牧羊犬',
	  'animal_en': 'RoughCollie',
	  'pic': '../static/funreports/sumu/animal.png',
	  'tags': '闷骚、外冷内热、好奇、吐槽担当、口嫌体正直、难以捉摸、艺术气质、规划性强',
	  'short_description': '苏格兰牧羊犬擅长交际，平常完全不会显露出软弱或攻击性的一面，和待人友好的你有着相似的一面。而当工作时，苏牧十分警觉，前倾的耳朵能听见半公里以外的声音，这种专注工作、对细节严苛的性格也和你极为相像。',
	  'coordinate': '',
	  'basic_discription': '一般来说，你在工作或者事务上有着近乎完美的要求，会留意到他人较少注意到的细节，对于工作所要达成的效果有自己的要求和标准。但是你并不完全是典型的完美主义者，主要表现在你并不内敛沉闷，在工作之余，你乐于与他人交往和互动，与他人交往也是友好而亲切的，尤其在朋友面前，你热衷于自我表达，讲起话来可以滔滔不绝。',
	  'in_lover': '作为你的另一半（或将来的另一半），他可能时常会在你这边收获惊喜。完美型的你其实自身颇有内涵，并不像其他女生一样看问题只关注表面，闲暇时间你会有一些自己的爱好和活动，用以提高自己的见识和修养。<br/><br/>他和你在一起，可能最初被你的个性所吸引，随之爱上你的内在，或者最初爱上你的内在，随后喜欢上你的个性。不论是哪一种，随着交往的深入，他能发现不同的你，收获不一样的惊喜。<br/><br/>但是有一点需要注意，你的情绪可能会随外界而有比较大的起伏，有时候你会表现的情绪很高涨，任何事情在你眼中都可能变得很美好；有时你可能会走入死胡同，导致情绪低落甚至偏向抑郁。如果这时候的他能体谅你，读懂你，那他一定是你的真爱，还犹豫什么，嫁了吧！',
	  'in_friends': '你的朋友说多不多，说少也不少。一方面你对交友有一套自己的底线或标准，对朋友的选择比较慎重。另一方面，你很容易对他人表达你的善意。作为你的朋友，Ta有时候难以捉摸你，因为你所表达出来的善意让Ta觉得你是一个很好相处的人，但是真正交往起来之后，会发现你会有很多标准和要求，而这种标准你会通过很多言语或非言语性方式表达出来。比如，他看到你工作台很乱，可能会说，你就不能把这里弄整洁一点吗？有时候你的标准和要求能让你的朋友信服，从而加以改进，但有时候当你的这种标准太严苛和主观时会给人方案，这种主观性有时候表现在聊天交友的角色定位中，如果你一直只关注自己想要的聊天内容而忽视对方的感受的话，那么你需要警惕了，适当站在对方的角度上思考是必要的。',
	  'in_colleagues': '在你的同事眼中，你是一个“靠得住”的人。你对工作有自己的标准和要求，在细节上的处理优于其他人。这对于你的领导来说，你是一个得力的手下干将，Ta会乐于交付你一些重要的事。而对于你的同事而言，你是一个他们乐于一起共事的人。事实上，在工作中你虽然有所要求，但你并没有强烈的竞争欲望，在工作之外，你也能和同事们相处良好。需要注意的是，你的思维比较跳脱，内敛和外放的风格切换有时会给人带来一些困惑。',
	  'will_be': '作为轻微“洁癖”的家长，你会给你的孩子订立一些标准。例如，卫生要自己做好，不容许东西随处乱放，学习需要达到XX标准。但是，难道在孩子的眼中，你真的是一个虎妈吗？未必。你有活泼型的幽默风趣，这是你和孩子交流的有效润滑剂。<br/><br/>你的内心保有孩童时的天真，你们之间有跨越年龄的“友谊”。当另一半比较严肃的时候，孩子很有可能和你打成阵营。在你的孩子眼中，你既是严师，也是益友，如果你能让孩子明白哪些事情可以开玩笑，哪些事情需要严肃对待，那么你和孩子的关系将更加和睦融洽。',
	  'advantage': '1)你是一个习惯思考的人，看待事物不会浮于表面，相比于其他人，你可能更容易看到事物的本质问题；<br/><br/>2)对待工作和其他事物你比较有主见，处理事情条理也比较清晰，对做事情有自己的标准，容易督促事情向好的方面发展；<br/><br/>3）内心比较热情，与人交往时，你能通过制造或参与话题来活跃气氛，给人轻松愉悦的感觉。',
	  'shortcoming': '1）如果你把工作中的完美主义带到生活中，你可能会难以得到他人理解；而如果你把与人相处时的活泼性带到工作中，则可能导致工作无法很好地完成。同时，如果不能顺畅切换，你也容易经常陷入自我纠结；<br/><br/>2）对细节的过度在意有时候会让你工作上停滞不前，假如事情没有达到你的设想的标准，你会修改到你满意为止。而你又常常坐不住，所以事情往往会搁置不前；<br/><br/>3）关注自我的你，有时候会过于关注自己想要聊的话题，只顾着自己滔滔不绝，却忽略了其他人的感受；<br/><br/>4）你比较容易情绪化，情绪容易高涨，也容易低沉，在与人交往时会让人对你产生距离。因为对方如果不是太了解你的话，很难摸清楚你的脾气；<br/><br/>5）当你的完美主义太过极端，你会容易钻牛角尖，从而引起情绪低落，容易抑郁；<br/><br/>6）你的记性有时候很差，经常丢三落四，找不见东西或记不住名字是常有的事。',
	  'suggest': '1）学会合理运用完美型和活泼型两种不同的特质，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当需要你在工作和交往两种状态中过渡时，你可能感觉到困惑，无法专心于工作或是对他人表现出冷淡严谨的一面，建议你先静下心来，学会自我调整；<br/><br/>2）遇错学会道歉。每个人的观点都是基于各自的经验形成的，没有绝对的对错之分。当你确实做了不恰当的事情时，不妨放下你的执拗，勇敢承认它并放低姿态道歉；<br/><br/>3）积极看待问题，意识到没有人喜欢阴沉和充满负能量的人。当事情发展不如自己想象中那样完美时，避免陷入到死循环中；<br/><br/>4）说话讲重点，就事论事。当与人交谈时，关注对方发出的的信号，当你发现别人试图绕开你的聊天内容时，对方可能对你想要讲的话题缺乏兴趣，这时请尽量压缩你的谈话内容；<br/><br/>5）结识新人时多花点功夫记忆对方的名字。你需要意识到，当你见面不久就能叫出别人的名字，对方会感到被尊重，乐于与你交往；但总也记不住别人的名字则会让人觉得你没把Ta当回事。对于容易忘事的你来说，将对方的名字和对应特征记在便签上不失为一个办法；<br/><br/>6）适当关注他人的需求。要成为对方真正想要的朋友，你就不能仅仅把他人当成你的听众，而要学会倾听对方。',
	  'match_jobs': '全能'
	}, { 'key': 'mp',
	  'sex': 'male',
	  'animal': '天鹅',
	  'animal_en': 'Cygnus',
	  'pic': '../static/funreports/tiane/animal.png',
	  'tags': '傲娇、有气质、人畜无害、低调、家里蹲、尴尬癌、理性派、注重细节、习惯性拖延',
	  'short_description': '表面看来，天鹅优雅淡定，但其实天鹅在湖底下的双脚却在不断地划水，因为——你必须竭尽全力，才能看起来毫不费力！这就好比是对自我管理有要求的你，总是保持着从容的姿态，但对待工作却十分认真细致。',
	  'coordinate': '',
	  'basic_discription': '通常情况下，你做事比较认真，能将问题看得很通透，但你不会去抢风头，因为你并不愿意成为焦点人物。你一方面会注重追求自己的标准，另一方面又乐于享受平稳的生活，不会过于激进和苛求。这两种性格能相互作用，互相补充，使得你善于学习和研究，又善于待人接物，很有潜力成为一名教育工作者。但你对目标的追求有时不够坚定，在遇到挫折时容易转向随和、无所谓的心态，缺乏一种锐意进取的精神。',
	  'in_lover': '做你女朋友挺幸福的，如果你问她，你到底喜欢我哪一点，她可能会回答说，因为你让我感觉很安心。<br/><br/>你对自我有追求，对待工作或学习也常常是一丝不苟的，你的魅力散发在你认真做事情的时候。同时，你很少有情绪上的歇斯底里，这种平和的性格能给你们的爱情添上防护的外衣，你们很少会因为感情问题而进行激烈的争论。<br/><br/>如果她认为你们是自然吸引的，那其实不太正确，因为她其实是通过了你某些鉴定标准的，这也从侧面反映出了你的伴侣是优秀的。同样的，你对自己也有一定的标准和要求，但是当要求没有达到时，你未必会将失落表现出来，相反，你很可能会选择沉默，这时候会让对方产生困惑。如果你们能够向对方敞开心扉，并给予支持，那么你们将拥有更和谐的伴侣关系。',
	  'in_friends': '你是一个人际关系不错的人。在朋友的眼里，你是一个信得过的朋友，因为你是一个不错的倾听者，也从来不会在他人面前说三道四。在人际关系方面，你最大的优点是“无过”，因此很少树敌。这种中立客观又和平淡然的性格能赢得他人的亲近。但其实，你也是“择人而交”的，你在心里有自己的一套交友准则，能走进你内心的人并不多。',
	  'in_colleagues': '你既可以做宏观把控的角色，也可以做关注细节，配合他人的“拧螺丝”角色。一方面，要求完美的你有目标，肯追求，适合掌握大方向，在你手下出来的产品一定是过关的；另一方面，和平处事的风格让你能和同事良好相处，形成配合。此外，你从不会在工作中乱嚼舌根，也不会肆意插手他人的事情，懂得尊重他人，能在很大程度上赢得同事的好感。',
	  'will_be': '作为家长，你希望自己家中能够像工作中那样干净整洁，一切都井然有序，因而你会给你的孩子适当订立某些标准，例如：家规晚上回家不能超过12点，自己的东西要摆放好等等。而当孩子不遵守规则时，你也不会大发雷霆，你会心平气和地告诉他，他哪里做错了以及为什么错了，所以在孩子眼中，你并没有绝对的权威，而是一个比较开明的家长。',
	  'advantage': '1)你习惯思考，所以看待事情一般不会停留在表面，相比于其他人，你更容易发现事物的本质；<br/><br/>2)在处理事情上，你比较有主见，头脑清晰有条理，而且有自己的一套原则，容易督促事情往设想的方面发展；<br/><br/>3)你肯钻研，对自己要求严格。在你看来，没有无意义的工作，任何事情，只要你想去做，你就希望把它做得尽善尽美。例如完美型的代表人物周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4)你的衣品比较好，着装整洁而恰当，给人一种大方得体的感觉。而这种衣着品味很可能来源于良好的家庭教养；<br/><br/>5）你懂得如何与人相处，淡然处事的风格能为你赢得他人的好感。',
	  'shortcoming': '1）追求完美的你有时候会有悲观倾向。因为你所追求的高标准可能在现实中难以得到满足，由此产生的挫败感传达到你的自我认知中时，可能就会导致情绪上的抑郁和低落；<br/><br/>2）有时候，你会比较懒散，难以激发自己的斗志。尤其是在遇到挫折时，你很可能会转向无所谓的态度，缺乏锐意进取的精神；<br/><br/>3）和平型的你喜欢生活的平稳，不太愿意尝试新鲜的事物，也不喜欢生活中出现太多变动或是既定的计划被人打断；<br/><br/>4）追求完美的你有时候会在细节上过度在意，导致工作停滞不前或是花费比一般人要多的时间来完成一项任务。如果事情没有达到你的要求，你会反复修改，直到你满意为止。',
	  'suggest': '1）多从正面去看待问题。没有人喜欢阴沉和充满负能量的人，当事情发展不如自己想象中那样完美时，不妨先停下来，换另一件事来做，避免陷入到思维死角中；<br/><br/>2）适当尝试新鲜事物。安于现状的你常常拒绝生活的变动，不过适当尝试新鲜事物或许可以让你发现更多生活精彩，参加兴趣小组就是一个接受新事物的不错选择；<br/><br/>3）培养锐意进取的心态。虽然你很有计划和目标性，但当事情见不到成效时，你可能会变得懈怠，虽然这能让你在情绪和心态上得到疏解，但有时再加上一点点坚持，你会更容易成功。',
	  'match_jobs': '教育家，老师，培训师，行政工作者'
	}, { 'key': 'mp',
	  'sex': 'female',
	  'animal': '天鹅',
	  'animal_en': 'Cygnus',
	  'pic': '../static/funreports/tiane/animal.png',
	  'tags': '傲娇、有气质、人畜无害、低调、家里蹲、尴尬癌、理性派、注重细节、习惯性拖延',
	  'short_description': '表面看来，天鹅优雅淡定，但其实天鹅在湖底下的双脚却在不断地划水，因为——你必须竭尽全力，才能看起来毫不费力！这就好比是对自我管理有要求的你，总是保持着从容的姿态，但对待工作却十分认真细致。',
	  'coordinate': '',
	  'basic_discription': '通常情况下，你做事比较认真，能将问题看得很通透，但你不会去抢风头，因为你并不愿意成为焦点人物。你一方面会注重追求自己的标准，另一方面又乐于享受平稳的生活，不会过于激进和苛求。这两种性格能相互作用，互相补充，使得你善于学习和研究，又善于待人接物，很有潜力成为一名教育工作者。但你对目标的追求有时不够坚定，在遇到挫折时容易转向随和、无所谓的心态，缺乏一种锐意进取的精神。',
	  'in_lover': '做你男朋友挺幸福的，如果你问他，你到底喜欢我哪一点，他可能会回答说，因为和你相处让我感觉很舒服。<br/><br/>你对自我有追求，对待工作或学习也常常是一丝不苟的，你的魅力散发在你认真做事情的时候。同时，你很少有情绪上的歇斯底里，这种平和的性格能给你们的爱情添上防护的外衣，你们很少会因为感情问题而进行激烈的争论。<br/><br/>如果他认为你们是自然吸引的，那其实不太正确，因为他其实是通过了你某些鉴定标准的，这也从侧面反映出了你的伴侣是优秀的。同样的，你对自己也有一定的标准和要求，但是当要求没有达到时，你未必会将失落表现出来，相反，你很可能会选择沉默，这时候会让对方产生困惑。如果你们能够向对方敞开心扉，并给予支持，那么你们将拥有更和谐的伴侣关系。',
	  'in_friends': '你是一个人际关系不错的人。在朋友的眼里，你是一个信得过的朋友，因为你是一个不错的倾听者，也从来不会在他人面前说三道四。在人际关系方面，你最大的优点是“无过”，因此很少树敌。这种中立客观又和平淡然的性格能赢得他人的亲近。但其实，你也是“择人而交”的，你在心里有自己的一套交友准则，能走进你内心的人并不多。',
	  'in_colleagues': '你既可以做宏观把控的角色，也可以做关注细节，配合他人的“拧螺丝”角色。一方面，要求完美的你有目标，肯追求，适合掌握大方向，在你手下出来的产品一定是过关的；另一方面，和平处事的风格让你能和同事良好相处，形成配合。此外，你从不会在工作中乱嚼舌根，也不会肆意插手他人的事情，懂得尊重他人，能在很大程度上赢得同事的好感。',
	  'will_be': '作为家长，你希望自己家中能够像工作中那样干净整洁，一切都井然有序，因而你会给你的孩子适当订立某些标准，例如：家规晚上回家不能超过12点，自己的东西要摆放好等等。而当孩子不遵守规则时，你也不会大发雷霆，你会心平气和地告诉他，他哪里做错了以及为什么错了，所以在孩子眼中，你并没有绝对的权威，而是一个比较开明的家长。',
	  'advantage': '1)你习惯思考，所以看待事情一般不会停留在表面，相比于其他人，你更容易发现事物的本质；<br/><br/>2)在处理事情上，你比较有主见，头脑清晰有条理，而且有自己的一套原则，容易督促事情往设想的方面发展；<br/><br/>3)你肯钻研，对自己要求严格。在你看来，没有无意义的工作，任何事情，只要你想去做，你就希望把它做得尽善尽美。例如完美型的代表人物周星驰，对于电影中的每一个镜头，每一个场景甚至演员的每一个眼神，都希望能够得到完美的表达；<br/><br/>4)你的衣品比较好，着装整洁而恰当，给人一种大方得体的感觉。而这种衣着品味很可能来源于良好的家庭教养；<br/><br/>5）你懂得如何与人相处，淡然处事的风格能为你赢得他人的好感。',
	  'shortcoming': '1）追求完美的你有时候会有悲观倾向。因为你所追求的高标准可能在现实中难以得到满足，由此产生的挫败感传达到你的自我认知中时，可能就会导致情绪上的抑郁和低落；<br/><br/>2）有时候，你会比较懒散，难以激发自己的斗志。尤其是在遇到挫折时，你很可能会转向无所谓的态度，缺乏锐意进取的精神；<br/><br/>3）和平型的你喜欢生活的平稳，不太愿意尝试新鲜的事物，也不喜欢生活中出现太多变动或是既定的计划被人打断；<br/><br/>4）追求完美的你有时候会在细节上过度在意，导致工作停滞不前或是花费比一般人要多的时间来完成一项任务。如果事情没有达到你的要求，你会反复修改，直到你满意为止。',
	  'suggest': '1）多从正面去看待问题。没有人喜欢阴沉和充满负能量的人，当事情发展不如自己想象中那样完美时，不妨先停下来，换另一件事来做，避免陷入到思维死角中；<br/><br/>2）适当尝试新鲜事物。安于现状的你常常拒绝生活的变动，不过适当尝试新鲜事物或许可以让你发现更多生活精彩，参加兴趣小组就是一个接受新事物的不错选择；<br/><br/>3）培养锐意进取的心态。虽然你很有计划和目标性，但当事情见不到成效时，你可能会变得懈怠，虽然这能让你在情绪和心态上得到疏解，但有时再加上一点点坚持，你会更容易成功。',
	  'match_jobs': '教育家，老师，培训师，行政工作者'
	}, { 'key': 'cm',
	  'sex': 'male',
	  'animal': '鹰',
	  'animal_en': 'Accipitridae',
	  'pic': '../static/funreports/ying/animal.png',
	  'tags': '思维敏捷、行动派、占有欲、目标精准、喜欢挑战、激进、高智商、现实主义者、卷福附体、追求品质生活',
	  'short_description': '你就如同鹰一样，一次只明确专注一个猎物，在猎食时限定自己的视野，能量瞬间集中于当下最终的目标，确保猎获食物来得以生存。你目标性强，处事十分专注，这样的你做任何事情都十分有效率，感觉没有什么事能难倒你。',
	  'coordinate': '',
	  'basic_discription': '你是最佳的商业人才，将领导才能和敏感聪慧结合起来会让你所向无敌。对你来说，没有什么事情是做不来的。同时你并不会在没有充分做好准备的情况下，贸贸然行动，而是在经过前期计划后才会抓住时机行动。<br/><br/>因而，在工作或学习中，你总是有着饱满的热情、较强的执行力，以及优秀的观察力。不过需要注意的是，对于工作，你会一直坚持下去，直到有完美的结果为止。这种对工作的过度关注会让你比较忽视与身边人的关系。',
	  'in_lover': '在两性相处的过程中，你倾向于占领支配性角色。一般情况下，你会掌握你和她之间的关系的决定权。在恋爱的过程中，你希望你和她能够达到在精神上沟通，但是你可能更多地会把精力放到工作上，而对恋爱多少有些心不在焉，这使得她有时候会不知所措而有点怨气。不过，面对心爱的她，你会很坦诚，而且会偷偷给她制造浪漫和惊喜，满足了女生对于浪漫的幻想。不过，果敢的你，一旦选择分手，便会表现出决绝和果断，不再眷恋。',
	  'in_friends': '在他人看来，你似乎不太需要朋友，作为一个气场强大的人，你能从工作或其他事物中找到很多乐趣，也愿意为工作牺牲很多。但你的内心还是渴望有朋友的支持和关注的，只是你谨小慎微的性格导致了你交友慎重，你要求你的朋友忠诚可靠，这样你才愿意付出你的真心。当和朋友交流产生争论时，你大多数会坚持自己的看法。但为了朋友，你也会甘心听他的牢骚，为他解决实际问题。',
	  'in_colleagues': '工作上是目标主导倾向的你，有统领全局的能力，非常有主见；而且善于做工作计划并分配工作，让每个人都“有事可做”；同时你倾向于对工作的执行进度有一个良好监控的清单式工作，这样能够在工作的过程中更好地关注各个方面，以更好地发现和处理问题。与此同时，兼具完美型性格的你，会把工作的前前后后都想得非常周到，能够评估风险和危机，这样的你常常能被上级和同事所赏识。',
	  'will_be': '作为父母，你不容许自己的家里乱糟糟的。你的组织和管理能力同样能应用在家庭中，把家里打造得井井有条。你注重你的家长权威性，对子女常使用命令式的语气，但同时你非常具有牺牲精神，虽然你会指责你的孩子乱糟糟的，但你还是会不断地为ta操心操力。',
	  'advantage': '1）你有较强的领导能力。力量型的“饱满的工作热情”和完美型的“善于思考”结合，为你赢得了同事们的尊重，让你在同事之间有很强的号召力；<br/><br/>2）你越挫越勇，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>3）你果断、有条理、目标明确，这种类型的你一般有强烈的欲望和决心，当朝着正确的方向进发时，力量型/完美型的你总是最容易成功；<br/><br/>4）你意志力坚定，目标性比较强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>5）你思维缜密，有良好的洞察力。力量型的你遇到问题你会想要即刻处理，然而完美型的个性使得你三思而后行，懂得把握时机。',
	  'shortcoming': '1）处理事情时过于理性，有时会显得冷酷无情，忽视他人感受；<br/><br/>2）控制欲太强，难以接受预期外的结果，一旦不如自己所愿就会陷入负性情绪中；<br/><br/>3）不太懂得放松和娱乐自己，工作起来不知疲倦，而且追求完美，因此转移你的注意力是一件具有一定难度的事情。这样的你有时候会忽略生活中的美好而变得无趣。',
	  'suggest': '1）学会放松，也是减轻对别人的压力：追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让我们周围的人产生可怕的压力；<br/><br/>2）有意识地留意他人的需求，学会关心他人。平时在生活中、工作上，多看多听，当你注意到别人的情绪时，给予反应，可以给人一种真诚的感觉，更能赢得别人的好感；<br/><br/>3）降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和不同类型的人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准。',
	  'match_jobs': '做规划和决策性的领导职位'
	}, { 'key': 'cm',
	  'sex': 'female',
	  'animal': '鹰',
	  'animal_en': 'Accipitridae',
	  'pic': '../static/funreports/ying/animal.png',
	  'tags': '思维敏捷、行动派、占有欲、目标精准、喜欢挑战、激进、高智商、现实主义者、卷福附体、追求品质生活',
	  'short_description': '你就如同鹰一样，一次只明确专注一个猎物，在猎食时限定自己的视野，能量瞬间集中于当下最终的目标，确保猎获食物来得以生存。你目标性强，处事十分专注，这样的你做任何事情都十分有效率，感觉没有什么事能难倒你。',
	  'coordinate': '',
	  'basic_discription': '你是最佳的商业人才，将领导才能和敏感聪慧结合起来会让你所向无敌。对你来说，没有什么事情是做不来的。同时你并不会在没有充分做好准备的情况下，贸贸然行动，而是在经过前期计划后才会抓住时机行动。<br/><br/>因而，在工作或学习中，你总是有着饱满的热情、较强的执行力，以及优秀的观察力。不过需要注意的是，对于工作，你会一直坚持下去，直到有完美的结果为止。这种对工作的过度关注会让你比较忽视与身边人的关系。',
	  'in_lover': '在两性相处的过程中，你倾向于占领支配性角色。一般情况下，你会掌握你和他之间的关系的决定权。在恋爱的过程中，你希望你和他能够达到在精神上沟通，但是你可能更多地会把精力放到工作上，而对恋爱多少有些心不在焉，这使得他有时候会对你有所抱怨。不过，面对心爱的他，你会很坦诚，而且会偷偷给他制造浪漫和惊喜，这让他感觉到温暖和感动。不过，果敢的你，一旦选择分手，便会表现出决绝和果断，不再眷恋。',
	  'in_friends': '在他人看来，你似乎不太需要朋友，作为一个气场强大的人，你能从工作或其他事物中找到很多乐趣，也愿意为工作牺牲很多。但你的内心还是渴望有朋友的支持和关注的，只是你谨小慎微的性格导致了你交友慎重，你要求你的朋友忠诚可靠，这样你才愿意付出你的真心。当和朋友交流产生争论时，你大多数会坚持自己的看法。但为了朋友，你也会甘心听他的牢骚，为他解决实际问题。',
	  'in_colleagues': '工作上是目标主导倾向的你，有统领全局的能力，非常有主见；而且善于做工作计划并分配工作，让每个人都“有事可做”；同时你倾向于对工作的执行进度有一个良好监控的清单式工作，这样能够在工作的过程中更好地关注各个方面，以更好地发现和处理问题。与此同时，兼具完美型性格的你，会把工作的前前后后都想得非常周到，能够评估风险和危机，这样的你常常能被上级和同事所赏识。',
	  'will_be': '作为父母，你不容许自己的家里乱糟糟的。你的组织和管理能力同样能应用在家庭中，把家里打造得井井有条。你注重你的家长权威性，对子女常使用命令式的语气，但同时你非常具有牺牲精神，虽然你会指责你的孩子乱糟糟的，但你还是会不断地为ta操心操力。',
	  'advantage': '1）你有较强的领导能力。力量型的“饱满的工作热情”和完美型的“善于思考”结合，为你赢得了同事们的尊重，让你在同事之间有很强的号召力；<br/><br/>2）你越挫越勇，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>3）你果断、有条理、目标明确，这种类型的你一般有强烈的欲望和决心，当朝着正确的方向进发时，力量型/完美型的你总是最容易成功；<br/><br/>4）你意志力坚定，目标性比较强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>5）你思维缜密，有良好的洞察力。力量型的你遇到问题你会想要即刻处理，然而完美型的个性使得你三思而后行，懂得把握时机。',
	  'shortcoming': '1）处理事情时过于理性，有时会显得冷酷无情，忽视他人感受；<br/><br/>2）控制欲太强，难以接受预期外的结果，一旦不如自己所愿就会陷入负性情绪中；<br/><br/>3）不太懂得放松和娱乐自己，工作起来不知疲倦，而且追求完美，因此转移你的注意力是一件具有一定难度的事情。这样的你有时候会忽略生活中的美好而变得无趣。',
	  'suggest': '1）学会放松，减轻对别人的压力：追求力量和成功会使你成为成功路上的王者，但要意识到对成功的迫切会让我们周围的人产生可怕的压力；<br/><br/>2）有意识地留意他人的需求，学会关心他人。平时在生活中、工作上，多看多听，当你注意到别人的情绪时，给予反应，可以给人一种真诚的感觉，更能赢得别人的好感；<br/><br/>3）降低自己的标准，从过度浪漫和理性化中回到现实。你可以多和不同类型的人交往，了解不同的人有不同的特点，明确自己最需要的东西，在此基础上适当放宽其他标准。',
	  'match_jobs': '做规划和决策性的领导职位'
	}, { 'key': 'cs',
	  'sex': 'male',
	  'animal': '狮',
	  'animal_en': 'Pantheraleo',
	  'pic': '../static/funreports/shi/animal.png',
	  'tags': '心中有团火、安利高手、外向、精力旺盛、主动、风趣、冒险王、天生的领导者、自信满满',
	  'short_description': '狮子是最大型的猫科动物，也是唯一群居的猫科动物。并且，狮群的首领有着良好的沟通能力，对群内狮子分工十分明确。因此，工作统筹领导能力强，且擅长处理人际关系的你与狮子有着相似的魅力。',
	  'coordinate': '',
	  'basic_discription': '外向乐观、坦率健谈的你，其实十分有领导潜力，你善于发掘别人的优点，能指挥别人并使其乐于工作。在工作中，活泼型的你能弥补力量型在人际关系上的忽视，因而能调动和指挥他人使其乐于工作。<br/><br/>在他人眼里，你常常给人一种有决断力，踏实稳重的感觉。你既懂得享受情趣又能达到目标，因此你具有推动力和决断力，但也不会为取得成就而强求自己。你工作时十分认真，玩乐时也全心投入，懂得适应情境而生活。但你做事情有时比较马虎，不太关注和在意细节，会给工作造成一些细微影响。',
	  'in_lover': '在感情中，你往往是一段关系中的主导者。她就像你的小粉丝一样，沉迷于你的魅力当中，喜欢跟着你的步调生活。而且，搞怪精灵的你总是有源源不断的浪漫想法，让你们的爱情得以保鲜。再者，你很少吝啬于情感上的表达，相反，你喜欢把自己内心的感受都说给她听，你和她之间能聊很多话题。<br/><br/>但是通常你比较难掩饰自己的情绪，好在情绪来得快去得也快，并且健忘的特点使得你并不会总是和她“翻旧账”，在她眼中，和你在一起心理包袱很小。当一段关系结束之后，你会有刻骨铭心的伤痛感，但很少会去死缠烂打。',
	  'in_friends': '目标性较强的你，会让很多人一开始和你保持距离。但是相处下来之后，很多人会被你有趣的性格所吸引，所以你身边从来就不缺朋友，他们都愿意围绕着你，因为你阳光、有幽默感，总能驱走朋友的愁云，带来欢笑。<br/><br/>需要注意的是，外向而善于言谈的你，有时会忽略朋友的需求，而把关注点只放在自己身上。这容易让他人形成一种“只关注自己，享受着被聚焦的快感”这种自私的印象。学会为他人考虑能让你成为一个更好的朋友。',
	  'in_colleagues': '在同事的眼中，你是一个懂得在适宜的时间里做适宜的事的人。你比较恪守“要玩就玩得开心，要工作就认真工作”这一理念。你做事情有目标性，做事注重实际行动和工作效率，一般有较强的工作能力。<br/><br/>事实上，你热爱工作的同时还能使之变得有乐趣，你有天马行空的想象里，因而喜欢尝试不同的方式去解决问题。另外，与人相处时你热情而主动，侃侃而谈的性格能吸引大部分人的好感。综合而言，你的工作能力加上你的个人魅力，使得你有很好的领导能力，能带动你的工作伙伴一起朝目标前进。',
	  'will_be': '在孩子眼中，你既是标准严明的父亲，又是可以敞开心扉交流的朋友，这一点是非常难得的。你对孩子有明确的要求，会发挥出自己身为家长的权威，支配和控制你的孩子并教导Ta学好。同时，你内心的孩子气和活跃细胞，让你能和自己的孩子打成一片，被孩子们所喜爱。<br/><br/>你一边享受着和孩子一起时候的欢乐，一边有意识地对孩子进行管理，你就像一个马戏团的团长，带来快乐的同时，也行使命令的主权，通过组织和管理的能力把家里打理得井井有条。需要注意的事，有时候你对孩子过度的控制欲会让孩子产生心理上的叛逆，从而拉开你们的心理距离。',
	  'advantage': '1）你能活跃气氛，人际关系良好。团队中活泼型的性格人缘很好，它能调和力量型在这一方面的劣势，使得你在与人相处方面不会过于冷酷无情；<br/><br/>2）你有很强的领导能力。力量型的“一工作就废寝忘食”的特点与活泼型的感染能力结合，让你在同事之间有很强的号召能力；<br/><br/>3）你很主动，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>4）你的沟通能力很强，不论是为人还是处事都比较灵活，与人相处时一般不会给人压力；<br/><br/>5）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃。',
	  'shortcoming': '1）力量型的你工作起来有时候六亲不认，工作的时候他人比较难转移你的注意力，有时会忽略生活中的美好；<br/><br/>2）力量型的你控制欲望强烈，虽然活泼的性格特征能比较缓和这一特点，但如果表达方式不够温和委婉的话，仍然会给人留下比较霸道的印象；<br/><br/>3）力量型和活泼型两者都表现出性格外倾的特点，大部分时候追求表达，对自我太过的关注导致你容易忽视他人的感受；<br/><br/>4）脾气暴躁，遇到不顺的事情容易生气，缺乏平和的内心。',
	  'suggest': '1）你需要适当控制住自己的表演欲，把关注焦点分担到他人身上。你可以从听和看做起，在别人表达完之前，不要急着打断别人说话，试着去理解和记住他人所说的话，让他人感受到被尊重；<br/><br/>2）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>3）学会自我减压和放松。力量型一旦陷入工作很可能成为“工作狂”，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>4）保留自己的观点。力量型的你有时很没耐心，总喜欢对他人的行为给以主观的评价。当你意识到自己有这方面倾向时，保留自己的观点，选择低调的方式处理。',
	  'match_jobs': '推广、策划、活动组织'
	}, { 'key': 'cs',
	  'sex': 'female',
	  'animal': '狮',
	  'animal_en': 'Pantheraleo',
	  'pic': '../static/funreports/shi/animal.png',
	  'tags': '心中有团火、安利高手、外向、精力旺盛、主动、风趣、冒险王、天生的领导者、自信满满',
	  'short_description': '狮子是最大型的猫科动物，也是唯一群居的猫科动物。并且，狮群的首领有着良好的沟通能力，对群内狮子分工十分明确。因此，工作统筹领导能力强，且擅长处理人际关系的你与狮子有着相似的魅力。',
	  'coordinate': '',
	  'basic_discription': '外向乐观、坦率健谈的你，其实十分有领导潜力，你善于发掘别人的优点，能指挥别人并使其乐于工作。在工作中，活泼型的你能弥补力量型在人际关系上的忽视，因而能调动和指挥他人使其乐于工作。<br/><br/>在他人眼里，你常常给人一种有决断力，踏实稳重的感觉。你既懂得享受情趣又能达到目标，因此你具有推动力和决断力，但也不会为取得成就而强求自己。你工作时十分认真，玩乐时也全心投入，懂得适应情境而生活。但你做事情有时比较马虎，不太关注和在意细节，会给工作造成一些细微影响。',
	  'in_lover': '在感情中，你往往是一段关系中的主导者。你有较强的掌控欲，不过比较好的是，你会通过一种更加温和的形式表现出来，使他能在感情中跟着你的节奏生活。而且，搞怪精灵的你总是有源源不断的浪漫想法，让你们的爱情得以保鲜。再者，你很少吝啬于情感上的表达，相反，你喜欢把自己内心的感受都说给他听，你和他之间能聊很多话题。<br/><br/>但是通常你比较难掩饰自己的情绪，好在情绪来得快去得也快，并且活泼型健忘的特点使得你并不会总是和他“翻旧账”，在他看来，和你在一起会很舒心。当一段关系结束之后，你会有刻骨铭心的伤痛感，但很少会去死缠烂打。',
	  'in_friends': '目标性较强的你，会让很多人一开始和你保持距离。但是相处下来之后，很多人会被你有趣的性格所吸引，所以你身边从来就不缺朋友，他们都愿意围绕着你，因为你阳光、有幽默感，总能驱走朋友的愁云，带来欢笑。<br/><br/>需要注意的是，外向而善于言谈的你，有时会忽略朋友的需求，而把关注点只放在自己身上。这容易让他人形成一种“只关注自己，享受着被聚焦的快感”这种自私的印象。学会为他人考虑能让你成为一个更好的朋友。',
	  'in_colleagues': '在同事的眼中，你是一个懂得在适宜的时间里做适宜的事的人。你比较恪守“要玩就玩得开心，要工作就认真工作”这一理念。你做事情有目标性，做事注重实际行动和工作效率，一般有较强的工作能力。<br/><br/>事实上，你热爱工作的同时还能使之变得有乐趣，你有天马行空的想象里，因而喜欢尝试不同的方式去解决问题。另外，与人相处时你热情而主动，侃侃而谈的性格能吸引大部分人的好感。综合而言，你的工作能力加上你的个人魅力，使得你有很好的领导能力，能带动你的工作伙伴一起朝目标前进。',
	  'will_be': '在孩子眼中，你既是标准严明的妈妈，又是可以敞开心扉交流的朋友，这一点是非常难得的。你对孩子有明确的要求，会发挥出自己身为家长的权威，支配和控制你的孩子并教导Ta学好。同时，你内心的孩子气和活跃细胞，让你能和自己的孩子打成一片，被孩子们所喜爱。<br/><br/>你一边享受着和孩子一起时候的欢乐，一边有意识地对孩子进行管理，你就像一个马戏团的团长，带来快乐的同时，也行使命令的主权，通过组织和管理的能力把家里打理得井井有条。需要注意的事，有时候你对孩子过度的控制欲会让孩子产生心理上的叛逆，从而拉开你们的心理距离。',
	  'advantage': '1）你能活跃气氛，人际关系良好。团队中活泼型的性格人缘很好，它能调和力量型在这一方面的劣势，使得你在与人相处方面不会过于冷酷无情；<br/><br/>2）你有很强的领导能力。力量型的“一工作就废寝忘食”的特点与活泼型的感染能力结合，让你在同事之间有很强的号召能力；<br/><br/>3）你很主动，面对困难和挫折时，一般不会选择避开问题，更多的是逆流直上，用于面对并想办法解决它；<br/><br/>4）你的沟通能力很强，不论是为人还是处事都比较灵活，与人相处时一般不会给人压力；<br/><br/>5）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃。',
	  'shortcoming': '1）力量型的你工作起来有时候六亲不认，工作的时候他人比较难转移你的注意力，有时会忽略生活中的美好；<br/><br/>2）力量型的你控制欲望强烈，虽然活泼的性格特征能比较缓和这一特点，但如果表达方式不够温和委婉的话，仍然会给人留下比较霸道的印象；<br/><br/>3）力量型和活泼型两者都表现出性格外倾的特点，大部分时候追求表达，对自我太过的关注导致你容易忽视他人的感受；<br/><br/>4）脾气暴躁，遇到不顺的事情容易生气，缺乏平和的内心。',
	  'suggest': '1）你需要适当控制住自己的表演欲，把关注焦点分担到他人身上。你可以从听和看做起，在别人表达完之前，不要急着打断别人说话，试着去理解和记住他人所说的话，让他人感受到被尊重；<br/><br/>2）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>3）学会自我减压和放松。力量型一旦陷入工作很可能成为“工作狂”，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>4）保留自己的观点。力量型的你有时很没耐心，总喜欢对他人的行为给以主观的评价。当你意识到自己有这方面倾向时，保留自己的观点，选择低调的方式处理。',
	  'match_jobs': '推广、策划、活动组织'
	}, { 'key': 'cp',
	  'sex': 'male',
	  'animal': '象',
	  'animal_en': 'Elephasmaximus',
	  'pic': '../static/funreports/xiang/animal.png',
	  'tags': '踏实可靠、低调的实力派、意志坚定、情绪平稳、稳重、凶起来我自己都怕、倔强、人不犯我我不犯人',
	  'short_description': '你做事沉稳、有目标的特质很像大象。作为群居性动物，大象群内有很好的协作性，每天都有规定的活动时间和行动路线，另一方面，虽然大象体型庞大，但却是很感性的动物，有很高的共情能力，就像你对朋友一样，能在他们沮丧时及时响应和安抚。',
	  'coordinate': '',
	  'basic_discription': '你是自信沉稳的偏工作主导型。你低调冷静、有耐心但又不失进取心，同时你奋发进取的个性能够以一种更为温和的形式表现出来，有能力却脚踏实地，有想法却并不张扬，能无形中给人一种信任感。<br/><br/>他人在与你交往时会感觉很舒适，但同时也能从你身上感受到一种低调的气场。需要注意的是，虽然表面上你能够与人较好，但是知心朋友并不多，因为你的平稳沉静的性格大多数是为工作服务的，以便更好地处理工作上的事物。',
	  'in_lover': '在她看来，你是一个能让她感觉到安全的踏实可靠的人。虽然你并不是很浪漫，但你会真切地为对方考虑。你对感情十分忠诚，有责任感，这是最吸引她的一点。虽然生活中有很多琐碎的小事，但你们不太因这些琐事而争吵。更直白一点说，感情中你们之间的分工是相对比较明确的。<br/><br/>沉稳而踏实的你，通常是感情的主导者，在一些大的决策上面，往往是你在拿主意。而在小事中，你更多的是听对方的。即便有一些摩擦，沉稳如你也很少会和她激烈地争吵。你能明白生活中什么是重要的，什么是可以妥协的，因而你们的感情比较稳固。当然，如果能偶尔来个惊喜和浪漫的话，那你几乎要套牢她了！',
	  'in_friends': '在朋友眼中，你是一个踏实而可靠的人。通常表现比较冷静的你，能够在朋友六神无主时给予冷静的分析，帮助对方梳理好问题的重难点，甚至给出自己的观点和建议。在事务性问题上，你能设身处地的为朋友着想，并且常常能给出一些切实可行的解决方案。但是在人际问题上，谨慎的你常常会保持客观而中立的态度。虽然耐心的你依然会做朋友忠实的倾听者，但你并不好表明什么态度。',
	  'in_colleagues': '在同事眼中，你是一个很懂得管理和执行的人。你目标型很强，通常为了达到目标你会很努力。但有些人可能会把这种强烈的目的性表现地很明显，有时会让他人反感；而聪明的你具有沉稳的一面，有能力通过一种“润物无声”的温和方式达到目标，既不会惹人反感，更不会让人感觉到攻击性。<br/><br/>因此，你的管理能力很强，作为领导，你能够让下属心甘情愿地努力工作，而作为同事，你更能带动大家一起向着目标行进。总之，同事的眼中你具有较良好的威信。当然也有时候，你对自己的高要求可能会影响到团队的其他人，给大家的工作带来一定的紧张感。而且你内心的固执让你很难真正接受他人的意见。',
	  'will_be': '在孩子眼中，你会是一个比较有威严的父亲，总带着一本正经的严肃面孔。通常你比较关注孩子的学习成绩，身体健康方面的状况，会为家庭大的方面进行决策，也会从宏观上为孩子作打算。有很强的责任感的你，其实为了家庭会付出很多，但在生活细节上你比较少照顾到，这可能和家庭分工有关。沉稳的你很少会和孩子发火，但同时，相比于母亲，孩子可能和你更不亲近。不过对你来说，努力拼搏，提升家庭的整体幸福是你最大的使命，这样的你会赢得孩子和另一半的尊重。',
	  'advantage': '1）你个性沉稳，做事靠谱，在工作和为人处事方面，都会给他人留下值得信赖的感觉；<br/><br/>2）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>3）你是强势的领导者。不论在何种场合中，力量型的你都很能赢得他人的注视和焦点，特别是当大家没有注意，乱做一团的时候，你更能显示出自己的领导风范；<br/><br/>4）永远精力旺盛。你好像总有用不完的精力和力量，当身边的人感到力不从心时，你依然充满活力，斗志昂扬；<br/><br/>5）虽然你一旦进入工作就会进入一种非常认真的状态，但你对工作绩效和成果的追求会以一种更温和的方式表现出来。',
	  'shortcoming': '1）你控制欲望强烈，总想着掌控全局，而且常常固执地认为自己是对的，有时给人一种专横霸道的感觉；<br/><br/>2）你给人一种呆板，不懂得变通的印象，而且有时候会认死理，不懂得调动气氛，而且他人很难和你开玩笑；<br/><br/>3）虽然你有追求又个性平稳，但沉浸在工作中的你常常不懂得给自己放松和减压，因而患心脏病的风险比较高；<br/><br/>4）你不会轻易向他人坦露自我，表现为对他人有所防备，在谈及自己时，你会比较敏感。',
	  'suggest': '1）适当转换视角，从他人的观点中取合理性。你有时候就是“没有错先生”，在内心中固执地认为“我没有错，是别人错了”，虽然不会太明显地表露出来。如果能适当转换视角，也许你也能看到不一样的东西；<br/><br/>2）学会自我减压和放松。虽然你热衷于工作或学习，但这会让你忽视自己的真实需要，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>3）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>4）学会沟通的艺术，有些话换一种方式表达，效果会不一样，更让对方接受；<br/><br/>5）适当坦露自己，能让他人觉得你更容易亲近些。',
	  'match_jobs': '政治家，管理层'
	}, { 'key': 'cp',
	  'sex': 'female',
	  'animal': '象',
	  'animal_en': 'Elephasmaximus',
	  'pic': '../static/funreports/xiang/animal.png',
	  'tags': '踏实可靠、低调的实力派、意志坚定、情绪平稳、稳重、凶起来我自己都怕、倔强、人不犯我我不犯人',
	  'short_description': '你做事沉稳、有目标的特质很像大象。作为群居性动物，大象群内有很好的协作性，每天都有规定的活动时间和行动路线，另一方面，虽然大象体型庞大，但却是很感性的动物，有很高的共情能力，就像你对朋友一样，能在他们沮丧时及时响应和安抚。',
	  'coordinate': '',
	  'basic_discription': '你是自信沉稳的偏工作主导型。你低调冷静、有耐心但又不失进取心，同时你奋发进取的个性能够以一种更为温和的形式表现出来，有能力却脚踏实地，有想法却并不张扬，能无形中给人一种信任感。<br/><br/>他人在与你交往时会感觉很舒适，但同时也能从你身上感受到一种低调的气场。需要注意的是，虽然表面上你能够与人较好，但是知心朋友并不多，因为你的平稳沉静的性格大多数是为工作服务的，以便更好地处理工作上的事物。',
	  'in_lover': '在他看来，你是一个内秀而沉稳的人。你并不像很多女生一样追求浪漫，你更多的是关注对方的成熟度。在和他相处的过程中，你很少因为生活的琐碎小事而和他大吵大闹，这对于你来说未免有点幼稚。但是在一些大的感情发展方面，可能会和对方产生一些冲突。原因很简单，因为你的性格决定你在感情中并不弱势，你有较强的控制欲，希望成为感情的主导者，能在一些大的决策上拿主意。<br/><br/>这对于大部分男生来说可能比较难以接受。如果爱情中你能温顺一些，多一些对他的依赖，或者偶尔在生活中给他制造一些浪漫的小惊喜，可能会大大有益于你们之间的感情发展。当然，如果现在的他已经向你妥协了的话，那除了真爱，还能是什么呢？',
	  'in_friends': '在朋友眼中，你是一个踏实而可靠的人。通常表现比较冷静的你，能够在朋友六神无主时给予冷静的分析，帮助对方梳理好问题的重难点，甚至给出自己的观点和建议。在事务性问题上，你能设身处地的为朋友着想，并且常常能给出一些切实可行的解决方案。但是在人际问题上，谨慎的你常常会保持客观而中立的态度。虽然耐心的你依然会做朋友忠实的倾听者，但你并不好表明什么态度。',
	  'in_colleagues': '在同事眼中，你是一个很懂得管理和执行的人。你目标型很强，通常为了达到目标你会很努力。但有些人可能会把这种强烈的目的性表现地很明显，有时会让他人反感；而聪明的你具有沉稳的一面，有能力通过一种“润物无声”的温和方式达到目标，既不会惹人反感，更不会让人感觉到攻击性。<br/><br/>因此，你的管理能力很强，作为领导，你能够让下属心甘情愿地努力工作，而作为同事，你更能带动大家一起向着目标行进。总之，同事的眼中你具有较良好的威信。当然也有时候，你对自己的高要求可能会影响到团队的其他人，给大家的工作带来一定的紧张感。而且你内心的固执让你很难真正接受他人的意见。',
	  'will_be': '在孩子眼中，你会是一个比较温和又严肃的妈妈。你不仅会关注孩子的学习成绩，身体健康等大的方面的状况，也会在生活细节方面关注孩子的成长，因此当涉及到关于教育、成绩等大的问题时，你可能会比较强势，有主见，无形中表现出一种不容置疑的气场；但同时，在生活的小的方面，你也能耐心而温和地和孩子进行良好的沟通，很少因孩子犯错而大发雷霆。<br/><br/>如果孩子能够知道什么情况是“可以商量”，而什么时候是“必须听话”的话，他的成长和发展一般都不会跑太偏。当然，如果你能适当听听孩子内心的声音，能够综合多方面改进对孩子的教育方案，那么你更能赢得孩子的尊重。',
	  'advantage': '1）你个性沉稳，做事靠谱，在工作和为人处事方面，都会给他人留下值得信赖的感觉；<br/><br/>2）你意志力坚定，目标性很强。做任何事情你都会有一个明确的目标，一旦开始，则很少中途放弃；<br/><br/>3）你是强势的领导者。不论在何种场合中，力量型的你都很能赢得他人的注视和焦点，特别是当大家没有注意，乱做一团的时候，你更能显示出自己的领导风范；<br/><br/>4）永远精力旺盛。你好像总有用不完的精力和力量，当身边的人感到力不从心时，你依然充满活力，斗志昂扬；<br/><br/>5）虽然你一旦进入工作就会进入一种非常认真的状态，但你对工作绩效和成果的追求会以一种更温和的方式表现出来。',
	  'shortcoming': '1）你控制欲望强烈，总想着掌控全局，而且常常固执地认为自己是对的，有时给人一种专横霸道的感觉；<br/><br/>2）你给人一种呆板，不懂得变通的印象，而且有时候会认死理，不懂得调动气氛，而且他人很难和你开玩笑；<br/><br/>3）虽然你有追求又个性平稳，但沉浸在工作中的你常常不懂得给自己放松和减压，因而患心脏病的风险比较高；<br/><br/>4）你不会轻易向他人坦露自我，表现为对他人有所防备，在谈及自己时，你会比较敏感。',
	  'suggest': '1）适当转换视角，从他人的观点中取合理性。你有时候就是“没有错先生”，在内心中固执地认为“我没有错，是别人错了”，虽然不会太明显地表露出来。如果能适当转换视角，也许你也能看到不一样的东西；<br/><br/>2）学会自我减压和放松。虽然你热衷于工作或学习，但这会让你忽视自己的真实需要，持续性的高强度工作对你的身体健康产生一定威胁，因此，适当自我减压和放松是重要的。泡个热水澡，运动出出汗，听听古典音乐都是不错的选择；<br/><br/>3）在工作和与人交往中，你要适当响应他人的号召，一个肯定的微笑，一个善意的手势都能有所帮助，切忌一味支配他人；<br/><br/>4）学会沟通的艺术，有些话换一种方式表达，效果会不一样，更让对方接受；<br/><br/>5）适当坦露自己，能让他人觉得你更容易亲近些。',
	  'match_jobs': '政治家，管理层'
	}, { 'key': 'sc',
	  'sex': 'male',
	  'animal': '海豹',
	  'animal_en': 'Leptonyx',
	  'pic': '../static/funreports/haibao/animal.png',
	  'tags': '乐观开朗、辩论家、搞事情、段子手、精力充沛、演说家、爱要坦荡荡、自来熟',
	  'short_description': '你擅长交流，就像海族馆中的演说家——海豹。活泼好动的海豹总是能带给别人很多欢乐，但同时，海豹也可以是一种凶猛的动物，著名的美国三栖突击队就以“海豹突击队”命名，因而，你既有海豹的外向开朗，也有海豹的领导力和行动力，是工作中的小能手。',
	  'coordinate': '',
	  'basic_discription': '你总是给人外向乐观的印象。健谈的你，十分有领导潜力，你善于发掘别人的优点，能指挥别人并使其乐于工作。你既懂得享受情趣又能达到目标，因此你具有推动力和决断力，但也不会为取得成就而强求自己。你工作时十分认真，玩乐时也全心投入，因此通常能有良好的前途。',
	  'in_lover': '在感情中，你往往是一段关系中的主导者。你的伴侣就像你的小粉丝，沉迷于你的魅力当中，搞怪精灵的你总是有源源不断的浪漫想法。你的情绪来得快去得也快，一段关系的结束，你可能会大哭一场，或大醉一宿，之后你就能重新振作，准备投入到新的感情中去。',
	  'in_friends': '目标性很强的你，似乎不需要朋友，但很多人会被你有趣的性格所吸引，所以你身边从来就不缺朋友。因为你阳光、有幽默感，总能驱走朋友的愁云，带来欢笑，所以他们都愿意围绕着你。但实际上，你可能更关注自己的感受，你需要的是一群观众，接受你的所有滔滔不绝，享受着被聚焦的快感。因此，虽然你看上去从不缺少朋友，但知心朋友却很少。',
	  'in_colleagues': '你热爱工作并能使之变得有乐趣，喜欢尝试不同的方式去解决问题。同时，你做事情有目标性，喜欢掌握事情的主动权，你优秀的领导能力加上你的个人魅力，能够使一起工作的小伙伴发挥出最大的价值，极大的提高了你们实现目标的可能性。',
	  'will_be': '你本身就像个长不大的孩子，因为你总能和自己的孩子打成一片，被孩子们所喜爱。在教养孩子的事情上，你一边享受着和孩子一起时候的欢乐，一边有意识地对孩子进行管理。你就像一个马戏团的团长，带来快乐的同时，也行使命令权，通过组织和管理的能力把家里打理得井井有条。',
	  'advantage': '1）你是个气氛带动者，有你的地方就绝对不会有冷场；<br/><br/>2）在工作中，你积极主动，创意无限，热爱自由，喜欢掌握自主权，你总能积极地面对困境，不容易被挫折打败；<br/><br/>3）你是一个乐天的行动者。',
	  'shortcoming': '1）你追求表达，是个滔滔不绝的演说者，对自我太过的关注导致你容易忽视他人的感受；<br/><br/>2）表面看起来有众多朋友，实际上知心朋友少之又少，太过自我中心和固执，让你忽视别人的感受；<br/><br/>3）过分坚持自己的见解，对他人缺点接纳度低；<br/><br/>4）脾气暴躁，遇到不顺的事情容易生气，缺乏平和的内心。',
	  'suggest': '1）控制住自己的表演欲，把关注焦点分担到他人身上，从听和看做起。在别人表达完之前，不要急着打断说话，记得他们的名字，记得他们说话的内容，将每个人都当做世上独特的人来对待，这样你能更好地理解他们的感受；<br/><br/>2）学会把他人的需求放在首位。你不能满足于他人愿意成为你的听众，而要理解对方真正想要的，努力成为对方真正的朋友；<br/><br/>3）试着离开支配地位，喜欢掌握主导权的你脱离控制权会让你感到不自在，但同时你能开始发现身边人的优点，以及会对身边的人坦诚相对。',
	  'match_jobs': '推广、策划、活动组织、广告'
	}, { 'key': 'sc',
	  'sex': 'female',
	  'animal': '海豹',
	  'animal_en': 'Leptonyx',
	  'pic': '../static/funreports/haibao/animal.png',
	  'tags': '乐观开朗、辩论家、搞事情、段子手、精力充沛、演说家、爱要坦荡荡、自来熟',
	  'short_description': '你擅长交流，就像海族馆中的演说家——海豹。活泼好动的海豹总是能带给别人很多欢乐，但同时，海豹也可以是一种凶猛的动物，著名的美国三栖突击队就以“海豹突击队”命名，因而，你既有海豹的外向开朗，也有海豹的领导力和行动力，是工作中的小能手。',
	  'coordinate': '',
	  'basic_discription': '你总是给人外向乐观的印象。健谈的你，十分有领导潜力，你善于发掘别人的优点，能指挥别人并使其乐于工作。你既懂得享受情趣又能达到目标，因此你具有推动力和决断力，但也不会为取得成就而强求自己。你工作时十分认真，玩乐时也全心投入，因此通常能有良好的前途。',
	  'in_lover': '在感情中，你往往是一段关系中的主导者。你的伴侣就像你的小粉丝，沉迷于你的魅力当中，搞怪精灵的你总是有源源不断的浪漫想法。你的情绪来得快去得也快，一段关系的结束，你可能会大哭一场，或大醉一宿，之后你就能重新振作，准备投入到新的感情中去。',
	  'in_friends': '目标性很强的你，似乎不需要朋友，但很多人会被你有趣的性格所吸引，所以你身边从来就不缺朋友。因为你阳光、有幽默感，总能驱走朋友的愁云，带来欢笑，所以他们都愿意围绕着你。但实际上，你可能更关注自己的感受，你需要的是一群观众，接受你的所有滔滔不绝，享受着被聚焦的快感。因此，虽然你看上去从不缺少朋友，但知心朋友却很少。',
	  'in_colleagues': '你热爱工作并能使之变得有乐趣，喜欢尝试不同的方式去解决问题。同时，你做事情有目标性，喜欢掌握事情的主动权，你优秀的领导能力加上你的个人魅力，能够使一起工作的小伙伴发挥出最大的价值，极大的提高了你们实现目标的可能性。',
	  'will_be': '你本身就像个长不大的孩子，因为你总能和自己的孩子打成一片，被孩子们所喜爱。在教养孩子的事情上，你一边享受着和孩子一起时候的欢乐，一边有意识地对孩子进行管理。你就像一个马戏团的团长，带来快乐的同时，也行使命令权，通过组织和管理的能力把家里打理得井井有条。',
	  'advantage': '1）你是个气氛带动者，有你的地方就绝对不会有冷场；<br/><br/>2）在工作中，你积极主动，创意无限，热爱自由，喜欢掌握自主权，你总能积极地面对困境，不容易被挫折打败；<br/><br/>4）你是一个乐天的行动者。',
	  'shortcoming': '1）你追求表达，是个滔滔不绝的演说者，对自我太过的关注导致你容易忽视他人的感受；<br/><br/>2）表面看起来有众多朋友，实际上知心朋友少之又少，太过自我中心和固执，让你忽视别人的感受；<br/><br/>3）过分坚持自己的见解，对他人缺点接纳度低；<br/><br/>5）脾气暴躁，遇到不顺的事情容易生气，缺乏平和的内心。',
	  'suggest': '1）控制住自己的表演欲，把关注焦点分担到他人身上，从听和看做起。在别人表达完之前，不要急着打断说话，记得他们的名字，记得他们说话的内容，将每个人都当做世上独特的人来对待，这样你能更好地理解他们的感受；<br/><br/>2）学会把他人的需求放在首位。你不能满足于他人愿意成为你的听众，而要理解对方真正想要的，努力成为对方真正的朋友；<br/><br/>3）试着离开支配地位，喜欢掌握主导权的你脱离控制权会让你感到不自在，但同时你能开始发现身边人的优点，以及会对身边的人坦诚相对。',
	  'match_jobs': '推广、策划、活动组织、广告'
	}, { 'key': 'sp',
	  'sex': 'male',
	  'animal': '萨摩耶',
	  'animal_en': 'Samoyed',
	  'pic': '../static/funreports/samoye/animal.png',
	  'tags': '小天使、正能量、温暖、乐观、容易受别人影响、没戒心、孩子气、天然治愈系、人见人爱',
	  'short_description': '萨摩耶犬性情温顺，咧开嘴的样子就像是在微笑，看起来十分和善，但不得不提醒你，它们可是天生的淘气鬼，喜欢搞破坏，也喜欢赖在主人身边。和萨摩耶相像的是，你处事温和，待人友好。你对生活总是充满好奇与期待，但同时又会有恋旧情结，可能会留着一些破铜烂铁。',
	  'coordinate': '',
	  'basic_discription': '你凡事都能处之泰然并自得其乐、这种幽默和随和的双重性格使你能成为别人最好的朋友。你热情和轻松的天性能吸引人，大家都喜欢和你相处。你很善于处理良好的人际关系，也是父母和市民代表的理想人选。但你的缺点在于，你不肯去追求你本来可以得到的东西，而且还缺乏理财能力。',
	  'in_lover': '你对每一段感情都认真投入，你爱得深沉，并愿意为之付出百分百的真心，你能让你的伴侣总是感到愉悦，并且没有压迫感。如果你问伴侣喜欢你的什么，一般得到的回答是“你的全部”，因为你虽然没有突出的锋芒，但却像春风一样沁人心扉。另外，你对感情很少拖泥带水，通常一段关系结束之后，你也不会过于留恋。',
	  'in_friends': '不难想象，你从小时候开始，身边就围绕着一堆小伙伴，即使你不是刻意而为，但你身边总是有很多朋友，这是你的天性使然。你甚至还是很多人心目中的“最好朋友”的人选，因为跟你聊天完全就是一种享受，你从不吝啬对别人的赞美，和别人也有永远说不完的话题。你的幽默感总能把朋友逗乐，反过来，当朋友需要表达的时候，你也能做到礼貌的聆听，不会把聊天当成一个人的舞台秀。',
	  'in_colleagues': '你对待工作积极主动，接到新的任务能马上如火如荼开展起来，喜欢尝试新的方式去解决问题。人缘好的你有很好的号召力，让人愿意和你一起干活，有着出色的人际协调能力，能缓和同事间的关系，避免冲突，但对工作安排缺乏合理的规划，对目标也没有势在必得的决心，显得过于随意，常常在deadline的时候拼命赶工。',
	  'will_be': '你简直是孩子眼中的理想父母，愿意花时间陪孩子的你，就像他们年纪大一点的朋友，能和他们打成一片，分享共同的话题。在对待孩子教育的问题上，你随性，亲和，自由没束缚的个性使你不会给孩子过多的条条框框，你不急躁，不易生气，让孩子能有充足的安全感。',
	  'advantage': '1）你善于表达，和你相处会让人感到很舒服，因为你总有说不完的话题，完全不用担心会冷场；<br/><br/>2）你能给予别人足够的表达空间，如果有人想跟你倾诉，你能放下手头的东西聆听，体现到充分的尊重；<br/><br/>3）你热情、有活力，仿佛对一切都有兴趣，能积极响应别人的号召，绝对不会是一个扫兴者；<br/><br/>4）你处事平和，有较好的抗压能力，面对突发事件时不会急得跳脚，有着较好的情绪控制能力。',
	  'shortcoming': '1）你行动力不足，有拖延毛病，很多事情其实只要你再努力一下就能做到，但你却缺乏持续追求的动力；<br/><br/>2）缺乏理财能力，由于少规划和随性的个性，你很少对财产进行下意识的管理，赚多少、花多少都没有明确的数字概念；<br/><br/>3）你无限的创意和想象力有时候会导致物极必反的结果，随意的个性导致你无法掌握尺度，有时候会开了过大的玩笑或玩得过火了；<br/><br/>4）你的忘性很大，有时候甚至有点丢三落四的。',
	  'suggest': '活泼和平型的你有着不错的人际关系，但也有一些小缺点，如果能借鉴以下一些建议可能会更好：<br/><br/>1）有时候为了把谈话内容变得更有趣，你可能会夸大故事的实际情况，甚至无中生有，要注意保持描述的客观性，适当修饰固然是好，但言过其实就是谎言了哟；<br/><br/>2）合理规划工作计划，建议把任务细分为一个个小任务，这能帮你把任务阶段性目标具体化，也能降低完成的难度感，每完成一个阶段，可以给自己一个小小的奖励，更好地激励自己完成下一阶段的任务；<br/><br/>3）友善随和是你的优点，你从不愿意伤害他人，你不会对人说“不”，常常让自己十分苦恼，为了让自己能更愉快地玩耍，适当的拒绝是十分必要的。',
	  'match_jobs': '外交家、客户经理、销售、行政工作'
	}, { 'key': 'sp',
	  'sex': 'female',
	  'animal': '萨摩耶',
	  'animal_en': 'Samoyed',
	  'pic': '../static/funreports/samoye/animal.png',
	  'tags': '小天使、正能量、温暖、乐观、容易受别人影响、没戒心、孩子气、天然治愈系、人见人爱',
	  'short_description': '萨摩耶犬性情温顺，咧开嘴的样子就像是在微笑，看起来十分和善，但不得不提醒你，它们可是天生的淘气鬼，喜欢搞破坏，也喜欢赖在主人身边。和萨摩耶相像的是，你处事温和，待人友好。你对生活总是充满好奇与期待，但同时又会有恋旧情结，可能会留着一些破铜烂铁。',
	  'coordinate': '',
	  'basic_discription': '你凡事都能处之泰然并自得其乐、这种幽默和随和的双重性格使你能成为别人最好的朋友。你热情和轻松的天性能吸引人，大家都喜欢和你相处。你很善于处理良好的人际关系，也是父母和市民代表的理想人选。但你的缺点在于，你不肯去追求你本来可以得到的东西，而且还缺乏理财能力。',
	  'in_lover': '你对每一段感情都认真投入，你爱得深沉，并愿意为之付出百分百的真心，你能让你的伴侣总是感到愉悦，并且没有压迫感。如果你问伴侣喜欢你的什么，一般得到的回答是“你的全部”，因为你虽然没有突出的锋芒，但却像春风一样沁人心扉。另外，你对感情很少拖泥带水，通常一段关系结束之后，你也不会过于留恋。',
	  'in_friends': '不难想象，你从小时候开始，身边就围绕着一堆小伙伴，即使你不是刻意而为，但你身边总是有很多朋友，这是你的天性使然。你甚至还是很多人心目中的“最好朋友”的人选，因为跟你聊天完全就是一种享受，你从不吝啬对别人的赞美，和别人也有永远说不完的话题。你的幽默感总能把朋友逗乐，反过来，当朋友需要表达的时候，你也能做到礼貌的聆听，不会把聊天当成一个人的舞台秀。',
	  'in_colleagues': '你对待工作积极主动，接到新的任务能马上如火如荼开展起来，喜欢尝试新的方式去解决问题。人缘好的你有很好的号召力，让人愿意和你一起干活，有着出色的人际协调能力，能缓和同事间的关系，避免冲突，但对工作安排缺乏合理的规划，对目标也没有势在必得的决心，显得过于随意，常常在deadline的时候拼命赶工。',
	  'will_be': '你简直是孩子眼中的理想父母，愿意花时间陪孩子的你，就像他们年纪大一点的朋友，能和他们打成一片，分享共同的话题。在对待孩子教育的问题上，你随性，亲和，自由没束缚的个性使你不会给孩子过多的条条框框，你不急躁，不易生气，让孩子能有充足的安全感。',
	  'advantage': '1）你善于表达，和你相处会让人感到很舒服，因为你总有说不完的话题，完全不用担心会冷场；<br/><br/>2）你能给予别人足够的表达空间，如果有人想跟你倾诉，你能放下手头的东西聆听，体现到充分的尊重；<br/><br/>3）你热情、有活力，仿佛对一切都有兴趣，能积极响应别人的号召，绝对不会是一个扫兴者；<br/><br/>5）你处事平和，有较好的抗压能力，面对突发事件时不会急得跳脚，有着较好的情绪控制能力。',
	  'shortcoming': '1）你行动力不足，有拖延毛病，很多事情其实只要你再努力一下就能做到，但你却缺乏持续追求的动力；<br/><br/>2）缺乏理财能力，由于少规划和随性的个性，你很少对财产进行下意识的管理，赚多少、花多少都没有明确的数字概念；<br/><br/>3）你无限的创意和想象力有时候会导致物极必反的结果，随意的个性导致你无法掌握尺度，有时候会开了过大的玩笑或玩得过火了；<br/><br/>5）你的忘性很大，有时候甚至有点丢三落四的。',
	  'suggest': '1）有时候为了把谈话内容变得更有趣，你可能会夸大故事的实际情况，甚至无中生有，要注意保持描述的客观性，适当修饰固然是好，但言过其实就是谎言了哟；<br/><br/>2）合理规划工作计划，建议把任务细分为一个个小任务，这能帮你把任务阶段性目标具体化，也能降低完成的难度感，每完成一个阶段，可以给自己一个小小的奖励，更好地激励自己完成下一阶段的任务；<br/><br/>3）友善随和是你的优点，你从不愿意伤害他人，你不会对人说“不”，常常让自己十分苦恼，为了让自己能更愉快地玩耍，适当的拒绝是十分必要的。',
	  'match_jobs': '外交家、客户经理、销售、行政工作'
	}, { 'key': 'sm',
	  'sex': 'male',
	  'animal': '鼠兔',
	  'animal_en': 'Ochotonidae',
	  'pic': '../static/funreports/shutu/animal.png',
	  'tags': '创意无限、幽默、腹黑、友谊的小船说翻就翻、善变、闷骚、难以捉摸、吐槽高手、爱玩',
	  'short_description': '你对自己的将来有一定的目标，愿意像鼠兔一样顶着风雪外出觅食，同时又有一定的完美主义，喜欢按照自己的想法来。虽然你常常给人“善言”的印象，但是你知道什么时候该说什么，在大庭广众之下不羞于高谈阔论，但危险时懂得闭嘴，以免祸从口出。',
	  'coordinate': '',
	  'basic_discription': '你把外向/内向的天性、乐观/悲观的双重性格表现得淋漓尽致。有时候你动若脱兔，有时候却静如处子；有时候你思潮起伏，有时候却深思熟虑，两种状态相互交替，导致你常常情绪化。举例来说，你和朋友约定了某天去玩，在出发前你都很兴奋，但到了出发那天，你反而会变得不想去了是常有发生的事。但如果两者特征运用得好，能让两种不同特性大放异彩，你将在某些地方比别人更胜一筹。',
	  'in_lover': '在感情中，你往往是一段关系的主导者，即使一开始不是，在交往中也会慢慢转变成主导角色，和对待其他事情一样。你对另一半也十分有要求，你甚至会给理想伴侣列出一份清单，符合度越高的人越有机会成为你的伴侣。不过有时候情绪化的表现会让伴侣抓不准你内心的真实想法。<br/><br/>有着浪漫细胞的你，有时为博她一笑，也会愿意花时间制造一个完美的惊喜，对待感情认真真挚，但却不会纠缠不清，一段关系结束之后，往往不会过分留恋。',
	  'in_friends': '你是个很好的谈话对象，因为你幽默，有话题，所以你身边从来不缺朋友。但你结交朋友的态度很谨慎，并会把自己对完美的要求辐射到朋友身上，对他们也有着一套套的要求。虽然能真正触摸到你内心的朋友没有几个，但你回报他们的是一颗忠诚的心。',
	  'in_colleagues': '你具有创新精神，也有对细节的考究精神，为了达到最理想的效果，你会敢于使用新的方法，不惜翻盘重来，因此很多时候会带来了意想不到的成果。在职场上“功利”心不大，没有那种势在必得的决心，更多时候你把工作视为艺术品一样去雕刻，对自己、对同事都有着高标准的要求。',
	  'will_be': '你带着一点孩子气，会花时间陪孩子，乐意和孩子一起玩游戏或观看儿童动画，但你追求“有意义”的事情，而孩子很多时候说的东西都是没有实际意义的，因此有时候你会欠缺点耐性。对待孩子，你是一个有要求的父母，你鼓励孩子获得好成绩、奖学金，你把家打理得井井有条，不能容忍家里变得乱糟糟的。',
	  'advantage': '1）你情感丰富，创意无限，你脑海里天马行空，想象力爆棚，在你身上总会有让人意想不到的点子；<br/><br/>2）你有着一双发现美的眼睛，无论是对美好事物的欣赏，还是对身边人内里的优点的发掘，都能被你双眼一一洞悉，因此，你从来不吝于赞美，以此表达你对美好的感受；<br/><br/>3）你对处理事物有激情，对处理时每个细节有追求，如果两者配合得好，你会是一个很优秀的执行者。',
	  'shortcoming': '1）你常常周旋于活泼型的热情，又沉浸在完美型的安静中，表现得比较情绪化。有时你还会有情绪失控的时候，因此，身边的人可能会觉得你是个阴晴不定、难以捉摸的人；<br/><br/>2）完美型和活泼型两种截然不同的性格需要在工作做事和人际相处时进行切换，如果你把工作中的完美主义带到生活中，或者把与人相处时的活泼性带到工作中，都会产生非常负面的影响；<br/><br/>3）总体来说，你缺乏一个完成目标的动力，但同时你对工作完成度的完美追求让你进度十分缓慢，甚至停滞不前，以致无法在限期内完成任务；<br/><br/>4）过分追求完美让你并不好受，因为这世上大部分事情都是不完美的，未能接纳到这点的你很容易因此钻牛角尖，变得情绪低落。',
	  'suggest': '1）学会将活泼型和完美型两种不同类型在工作学习或人际交往中完美切换，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当两种状态让你比较迷糊时，你可以通过洗个脸、深吸一口气等小技巧来进行自我调整；<br/><br/>2）你对自我形象管理很重视，健谈的你容易成为谈话的中心者，不自觉地会把关注重点转移到自己身上，从而忽略了别人，把关注焦点分担到身边的人身上吧，这不是你一个人的独角戏；<br/><br/>3）接受这个世界是不完美的，学会欣赏缺陷美，你会变得更轻松，发现这个世界另一面的美好。',
	  'match_jobs': '艺术家、音乐家'
	}, { 'key': 'sm',
	  'sex': 'female',
	  'animal': '鼠兔',
	  'animal_en': 'Ochotonidae',
	  'pic': '../static/funreports/shutu/animal.png',
	  'tags': '创意无限、幽默、腹黑、友谊的小船说翻就翻、善变、闷骚、难以捉摸、吐槽高手、爱玩',
	  'short_description': '你对自己的将来有一定的目标，愿意像鼠兔一样顶着风雪外出觅食，同时又有一定的完美主义，喜欢按照自己的想法来。虽然你常常给人“善言”的印象，但是你知道什么时候该说什么，在大庭广众之下不羞于高谈阔论，但危险时懂得闭嘴，以免祸从口出。',
	  'coordinate': '',
	  'basic_discription': '你把外向/内向的天性、乐观/悲观的双重性格表现得淋漓尽致。有时候你动若脱兔，有时候却静如处子；有时候你思潮起伏，有时候却深思熟虑，两种状态相互交替，导致你常常情绪化。举例来说，你和朋友约定了某天去玩，在出发前你都很兴奋，但到了出发那天，你反而会变得不想去了是常有发生的事。但如果两者特征运用得好，能让两种不同特性大放异彩，你将在某些地方比别人更胜一筹。',
	  'in_lover': '在感情中，你往往是一段关系的主导者，即使一开始不是，在交往中也会慢慢转变成主导角色，和对待其他事情一样。你对另一半也十分有要求，你甚至会给理想伴侣列出一份清单，符合度越高的人越有机会成为你的伴侣。不过有时候情绪化的表现会让伴侣抓不准你内心的真实想法。<br/><br/>有着浪漫细胞的你，有时为博他一笑，也会愿意花时间制造一个完美的惊喜，对待感情认真真挚，但却不会纠缠不清，一段关系结束之后，往往不会过分留恋。',
	  'in_friends': '你是个很好的谈话对象，因为你幽默，有话题，所以你身边从来不缺朋友。但你结交朋友的态度很谨慎，并会把自己对完美的要求辐射到朋友身上，对他们也有着一套套的要求。虽然能真正触摸到你内心的朋友没有几个，但你回报他们的是一颗忠诚的心。',
	  'in_colleagues': '你具有创新精神，也有对细节的考究精神，为了达到最理想的效果，你会敢于使用新的方法，不惜翻盘重来，因此很多时候会带来了意想不到的成果。在职场上“功利”心不大，没有那种势在必得的决心，更多时候你把工作视为艺术品一样去雕刻，对自己、对同事都有着高标准的要求。',
	  'will_be': '你带着一点孩子气，会花时间陪孩子，乐意和孩子一起玩游戏或观看儿童动画，但你追求“有意义”的事情，而孩子很多时候说的东西都是没有实际意义的，因此有时候你会欠缺点耐性。对待孩子，你是一个有要求的父母，你鼓励孩子获得好成绩、奖学金，你把家打理得井井有条，不能容忍家里变得乱糟糟的。',
	  'advantage': '1）你情感丰富，创意无限，你脑海里天马行空，想象力爆棚，在你身上总会有让人意想不到的点子；<br/><br/>2）你有着一双发现美的眼睛，无论是对美好事物的欣赏，还是对身边人内里的优点的发掘，都能被你双眼一一洞悉，因此，你从来不吝于赞美，以此表达你对美好的感受；<br/><br/>4）你对处理事物有激情，对处理时每个细节有追求，如果两者配合得好，你会是一个很优秀的执行者。',
	  'shortcoming': '1）你常常周旋于活泼型的热情，又沉浸在完美型的安静中，表现得比较情绪化。有时你还会有情绪失控的时候，因此，身边的人可能会觉得你是个阴晴不定、难以捉摸的人；<br/><br/>2）完美型和活泼型两种截然不同的性格需要在工作做事和人际相处时进行切换，如果你把工作中的完美主义带到生活中，或者把与人相处时的活泼性带到工作中，都会产生非常负面的影响；<br/><br/>3）总体来说，你缺乏一个完成目标的动力，但同时你对工作完成度的完美追求让你进度十分缓慢，甚至停滞不前，以致无法在限期内完成任务；<br/><br/>4）过分追求完美让你并不好受，因为这世上大部分事情都是不完美的，未能接纳到这点的你很容易因此钻牛角尖，变得情绪低落。',
	  'suggest': '1）学会将活泼型和完美型两种不同类型在工作学习或人际交往中完美切换，工作时就进入好好工作的状态，而与人交往时就热情开朗一点。当两种状态让你比较迷糊时，你可以通过洗个脸、深吸一口气等小技巧来进行自我调整；<br/><br/>2）你对自我形象管理很重视，健谈的你容易成为谈话的中心者，不自觉地会把关注重点转移到自己身上，从而忽略了别人，把关注焦点分担到身边的人身上吧，这不是你一个人的独角戏；<br/><br/>4）接受这个世界是不完美的，学会欣赏缺陷美，你会变得更轻松，发现这个世界另一面的美好。',
	  'match_jobs': '艺术家、音乐家'
	}, { 'key': 'pm',
	  'sex': 'male',
	  'animal': '大红鹳',
	  'animal_en': 'Phoenicopterusroseus',
	  'pic': '../static/funreports/dahonghe/animal.png',
	  'tags': '吃瓜群众、悲观主义者、后知后觉、内心戏多、纠结、拖延症、选择困难、细心',
	  'short_description': '大红鹳性情温和，有着艳丽的羽毛，优雅的脖颈。它们每年都会在固定的时间从中美洲飞往佛罗里达半岛，起飞时就像一条红色的彩练从蓝天白云中掠过。和大红鹳相似的是，你性情也是很温和的，对美有一定追求，而且喜欢遵循自己既定的习惯，不喜欢被人打乱计划。',
	  'coordinate': '',
	  'basic_discription': '比起呆板的做工作，你认为有一个良好的人际关系才是更重要的。你的性格圆滑，和你相处总是让人感到舒适，就像一块朴实没有棱角的玉石。凭借你的性格，你总是能够很好地融入群体中。你为人低调，不愿意成为焦点人物，不过，虽然你崇尚低调，但不得说，你是比较有穿衣品味的，呈现在大家眼前总是那么干净大方。在做事方面，你秉承的是：温和地说话，小心行事，这与你低调的个性相互呼应。',
	  'in_lover': '在感情中的你是比较慢热，但这并不代表你内心没有小激动，只是你不太善于表现出来而已。在两性相处过程中，你表现的不够主动，如果另一方不主动，你可能就不会有所行动的那种，容易让她觉得你太闷，无趣。<br/><br/>在面对对方身上一些你不太能接受的缺点时，可能会对她提出要求，换句话就是会嫌弃对方。另外，由于你在情感方面的不善表达，在对方有所期待或者对方对你好时，你的不回应容易让她觉得你会有些冷淡哦。',
	  'in_friends': '在朋友眼中，你平和，易于相处，热心助人，经常在朋友需要的时候帮助他们。但是有的时候，你的不忍拒绝会让自己被越来越多的事情缠身，难以轻松。在朋友眼中，你懂得关爱他人，关心他人感受，是一个很好的聆听者，注意细节的你也善于通过分析为他们给出适当的建议。但是有的时候你的沉默会让他们觉得你和他们并不是那么的亲近。',
	  'in_colleagues': '你是团队的粘合剂，工作上有着良好的执行与团结协调团队的能力；善于细节，考虑问题透彻，能够胜任一些清单式工作，对工作的执行进度有一定的监控。不过比起主动承担或主导重要的任务，你更愿意协助其他人，把事情做好。在领导眼中，难免会显得不够上进。',
	  'will_be': '在子女的眼中，你不会是一个严厉苛责的家长，对孩子并不会提出太高的要求。与此同时，你是一个言行一致的家长，虽然你不会承诺过多，但是只要你答应的都会兑现。在家里，你比较讲究家里的条理性，比较难忍受自己的家里乱糟糟的。会为子女的生活打点好，甚至有的时候会显得过于操心了。',
	  'advantage': '1）你的外在表现冷静，但却不会阴郁，在他人的眼中是一个易于相处的人，和你交谈总会有一种自在的感觉；<br/><br/>2）你对人宽容，性格温和的你，基本很少会和他人争论，能和大多数的人友好相处；<br/><br/>3）你追求完美却不过分，这让你在工作和处事方面，总能把握一个良好的度。对自己的工作有要求，追求细节的同时，能较好、较高效地把事情完成，而不是被高要求、细节控所牵绊。',
	  'shortcoming': '1）在做决定的时候，显得困难，在这方面比较迟缓，甚至会因此耽搁事情；<br/><br/>2）内向的你容易在某些时候表现沉默，这让他人会感觉与你距离较远；<br/><br/>3）很好说话的你，比较难拒绝他人，有的时候容易被他人利用；<br/><br/>4）你的性子慢，反应速度不快，有时难以跟上生活的快速节奏。',
	  'suggest': '1）学会提高自己的决策能力，克服自己遇事逃避的缺点，勇于开始，对失败持有正确的观念；<br/><br/>2）多与他人进行沟通，不要隐藏自己的意见或内心感受，过多的沉默会把你与他人的距离拉开得更远；<br/><br/>3）在与他人相处的时候，多些不一样的改变，尽力去尝试些新鲜事物，这样会给你的人际或感情生活带来不一样的体验。',
	  'match_jobs': '梦想规划师，作家，小说家'
	}, { 'key': 'pm',
	  'sex': 'female',
	  'animal': '大红鹳',
	  'animal_en': 'Phoenicopterusroseus',
	  'pic': '../static/funreports/dahonghe/animal.png',
	  'tags': '吃瓜群众、悲观主义者、后知后觉、内心戏多、纠结、拖延症、选择困难、细心',
	  'short_description': '大红鹳性情温和，有着艳丽的羽毛，优雅的脖颈。它们每年都会在固定的时间从中美洲飞往佛罗里达半岛，起飞时就像一条红色的彩练从蓝天白云中掠过。和大红鹳相似的是，你性情也是很温和的，对美有一定追求，而且喜欢遵循自己既定的习惯，不喜欢被人打乱计划。',
	  'coordinate': '',
	  'basic_discription': '比起呆板的做工作，你认为有一个良好的人际关系才是更重要的。你的性格圆滑，和你相处总是让人感到舒适，就像一块朴实没有棱角的玉石。凭借你的性格，你总是能够很好地融入群体中。你为人低调，不愿意成为焦点人物，不过，虽然你崇尚低调，但不得说，你是比较有穿衣品味的，呈现在大家眼前总是那么干净大方。在做事方面，你秉承的是：温和地说话，小心行事，这与你低调的个性相互呼应。',
	  'in_lover': '在感情中的你是比较慢热，但这并不代表你内心没有小激动，只是你不太善于表现出来而已。在两性相处过程中，你倾向于表现为受支配型角色，如果另一方不主动，你可能就不会有所行动的那种。<br/><br/>大多时候你友善温和，与你在一起他会感到很舒适，不过因为你的内心情感细腻，有时会显得多愁善感，换句话说就是内心戏太多啦。另外，由于你在情感方面的不善表达，在对方有所期待或者对方对你好时，你的不回应容易让他觉得你会有些冷淡哦。',
	  'in_friends': '在朋友眼中，你平和，易于相处，热心助人，经常在朋友需要的时候帮助他们。但是有的时候，你的不忍拒绝会让自己被越来越多的事情缠身，难以轻松。在朋友眼中，你懂得关爱他人，关心他人感受，是一个很好的聆听者，注意细节的你也善于通过分析为他们给出适当的建议。但是有的时候你的沉默会让他们觉得你和他们并不是那么的亲近。',
	  'in_colleagues': '你是团队的粘合剂，工作上有着良好的执行与团结协调团队的能力；善于细节，考虑问题透彻，能够胜任一些清单式工作，对工作的执行进度有一定的监控。不过比起主动承担或主导重要的任务，你更愿意协助其他人，把事情做好。在领导眼中，难免会显得不够上进。',
	  'will_be': '在子女的眼中，你不会是一个严厉苛责的家长，对孩子并不会提出太高的要求。与此同时，你是一个言行一致的家长，虽然你不会承诺过多，但是只要你答应的都会兑现。在家里，你比较讲究家里的条理性，比较难忍受自己的家里乱糟糟的。会为子女的生活打点好，甚至有的时候会显得过于操心了。',
	  'advantage': '1）你的外在表现冷静，但却不会阴郁，在他人的眼中是一个易于相处的人，和你交谈总会有一种自在的感觉；<br/><br/>2）你对人宽容，性格温和的你，基本很少会和他人争论，能和大多数的人友好相处；<br/><br/>3）你追求完美却不过分，这让你在工作和处事方面，总能把握一个良好的度。对自己的工作有要求，追求细节的同时，能较好、较高效地把事情完成，而不是被高要求、细节控所牵绊。',
	  'shortcoming': '1）在做决定的时候，显得困难，在这方面比较迟缓，甚至会因此耽搁事情；<br/><br/>2）内向的你容易在某些时候表现沉默，这让他人会感觉与你距离较远；<br/><br/>3）很好说话的你，比较难拒绝他人，有的时候容易被他人利用；<br/><br/>4）你的性子慢，反应速度不快，有时难以跟上生活的快速节奏。',
	  'suggest': '1）学会提高自己的决策能力，克服自己遇事逃避的缺点，勇于开始，对失败持有正确的观念；<br/><br/>2）多与他人进行沟通，不要隐藏自己的意见或内心感受，过多的沉默会把你与他人的距离拉开得更远；<br/><br/>3）在与他人相处的时候，多些不一样的改变，尽力去尝试些新鲜事物，这样会给你的人际或感情生活带来不一样的体验。',
	  'match_jobs': '梦想规划师，作家，小说家'
	}, { 'key': 'ps',
	  'sex': 'male',
	  'animal': '斑马',
	  'animal_en': 'Zebra',
	  'pic': '../static/funreports/banma/animal.png',
	  'tags': '富有同情心、随遇而安、脾气好、和平主义者、耳根子软、船到桥头自然直、为人着想',
	  'short_description': '斑马性格温和，是具有很强社会性的群居动物，彼此间会互相梳理皮毛，而且群体概念较高，即使年老的个体也不会被驱逐出去，幼仔们也会在一起玩耍嬉闹。你的性格就像斑马一样，温和好脾气，你喜欢和朋友在一起的感觉，朋友的陪伴常常让你感觉到安心。',
	  'coordinate': '',
	  'basic_discription': '比起呆板的做工作，你认为有一个良好的人际关系才是更重要的。你虽然低调冷静，但又容易交友，这样的性格很是受欢迎的。一开始接触你的时候，他人总是会被你安静的外表所“一时蒙骗”，但在更多更深入的接触之后，会发现你其实是一个活跃的人，尤其在熟悉之后，你的“话唠”特性渐渐暴露。',
	  'in_lover': '在与另一半相处时，你表现得友善温和，但又不乏情趣，不得不说，你是一个很不错的交往对象。不过一开始的你是比较慢热的，但是一旦你懂得在感情中的相处之道，知道对方什么时候需要安静的陪伴，总在最恰当的时机活跃氛围。你会很为对方着想，平日里会为对方想很多，行动上也是非常的体贴，日常生活中的点点滴滴就十分让对方感动。但你的情绪有时容易受到外部事物的影响而起伏波动，一旦闹气情绪来，可能会让对方难以招架。',
	  'in_friends': '在朋友眼中，你是一个平和但不失风趣的人，和你在一起，基本不会出现冷场的情况，因为你总能很好地控制好当下的气氛，适当地把气氛活跃起来，总能把握好那个度，不至于显得聒噪烦人，或者爱出风头。你富有同情心，乐于助人，关心他人的感受，但是有时会因为获取太多他人的负面情绪，你自己的心情也会被影响到呢，因此你需要学会做一个聪明的“聆听者”，而不是别人“坏情绪”的垃圾桶哦。',
	  'in_colleagues': '你的良好人际关系为你的工作加分不少，对内有着良好的同事关系，对外也能以你的友好社交博得合作伙伴的好感。你善于处理与同事之间的关系，一般不会干涉他人，更多的是鼓励团队成员参与。然而，你的上进心不强，比起独立工作，你更愿意在他人的指导与安排下工作，不会主动去承担有挑战性的工作。',
	  'will_be': '在子女的眼中，你是一个易于亲近的父亲，你的性情温和，基本不会对子女大声说话。你民主，愿意倾听子女内心的声音，愿意陪孩子一起玩耍成长，是很好的陪伴型父母。',
	  'advantage': '1）你的性格平和，但却不乏活力，可以以“静若处子，动若脱兔”形容；<br/><br/>2）你爱说话却不会显得聒噪，能够活跃团队的气氛，给大家生活带来欢乐；<br/><br/>3）你善于把握与他人交往的距离，既不会过于侵犯他人的边界，但又不会与他人过于疏远；<br/><br/>4）你崇尚表达的自由，不干涉他人的客观态度，基本很少会和他人发生争吵；<br/><br/>5）你善于调节问题，充当“和事佬”的角色，保持着中立的态度。',
	  'shortcoming': '1）你的上进心不强，追求安逸，喜欢安定的生活和工作；<br/><br/>2）平日里你是个小懒虫，比较难以坚持做一件事，自制力比较差；<br/><br/>3）很好说话的你，比较难拒绝他人，有的时候容易被他人利用。',
	  'suggest': '1）不要过于安于现状，适当去挑战新鲜事物，也许会有新的发现。让自己振奋起来，你可以参加不同的活动小组，通过旅游试着去体验不同的人他们的生活，或其他方式让自己的生活多一些激情；<br/><br/>2）为自己平淡的生活制定一些目标，让每一天都过的有价值。你可以运用电脑桌面软件制定一个日、周、月计划表，要求自己今日事今日毕，必要时接受他人督促；<br/><br/>3）学会说“不”，首先，多想想自己真正想要的是什么，再者学会委婉拒绝的技巧，要知道一味地满足他人的要求或求助是没有主见的表现；<br/><br/>4）学会接受生活的责任，不要过于唠叨，总是为生活的小事而喋喋不休，你应该要像个爷们一样，勇于承担生活的责任，从逆境中寻找突破；<br/><br/>5）培养正确的消费观念，可以从使用记账小工具开始，培养理财的观念。',
	  'match_jobs': '老师，心理咨询师，幼教，'
	}, { 'key': 'ps',
	  'sex': 'female',
	  'animal': '斑马',
	  'animal_en': 'Zebra',
	  'pic': '../static/funreports/banma/animal.png',
	  'tags': '富有同情心、随遇而安、脾气好、和平主义者、耳根子软、船到桥头自然直、为人着想',
	  'short_description': '斑马性格温和，是具有很强社会性的群居动物，彼此间会互相梳理皮毛，而且群体概念较高，即使年老的个体也不会被驱逐出去，幼仔们也会在一起玩耍嬉闹。你的性格就像斑马一样，温和好脾气，你喜欢和朋友在一起的感觉，朋友的陪伴常常让你感觉到安心。',
	  'coordinate': '',
	  'basic_discription': '比起呆板的做工作，你认为有一个良好的人际关系才是更重要的。你虽然低调冷静，但又容易交友，这样的性格很是受欢迎的。一开始接触你的时候，他人总是会被你安静的外表所“一时蒙骗”，但在更多更深入的接触之后，会发现你其实是一个活跃的人，尤其在熟悉之后，你的“话唠”特性渐渐暴露。另外，你有时容易受到惊吓，别人可能会觉得你总是一惊一乍，但其实你的确是被吓住了。',
	  'in_lover': '在与另一半相处时，你表现得友善温和，但又不乏情趣，不得不说，你是一个很不错的交往对象。不过一开始的你是比较慢热的，但是一旦你懂得在感情中的相处之道，知道对方什么时候需要安静的陪伴，总在最恰当的时机活跃氛围。你会很为对方着想，平日里会为对方想很多，行动上也是非常的体贴，日常生活中的点点滴滴就十分让对方感动。但你的情绪有时容易受到外部事物的影响而起伏波动，一旦闹气情绪来，可能会让对方难以招架。',
	  'in_friends': '在朋友眼中，你是一个平和但不失风趣的人，和你在一起，基本不会出现冷场的情况，因为你总能很好地控制好当下的气氛，适当地把气氛活跃起来，总能把握好那个度，不至于显得聒噪烦人，或者爱出风头。你富有同情心，乐于助人，关心他人的感受，但是有时会因为获取太多他人的负面情绪，你自己的心情也会被影响到呢，因此你需要学会做一个聪明的“聆听者”，而不是别人“坏情绪”的垃圾桶哦。',
	  'in_colleagues': '你的良好人际关系为你的工作加分不少，对内有着良好的同事关系，对外也能以你的友好社交博得合作伙伴的好感。你善于处理与同事之间的关系，一般不会干涉他人，更多的是鼓励团队成员参与。然而，你的上进心不强，比起独立工作，你更愿意在他人的指导与安排下工作，不会主动去承担有挑战性的工作。',
	  'will_be': '在子女的眼中，你是一个易于亲近的母亲，你的性情温和，基本不会对子女大声说话。你民主，愿意倾听子女内心的声音，愿意陪孩子一起玩耍成长，是很好的陪伴型父母。',
	  'advantage': '1）你的性格平和，但却不乏活力，可以以“静若处子，动若脱兔”形容；<br/><br/>2）你爱说话却不会显得聒噪，能够活跃团队的气氛，给大家生活带来欢乐；<br/><br/>3）你善于把握与他人交往的距离，既不会过于侵犯他人的边界，但又不会与他人过于疏远；<br/><br/>4）你崇尚表达的自由，不干涉他人的客观态度，基本很少会和他人发生争吵；<br/><br/>5）你善于调节问题，充当“和事佬”的角色，保持着中立的态度。',
	  'shortcoming': '1）你的上进心不强，追求安逸，喜欢安定的生活和工作；<br/><br/>2）平日里你是个小懒虫，比较难以坚持做一件事，自制力比较差；<br/><br/>3）很好说话的你，比较难拒绝他人，有的时候容易被他人利用。',
	  'suggest': '1）不要过于安于现状，适当去挑战新鲜事物，也许会有新的发现。让自己振奋起来，你可以参加不同的活动小组，通过旅游试着去体验不同的人他们的生活，或其他方式让自己的生活多一些激情；<br/><br/>2）为自己平淡的生活制定一些目标，让每一天都过的有价值。你可以运用电脑桌面软件制定一个日、周、月计划表，要求自己今日事今日毕，必要时接受他人督促；<br/><br/>3）学会说“不”，首先，多想想自己真正想要的是什么，再者学会委婉拒绝的技巧，要知道一味地满足他人的要求或求助是没有主见的表现；<br/><br/>4）学会接受生活的责任，不要过于唠叨，总是为生活的小事而喋喋不休，你应该要像个爷们一样，勇于承担生活的责任，从逆境中寻找突破；<br/><br/>5）培养正确的消费观念，可以从使用记账小工具开始，培养理财的观念。',
	  'match_jobs': '老师，心理咨询师，幼教，'
	}, { 'key': 'pc',
	  'sex': 'male',
	  'animal': '熊猫',
	  'animal_en': 'Ailuropodamelanoleuca',
	  'pic': '../static/funreports/xiongmao/animal.png',
	  'tags': '淡定、倔强、不撞南墙不回头、我（以前）不是吃素的、人不犯我我不犯人、腹黑、意志坚定',
	  'short_description': '你独立自信，但偏偏容易满足。这不是很像熊猫吗！明明最初是吃肉的，却变成“其实竹子也很好吃”的地步；明明是猛兽，却偏偏靠卖萌为生。不过，熊猫团子固然可爱，但千万不要触碰它们的底（食）线（物），因为它们对自己认定事情是不会轻易放弃的，你也一样。',
	  'coordinate': '',
	  'basic_discription': '比起呆板的做工作，你认为有一个良好的人际关系才是更重要的。总体来说，你是自信沉稳的社交类型，你的性格结合了低调冷静、有耐心和进取的特质，拥有这样性格的你善言谈，有想法却不张扬，具有和他人交往的良好能力。不过在熟悉之后，可能会发现你也有固执的一面。',
	  'in_lover': '你并不是一个很浪漫的人，一不小心就会把日子过得老夫老妻那样，你的另一半可能会因此有所抱怨。但你对感情忠诚，有责任感，这正是你在感情方面最闪亮的优点。你常会依赖于对方为你决定生活中的琐碎小事，对你来说，贤妻良母型的伴侣最为合适。<br/><br/>你看重婚姻，于你而言，家是一个能让你感到安定的地方，即使工作再苦再累，只要想到你的另一半与属于你们之间的家，你就会有勇往直前的动力。在做大决策的时候，你会显得有点大男人主义，会要求伴侣听从你的意见，如果对方也是一个比较有主见的人，你们可能会因此而争吵。',
	  'in_friends': '你是一个比较注重他人感受的人，愿意从朋友的立场为其着想。朋友们也很愿意找你，尤其在遇到问题的时候，你总能给他们提供解决问题的建议，有的时候甚至会和朋友讲起大道理来。你是一个对事物有自己独特的想法，于朋友而言，和你交往能收获不少，但有的时候容易会在某些问题上发生分歧，这时候的你比较固执。但这只是你实事求是的表现，你绝不会在这些问题上刁难他人。',
	  'in_colleagues': '你的执行力较强，在面对风暴时能冷静处事，习惯先后退一步等一等，在你的脑中有着明确的目标，你会默默地计划，一步一步地把目标实现。你的管理能力强，如果你作为领导，比起用职权让下属做事，你的客观态度与友好的做事风格能够让下属很好地配合你的工作。良好的人际关系和善于聆听让你能在团队中建立较好的威信。不过有的时候，你对自己的高要求可能会影响到团队其他人，给大家的工作带来一定的紧张感。',
	  'will_be': '你在子女眼中会是一个比较严肃的父亲，有着一种无声的威严。你很少会大声和孩子说话，对于子女比较琐碎的事情，你并不太关心，这让子女感觉和你是比较远。你的另一半可能会对此有些抱怨。对你来说，努力拼搏，提升家庭的幸福是你最大的使命，并不能很好地顾及更多。',
	  'advantage': '1）你比较善于交谈，在与别人交流的时候，更偏向于谈自己的见解，容易给人留下较为自信的印象；<br/><br/>2）你个性沉稳，做事靠谱，在工作和为人处事方面，都会给他人留下值得信赖的感觉；<br/><br/>3）你对自己有所要求，并会为所定下的目标而不断努力；<br/><br/>4）你说话不仅能引经据典，也能循循善诱，常常能不知不觉中说服别人，有较好的号召力。',
	  'shortcoming': '1）一般情况下，你都不愿意和他人发生争吵，但在某些不可让步的观点上，可能会情绪比较激烈，为自己观点据理力争，显得固执；<br/><br/>2）你不会轻易向他人坦露自我，表现为对他人有所防备，在谈及自己时，你会比较敏感；<br/><br/>3）你的内心矛盾，常会有两种截然相反的力量相互拉锯，有时会让你很难受。',
	  'suggest': '1）学会沟通的艺术。有些话换一种方式表达，效果会不一样，更让对方接受。如果你想要对方做什么事，不要总是说“你要……”，学会说“如果你……做，我觉得更好”；<br/><br/>2）适当坦露自己，能让他人觉得你更容易亲近些；<br/><br/>3）当你的内心产生不可调解的矛盾时，不妨退一步思考，自己真正想要的是什么，当下的情况最佳的做法是什么。',
	  'match_jobs': '领导者，政治家，管理者'
	}, { 'key': 'pc',
	  'sex': 'female',
	  'animal': '熊猫',
	  'animal_en': 'Ailuropodamelanoleuca',
	  'pic': '../static/funreports/xiongmao/animal.png',
	  'tags': '淡定、倔强、不撞南墙不回头、我（以前）不是吃素的、人不犯我我不犯人、腹黑、意志坚定',
	  'short_description': '你独立自信，但偏偏容易满足。这不是很像熊猫吗！明明最初是吃肉的，却变成“其实竹子也很好吃”的地步；明明是猛兽，却偏偏靠卖萌为生。不过，熊猫团子固然可爱，但千万不要触碰它们的底（食）线（物），因为它们对自己认定事情是不会轻易放弃的，你也一样。',
	  'coordinate': '',
	  'basic_discription': '比起呆板的做工作，你认为有一个良好的人际关系才是更重要的。总体来说，你是自信沉稳的社交类型，你的性格结合了低调冷静、有耐心和进取的特质，拥有这样性格的你善言谈，有想法却不张扬，具有和他人交往的良好能力。不过在熟悉之后，可能会发现你也有固执的一面。',
	  'in_lover': '你并不是一个很浪漫的人，在感情方面比较慢热，比较少主动去做一些让对方感动的事情，甚至有的时候，对方营造好的氛围，你会不解风情地把气氛搞砸。但你对感情忠诚，有责任感，这正是你在感情方面最闪亮的优点。作为女生，你在生活方面会显得比较大条，不够细心，甚至有的时候会被另一半埋怨，这个时候如果对方性格细腻、细心且包容你的话，你们可能会更合拍些。<br/><br/>你看重婚姻，对你来说家是一个能让你感到安定的地方，但这往往会和你的事业心有所冲突，不会放太多心思与精力在家庭上。你比较有自己想法，有的时候可能会与另一半在问题的见解方面发生冲突。',
	  'in_friends': '你是一个比较注重他人感受的人，愿意从朋友的立场为其着想。朋友们也很愿意找你，尤其在遇到问题的时候，你总能给他们提供解决问题的建议，有的时候甚至会和朋友讲起大道理来。你是一个对事物有自己独特的想法，于朋友而言，和你交往能收获不少，但有的时候容易会在某些问题上发生分歧，这时候的你比较固执。但这只是你实事求是的表现，你绝不会在这些问题上刁难他人。',
	  'in_colleagues': '你的执行力较强，在面对风暴时能冷静处事，习惯先后退一步等一等，在你的脑中有着明确的目标，你会默默地计划，一步一步地把目标实现。你的管理能力强，如果你作为领导，比起用职权让下属做事，你的客观态度与友好的做事风格能够让下属很好地配合你的工作。良好的人际关系和善于聆听让你能在团队中建立较好的威信。不过有的时候，你对自己的高要求可能会影响到团队其他人，给大家的工作带来一定的紧张感。',
	  'will_be': '你在子女眼中会是一个比较严肃的母亲，你的性格温和，虽然不会对子女约束太多，也不会很凶地责骂他们，但会有着一种无声的威严在。比起其他母亲，你放在子女琐碎生活的精力不会太多，更多的是给子女提出一定的要求，希望子女成为独立优秀的人。这往往让子女感觉和你是比较远的，你的另一半可能也会对此有些抱怨。对你来说，家庭并不是你生活的全部，你还有其他所追求的，例如你的职业也对你很重要。',
	  'advantage': '1）你比较善于交谈，在与别人交流的时候，更偏向于谈自己的见解，容易给人留下较为自信的印象；<br/><br/>2）你个性沉稳，做事靠谱，在工作和为人处事方面，都会给他人留下值得信赖的感觉；<br/><br/>3）你对自己有所要求，并会为所定下的目标而不断努力；<br/><br/>4）你说话不仅能引经据典，也能循循善诱，常常能不知不觉中说服别人，有较好的号召力。',
	  'shortcoming': '1）一般情况下，你都不愿意和他人发生争吵，但在某些不可让步的观点上，可能会情绪比较激烈，为自己观点据理力争，显得固执；<br/><br/>2）你不会轻易向他人坦露自我，表现为对他人有所防备，在谈及自己时，你会比较敏感；<br/><br/>3）你的内心矛盾，常会有两种截然相反的力量相互拉锯，有时会让你很难受。',
	  'suggest': '1）学会沟通的艺术。有些话换一种方式表达，效果会不一样，更让对方接受。如果你想要对方做什么事，不要总是说“你要……”，学会说“如果你……做，我觉得更好”；<br/><br/>2）适当坦露自己，能让他人觉得你更容易亲近些；<br/><br/>3）当你的内心产生不可调解的矛盾时，不妨退一步思考，自己真正想要的是什么，当下的情况最佳的做法是什么。',
	  'match_jobs': '领导者，政治家，管理者'
	}, { 'key': 'scpm',
	  'sex': 'male',
	  'animal': '麋鹿',
	  'animal_en': 'Elaphurusdavidianus',
	  'pic': '../static/funreports/milu/animal.png',
	  'tags': '矛盾型、人格分裂、善变、难以捉摸、一时一个样、高深莫测、神秘人物、随性而行',
	  'short_description': '你是柔和多种性格的万里挑一型。有时候你像马一样沉稳，有时候你给人鹿一样的跳脱，你从来不会受外界事物的束缚，特立独行的你，永远无法让他人知晓你下一步的行为和反应会是什么。',
	  'coordinate': '',
	  'basic_discription': '你是一个行为状态不太稳定的人，和你相处总是“惊喜重重”。你有时候很高调，有时候又很沉默，高兴时很主动，不开心时无限被动，更有时候你会对被外界突发事物打击到崩溃，但有时候也会保持冷静的心态去面对。总之，可能全凭你高兴。跳脱的你，也许对自己的性格把握也不是很准确，而他人更无从给予正确的判断。',
	  'in_lover': '在她看来，感情中的你对待爱情很有自己的一套策略。喜欢浪漫的你，常常能为对方带来很多惊喜。你不像那些大男子主义的人，总是强迫对方做到某种某种标准。事实上，你更多情况下是跟着她的意见和观点走的。她在很多事情上能够说服你，因为各种性格特征均包容的你，常常能站在更宽阔的视角去看待问题。当然，有时候你也会不讲道理，她需要比较长的时间才能把你摸透。',
	  'in_friends': '你简直就是传说中的“奇妙的朋友”好吗？！即便是朝夕相处，有时候你的朋友也不知道你下一刻的举动会是如何，因为你很少有一个比较稳定的行为模式。但同时这也是为什么你能成为朋友圈中偶尔出现的一剂清新剂了。朋友们往往无法揣摩你的举动，你总是会给他们带来一些意外的惊喜。',
	  'in_colleagues': '在同事看来，你既是一个没有鲜明特征的人，又是一个特征非常鲜明的人。首先，在你身上均衡了多种性格，因此不论和哪种类型的人交流，你都不会有太大的障碍和问题。但同时，你在表达自己观点和看法的时候，往往要么不鸣则已，保持中庸的态度和立场，要么一鸣惊人，从突破常规的角度和立场来提出新颖的观点。总之，你比较难以捉摸，但是有自己的个人魅力。',
	  'will_be': '在孩子的眼中，你算是一个明事理、讲道理的父亲。在一定程度上，你和孩子之间有共同的语言和话题。在孩子的世界中，任何新奇的，甚至不可思议的事情都能发生，这和你天马行空的性格刚好有所照应。但是在教育孩子的力度上可能稍微差了些。在教导孩子时，你的逻辑比较跳脱，说服力比较差，这方面需要改进。',
	  'advantage': '1）你是一个喜欢活在当下的人，在他人看来，你活的很真实，很自我，特立独行的你有一种独特的魅力；<br/><br/>2）你的思维比较不受限制，有较好的创意和想法，通常能对工作和学习中提出一些新颖的点子；<br/><br/>3）没有一项鲜明性格的你，也是你性格最大的特点。至少你能和不同性格的人或多或少都能聊得来。',
	  'shortcoming': '1）你不稳定的性格给人一种分裂的感觉。因为你的行为模式不确定，有时内向有时又很跳脱，给人无从把握的感觉；<br/><br/>2）为人处世有时候凭心情，如果是交心的朋友则会给予理解，而这会屏蔽一些对你不那么熟悉的朋友。',
	  'suggest': '天马行空的你，在为人处世上要么非常随性，随心所欲，全凭自己的情绪状态；要么非常中庸，自己的观点和看法不表露，听他人的。因而，要让自己的性格变得更加积极和健康，你需要在有自己主见的基础上，适当让自己的性格保持稳定性。提出观点和看法时，以事实为依据，这样才会有更好的说服力。',
	  'match_jobs': '创意岗，设计师'
	}, { 'key': 'scpm',
	  'sex': 'female',
	  'animal': '麋鹿',
	  'animal_en': 'Elaphurusdavidianus',
	  'pic': '../static/funreports/milu/animal.png',
	  'tags': '矛盾型、人格分裂、善变、难以捉摸、一时一个样、高深莫测、神秘人物、随性而行',
	  'short_description': '你是柔和多种性格的万里挑一型。有时候你像马一样沉稳，有时候你给人鹿一样的跳脱，你从来不会受外界事物的束缚，特立独行的你，永远无法让他人知晓你下一步的行为和反应会是什么。',
	  'coordinate': '',
	  'basic_discription': '你是一个行为状态不太稳定的人，和你相处总是“惊喜重重”。你有时候很高调，有时候又很沉默，高兴时很主动，不开心时无限被动，更有时候你会对被外界突发事物打击到崩溃，但有时候也会保持冷静的心态去面对。总之，可能全凭你高兴。跳脱的你，也许对自己的性格把握也不是很准确，而他人更无从给予正确的判断。',
	  'in_lover': '在他看来，感情中的你对待爱情很有自己的一套策略。喜欢浪漫的你，常常能为对方带来很多惊喜。你不会总是强迫对方做到某种某种标准，相反，你更多情况下是跟着他的意见和观点走的。他在很多事情上能够说服你，因为各种性格特征均包容的你，常常能站在更宽阔的视角去看待问题。当然，有时候你也会不讲道理，他需要比较长的时间才能把你摸透。',
	  'in_friends': '你简直就是传说中的“奇妙的朋友”好吗？！即便是朝夕相处，有时候你的朋友也不知道你下一刻的举动会是如何，因为你很少有一个比较稳定的行为模式。但同时这也是为什么你能成为朋友圈中偶尔出现的一剂清新剂了。朋友们往往无法揣摩你的举动，你总是会给他们带来一些意外的惊喜。',
	  'in_colleagues': '在同事看来，你既是一个没有鲜明特征的人，又是一个特征非常鲜明的人。首先，在你身上均衡了多种性格，因此不论和哪种类型的人交流，你都不会有太大的障碍和问题。但同时，你在表达自己观点和看法的时候，往往要么不鸣则已，保持中庸的态度和立场，要么一鸣惊人，从突破常规的角度和立场来提出新颖的观点。总之，你比较难以捉摸，但是有自己的个人魅力。',
	  'will_be': '在孩子的眼中，你算是一个明事理、讲道理的妈妈。在一定程度上，你和孩子之间有共同的语言和话题。在孩子的世界中，任何新奇的，甚至不可思议的事情都能发生，这和你天马行空的性格刚好有所照应。但是在教育孩子的力度上可能稍微差了些。在教导孩子时，你的逻辑比较跳脱，说服力比较差，这方面需要改进。',
	  'advantage': '1）你是一个喜欢活在当下的人，在他人看来，你活的很真实，很自我，特立独行的你有一种独特的魅力；<br/><br/>2）你的思维比较不受限制，有较好的创意和想法，通常能对工作和学习中提出一些新颖的点子；<br/><br/>3）没有一项鲜明性格的你，也是你性格最大的特点。至少你能和不同性格的人或多或少都能聊得来。',
	  'shortcoming': '1）你不稳定的性格给人一种分裂的感觉。因为你的行为模式不确定，有时内向有时又很跳脱，给人无从把握的感觉；<br/><br/>2）为人处世有时候凭心情，如果是交心的朋友则会给予理解，而这会屏蔽一些对你不那么熟悉的朋友。',
	  'suggest': '天马行空的你，在为人处世上要么非常随性，随心所欲，全凭自己的情绪状态；要么非常中庸，自己的观点和看法不表露，听他人的。因而，要让自己的性格变得更加积极和健康，你需要在有自己主见的基础上，适当让自己的性格保持稳定性。提出观点和看法时，以事实为依据，这样才会有更好的说服力。',
	  'match_jobs': '创意岗，设计师'
	}];
	var finalData = {};
	for (var i = 0; i < data.length; i++) {
	  var _this = data[i],
	      group = _this.key;
	  if (finalData[group] != undefined) {
	    if (_this.sex == 'male') {
	      finalData[group][1] = _this;
	    } else {
	      finalData[group][2] = _this;
	    }
	  } else {
	    finalData[group] = {};
	    if (_this.sex == 'male') {
	      finalData[group][1] = _this;
	    } else {
	      finalData[group][2] = _this;
	    }
	  }
	};
	exports.default = finalData;

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/indexNq-share.4b5b860.jpg";

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _apis = __webpack_require__(5);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(17);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'funReport',
		data: function data() {
			return {
				tags: this.$store.state.funreport != null ? this.$store.state.funreport.tags.replace(/&quot;/g, '').split('、') : ''
			};
		},
		mounted: function mounted() {
			if (navigator.userAgent.indexOf('Android') > 0) {
				var allLi = document.querySelectorAll('.tagsNavatar .tags li');
				for (var i = 0; i < allLi.length; i++) {
					allLi[i].className += 'android';
				}
	
				setInterval(function () {
					for (var _i = 0; _i < allLi.length; _i++) {
						allLi[_i].style.marginTop = Math.random() * 10 + 'px';
						allLi[_i].style.marginBottom = Math.random() * 10 + 'px';
					}
				}, 1000);
			};
		},
	
		computed: (0, _extends3.default)({
			tagObj: function tagObj() {
				var result = {};
				if (this.$store.state.selfResult.tagstr == '') {
					var tags = this.$data.tags;
					for (var i = 0; i < tags.length; i++) {
						result[tags[i]] = {};
						result[tags[i]].num = 0;
					}
				} else {
					var json = JSON.parse(this.$store.state.selfResult.tagstr.replace(/&quot;/g, '"').replace(/null/g, '0'));
					var _tags = this.$data.tags;
					for (var _i2 = 0; _i2 < _tags.length; _i2++) {
						result[_tags[_i2]] = {};
						result[_tags[_i2]].num = json[_tags[_i2]];
					}
				}
				return this.$data.tagObj = result;
			}
		}, (0, _vuex.mapState)({
			funreport: function funreport(state) {
				return state.funreport;
			},
			selfResult: function selfResult(state) {
				return state.selfResult;
			}
		})),
		methods: {
			countTags: function countTags(whichTag, dom) {
				var _this = null,
				    sendTags = {},
				    componet = this;
				if (event.target.tagName.toLowerCase() == 'img') {
					_this = event.target.parentNode;
				} else if (event.target.tagName.toLowerCase() == 'li') {
					_this = event.target;
				};
	
				if (navigator.userAgent.indexOf('Android') > 0) {
					_this.className += ' click';
					setTimeout(function () {
						_this.className = _this.className.replace('click', '');
					}, 1000);
				}
	
				if (_this.className.indexOf('clear') < 0) {
					var allLi = document.querySelectorAll('.tagsNavatar .tags li');
					for (var i = 0; i < allLi.length; i++) {
						allLi[i].className += ' clear';
					}
				}
	
				if (!componet.tagObj[whichTag].isLock) {
					componet.tagObj[whichTag].num += 1;
					if (_this.className.indexOf('minus') > 0) {
						_this.className.replace('minus', '');
					}
					if (_this.className.indexOf('add') < 0) {
						_this.className += ' add';
					}
				} else {
					componet.tagObj[whichTag].num -= 1;
					if (_this.className.indexOf('add') > 0) {
						_this.className.replace('add', '');
					}
					if (_this.className.indexOf('minus') < 0) {
						_this.className += ' minus';
					}
				}
				componet.tagObj[whichTag].isLock = !componet.tagObj[whichTag].isLock;
	
				for (var _i3 = 0; _i3 < componet.tags.length; _i3++) {
					var index = componet.tags[_i3];
					sendTags[index] = componet.tagObj[index].num;
				}
				var postData = {
					tagstr: (0, _stringify2.default)(sendTags),
					id: componet.selfResult.activate_id
				};
				_axios2.default.post(_apis2.default.tagclick, _qs2.default.stringify(postData)).then(function (res) {
					if (res.data.code == 200) {}
				}).catch(function (error) {
					console.log(error);
				});
			},
			removeAnimate: function removeAnimate() {
				event.target.parentNode.parentNode.className = event.target.parentNode.parentNode.className.replace('add', '');
				event.target.parentNode.parentNode.className = event.target.parentNode.parentNode.className.replace('minus', '');
			},
			goDownload: function goDownload() {
				_router2.default.push({
					name: 'download',
					path: '/download'
				});
			}
		}
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(11);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _apis = __webpack_require__(5);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(17);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'funBodyShare',
		data: function data() {
			return {
				tags: this.$store.state.sharereport != '' ? this.$store.state.sharereport.tags.split('、') : ''
			};
		},
		mounted: function mounted() {
			if (navigator.userAgent.indexOf('Android') > 0) {
				var allLi = document.querySelectorAll('.tagsNavatar .tags li');
				for (var i = 0; i < allLi.length; i++) {
					allLi[i].className += 'android';
				}
	
				setInterval(function () {
					for (var _i = 0; _i < allLi.length; _i++) {
						allLi[_i].style.marginTop = Math.random() * 7 + 'px';
						allLi[_i].style.marginBottom = Math.random() * 7 + 'px';
					}
				}, 1000);
			};
		},
	
		computed: (0, _extends3.default)({
			tagObj: function tagObj() {
				var result = {};
				if (this.$store.state.selfResult.tagstr == '') {
					var tags = this.$data.tags;
					for (var i = 0; i < tags.length; i++) {
						result[tags[i]] = {};
						result[tags[i]].num = 0;
					}
				} else {
					var json = JSON.parse(this.$store.state.selfResult.tagstr.replace(/&quot;/g, '"').replace(/null/g, '0'));
					var _tags = this.$data.tags;
					for (var _i2 = 0; _i2 < _tags.length; _i2++) {
						result[_tags[_i2]] = {};
						result[_tags[_i2]].num = json[_tags[_i2]];
					}
				}
				return this.$data.tagObj = result;
			}
		}, (0, _vuex.mapState)({
			funreport: function funreport(state) {
				return state.sharereport;
			},
			selfResult: function selfResult(state) {
				return state.selfResult;
			}
		})),
		methods: {
			countTags: function countTags(whichTag, dom) {
				var _this = null,
				    sendTags = {},
				    componet = this;
				if (event.target.tagName.toLowerCase() == 'img') {
					_this = event.target.parentNode;
				} else if (event.target.tagName.toLowerCase() == 'li') {
					_this = event.target;
				};
	
				if (navigator.userAgent.indexOf('Android') > 0) {
					_this.className += ' click';
					setTimeout(function () {
						_this.className = _this.className.replace('click', '');
					}, 1000);
				}
	
				if (_this.className.indexOf('clear') < 0) {
					var allLi = document.querySelectorAll('.tagsNavatar .tags li');
					for (var i = 0; i < allLi.length; i++) {
						allLi[i].className += ' clear';
					}
				}
	
				if (!componet.$data.tagObj[whichTag].isLock) {
					componet.$data.tagObj[whichTag].num += 1;
					if (_this.className.indexOf('minus') > 0) {
						_this.className.replace('minus', '');
					}
					if (_this.className.indexOf('add') < 0) {
						_this.className += ' add';
					}
				} else {
					componet.$data.tagObj[whichTag].num -= 1;
					if (_this.className.indexOf('add') > 0) {
						_this.className.replace('add', '');
					}
					if (_this.className.indexOf('minus') < 0) {
						_this.className += ' minus';
					}
				}
				componet.$data.tagObj[whichTag].isLock = !componet.$data.tagObj[whichTag].isLock;
	
				for (var _i3 = 0; _i3 < componet.$data.tags.length; _i3++) {
					var index = componet.$data.tags[_i3];
					sendTags[index] = componet.$data.tagObj[index].num;
				}
				var postData = {
					tagstr: (0, _stringify2.default)(sendTags),
					id: componet.selfResult.activate_id
				};
				_axios2.default.post(_apis2.default.tagclick, _qs2.default.stringify(postData)).then(function (res) {
					if (res.data.code == 200) {}
				}).catch(function (error) {
					console.log(error);
				});
			},
			removeAnimate: function removeAnimate() {
				event.target.parentNode.parentNode.className = event.target.parentNode.parentNode.className.replace('add', '');
				event.target.parentNode.parentNode.className = event.target.parentNode.parentNode.className.replace('minus', '');
			}
		}
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'friendList',
		computed: (0, _vuex.mapState)({
			friendList: function friendList(state) {
				return state.friendList;
			},
			busy: function busy(state) {
				return state.busy;
			}
		}),
		methods: {
			friendreport: function friendreport(id) {
				_router2.default.push({
					path: '/sharereport/',
					name: 'sharereport',
					params: { reportId: id }
				});
			}
		}
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
		name: 'funHead',
		computed: (0, _vuex.mapState)({
			funreport: function funreport(state) {
				return state.funreport;
			}
		})
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	exports.default = {
		name: 'shareReportHead',
		components: {},
		data: function data() {
			return {
				tags: this.$store.state.funreport != null ? this.$store.state.funreport.tags.split('、') : ''
			};
		},
	
		computed: (0, _vuex.mapState)({
			funreport: function funreport(state) {
				return state.sharereport;
			},
			selfResult: function selfResult(state) {
				return state.selfResult;
			}
		})
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'qrcodeMask'
	};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _yxlLogo = __webpack_require__(7);
	
	var _yxlLogo2 = _interopRequireDefault(_yxlLogo);
	
	var _qrcodeMask = __webpack_require__(9);
	
	var _qrcodeMask2 = _interopRequireDefault(_qrcodeMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'IndexPage',
	  created: function created() {
	    if (this.$route.query.channel_id) {
	      this.setChannelId(this.$route.query.channel_id);
	    }
	    if (this.GetQueryString("channel_id")) {
	      this.setChannelId(this.GetQueryString("channel_id"));
	    }
	  },
	  mounted: function mounted() {
	    this.pullQuestion(this.getObjLength);
	    this.pullIstested();
	
	    document.querySelector('.page-index').style.minHeight = window.screen.availHeight - 45 + 'px';
	
	    document.title = '你是萌兽，还是猛兽？';
	    this.$data.oldUnlock = this.shareLock + '';
	
	    var that = this;
	    wx.ready(function () {
	      wx.onMenuShareAppMessage({
	        title: '你是萌兽，还是猛兽？',
	        desc: '超准的心理测试，用动物看出你真正的性格！',
	        link: 'http://static.xinli001.com/animalPicture/index.html',
	        imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg",
	        type: '',
	        dataUrl: '',
	        success: function success() {
	          zhuge.track('测评活动', {
	            '被分享页面': '首页或答题页'
	          });
	        },
	        cancel: function cancel() {}
	      });
	
	      wx.onMenuShareTimeline({
	        title: '你是萌兽，还是猛兽？',
	        link: 'http://static.xinli001.com/animalPicture/index.html',
	        imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg",
	        success: function success() {
	          zhuge.track('测评活动', {
	            '被分享页面': '首页或答题页'
	          });
	        },
	        cancel: function cancel() {}
	      });
	
	      wx.hideMenuItems({
	        menuList: ['menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari", "menuItem:copyUrl"] });
	    });
	  },
	  data: function data() {
	    return {
	      redoDialogShow: 0,
	      oldUnlock: 0
	    };
	  },
	
	  components: {
	    yxlLogo: _yxlLogo2.default,
	    qrcodeMask: _qrcodeMask2.default
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['pullQuestion', 'pullIstested']), (0, _vuex.mapMutations)(['setSex', 'setIstested', 'emptyReport', 'setStayFun', 'setChannelId']), {
	    redoDialog: function redoDialog() {
	      this.$data.redoDialogShow = !this.$data.redoDialogShow;
	    },
	    redo: function redo() {
	      this.$data.isTested = 0;
	      this.setIstested(0);
	      this.$data.redoDialogShow = 0;
	      this.emptyReport();
	    },
	    checkReport: function checkReport() {
	      this.setStayFun(false);
	      _router2.default.push({
	        path: '/funreport',
	        name: 'funreport',
	        query: {
	          channel_id: this.channel_id
	        }
	      });
	    },
	    answerSex: function answerSex(str) {
	      this.setSex(str);
	      _router2.default.push({
	        name: 'question',
	        params: {
	          questionId: 1
	        },
	        query: {
	          channel_id: this.channel_id
	        }
	      });
	    }
	  }),
	  computed: (0, _extends3.default)({
	    sex: function sex() {
	      return this.$store.state.sex;
	    },
	    isTested: function isTested() {
	      return this.$store.state.isTested;
	    }
	  }, (0, _vuex.mapState)({
	    stayFun: function stayFun(state) {
	      return state.stayFun;
	    },
	    channel_id: function channel_id(state) {
	      return state.channel_id;
	    }
	  }))
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vuex = __webpack_require__(1);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'download',
		computed: (0, _vuex.mapState)({
			funreport: function funreport(state) {
				return state.funreport;
			}
		}),
		mounted: function mounted() {
			document.querySelector('.page-download').style.minHeight = window.screen.availHeight + 'px';
	
			wx.ready(function () {
				wx.hideMenuItems({
					menuList: ['menuItem:share:qq', 'menuItem:share:timeline', "menuItem:share:appMessage", 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari", "menuItem:copyUrl"] });
			});
		}
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _apis = __webpack_require__(5);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _yxlLogo = __webpack_require__(7);
	
	var _yxlLogo2 = _interopRequireDefault(_yxlLogo);
	
	var _funHead = __webpack_require__(116);
	
	var _funHead2 = _interopRequireDefault(_funHead);
	
	var _funBody = __webpack_require__(113);
	
	var _funBody2 = _interopRequireDefault(_funBody);
	
	var _freeShare = __webpack_require__(112);
	
	var _freeShare2 = _interopRequireDefault(_freeShare);
	
	var _unlockShare = __webpack_require__(118);
	
	var _unlockShare2 = _interopRequireDefault(_unlockShare);
	
	var _funFriendList = __webpack_require__(115);
	
	var _funFriendList2 = _interopRequireDefault(_funFriendList);
	
	var _qrcodeMask = __webpack_require__(9);
	
	var _qrcodeMask2 = _interopRequireDefault(_qrcodeMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'funreportPage',
		components: {
			yxlLogo: _yxlLogo2.default,
			funHead: _funHead2.default,
			funReport: _funBody2.default,
			freeShare: _freeShare2.default,
			unlockShare: _unlockShare2.default,
			friendList: _funFriendList2.default,
			qrcodeMask: _qrcodeMask2.default
		},
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			_axios2.default.get(_apis2.default.getSelfReport, {
				params: {
					'isWeiXin': to.query.isWeiXin ? to.query.isWeiXin : 0
				}
			}).then(function (res) {
				var res = res.data;
				if (res.code == 200) {
					_store2.default.commit('setFunreport', { report: res.data, gender: res.data.gender });
					_store2.default.dispatch('getFriendList', res.data.activate_id);
				} else if (res.code == 1001) {
					window.location.href = _apis2.default.shouquan + '?callback=' + encodeURIComponent(location.href);
				}
			}).then(function () {
				next(function (vm) {});
			}).catch(function (error) {
				console.log(error);
			});
		},
		data: function data() {
			return {
				shareMask: false,
				isFirstShare: true,
				qrCodeMask: false,
				page: 1,
				oldUnlock: 0,
				friendListEnd: 0
			};
		},
		created: function created() {
			document.title = '你是萌兽，还是猛兽？';
		},
		mounted: function mounted() {
			document.body.scrollTop = 0;
			if (this.selfResult != undefined & this.selfResult.unlock == '1' & this.stayFun != true) {
				_router2.default.replace({
					name: 'proreport',
					path: '/proreport',
					query: {
						isWeiXin: this.$route.query.isWeiXin ? this.$route.query.isWeiXin : 0,
						channel_id: this.channel_id
					}
				});
			} else {
				this.setStayFun(true);
				document.querySelector('.page-funreport').style.minHeight = window.screen.availHeight - 45 + 'px';
			}
	
			this.$data.oldUnlock = this.shareLock + '';
			this.setFinishTest(true);
	
			var that = this;
			wx.ready(function () {});
			wx.ready(function () {
				var shareConfig = {
					title: '天了噜，' + that.selfResult.nickname + ' 灵魂深处竟然是神兽' + that.funreport.animal + '！',
					desc: '每个人身体里都有一只动物，代表着你最原始的兽性',
					link: 'http://static.xinli001.com/animalPicture/index.html?fromChannel=' + that.channel_id + '#/sharereport/' + that.selfResult.activate_id + '?' + Math.random(),
					imgUrl: 'http://static.xinli001.com/animalPicture/' + that.funreport.pic.replace('../', '') };
				setWxShare();
				function setWxShare() {
					wx.onMenuShareAppMessage({
						title: shareConfig.title,
						desc: shareConfig.desc,
						link: shareConfig.link,
						imgUrl: shareConfig.imgUrl,
						type: 'link',
						dataUrl: '',
						success: function success() {
							that.unLockReport(that.selfResult.activate_id);
	
							if (that.$data.oldUnlock == '0' & that.shareLock) {
								that.qrCodeMask = true;
							} else if (that.$data.oldUnlock == '1' & that.shareLock) {
								that.qrCodeMask = true;
							} else {
								that.qrCodeMask = false;
							}
							that.shareMask = false;
							zhuge.track('测评活动', {
								'被分享页面': '趣味报告页'
							});
						},
						cancel: function cancel() {}
					});
	
					wx.onMenuShareTimeline({
						title: shareConfig.title,
						link: shareConfig.link,
						imgUrl: shareConfig.imgUrl,
						success: function success() {
							that.unLockReport(that.selfResult.activate_id);
	
							if (that.$data.oldUnlock == '0' & that.shareLock) {
								that.qrCodeMask = true;
							} else if (that.$data.oldUnlock == '1' & that.shareLock) {
								that.qrCodeMask = true;
							} else {
								that.qrCodeMask = false;
							}
							that.shareMask = false;
							zhuge.track('测评活动', {
								'被分享页面': '趣味报告页'
							});
						},
						cancel: function cancel() {}
					});
	
					wx.hideMenuItems({
						menuList: ['menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari", "menuItem:copyUrl"] });
	
					wx.showMenuItems({
						menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"]
					});
				}
			});
		},
	
		computed: (0, _extends3.default)({
			price: function price() {
				var p = this.selfResult.discount_price ? this.selfResult.discount_price : '0',
				    result = '';
	
				if (p.split('.').length >= 2) {
					result = p.split('.')[0] + '.' + p.split('.')[1].slice(0, 2);
				} else {
					result = p.split('.')[0] + '.00';
				}
	
				return result;
			}
		}, (0, _vuex.mapState)({
			funreport: function funreport(state) {
				return state.funreport;
			},
			selfResult: function selfResult(state) {
				return state.selfResult;
			},
			shareLock: function shareLock(state) {
				return state.selfResult.unlock;
			},
			is_free: function is_free(state) {
				return state.selfResult.is_free;
			},
			friendList: function friendList(state) {
				return state.friendList;
			},
			stayFun: function stayFun(state) {
				return state.stayFun;
			},
			channel_id: function channel_id(state) {
				return state.channel_id;
			}
		})),
		methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['setshareLock', 'setBusy', 'setFriendList', 'setFinishTest', 'setStayFun', 'setChannelId']), (0, _vuex.mapActions)(['unLockReport', 'getSelfReport', 'unLockPeopleAdd', 'buyProReport']), {
			update: function update() {
				this.$data;
			},
			funToShare: function funToShare() {
				this.toggleShare();
				this.unLockPeopleAdd();
			},
			toggleShare: function toggleShare(share) {
				this.$data.shareMask = !this.$data.shareMask;
			},
			toProReport: function toProReport() {
				_router2.default.push({
					path: '/proreport/',
					name: 'proreport',
					query: {
						isWeiXin: this.$route.query.isWeiXin ? this.$route.query.isWeiXin : 0,
						channel_id: this.channel_id
					}
				});
			},
			oneQrcode: function oneQrcode() {
				this.$data.qrCodeMask = !this.$data.qrCodeMask;
				this.$data.isFirstShare = false;
			},
			buyReport: function buyReport() {
				this.buyProReport({
					test_id: 11,
					channel_id: this.channel_id
				});
			},
			loadMoreFriend: function loadMoreFriend() {
				if (this.$data.friendListEnd) {
					return;
				}
				var busy = this.$store.state.busy,
				    that = this;
				var offsetBottom = document.body.scrollHeight - document.querySelector('body').scrollTop - window.screen.availHeight;
				if (!busy & offsetBottom < 50) {
					that.setBusy(true);
					_axios2.default.get(_apis2.default.friends, {
						params: {
							id: that.selfResult.activate_id,
							page: that.$data.page + 1
						}
					}).then(function (res) {
						that.setBusy(false);
						if (res.data.code == 200) {
							if (res.data.data.length > 0) {
								that.$data.page++;
								console.log(that.$data.page);
								for (var i = 0; i < res.data.data.length; i++) {
									that.friendList.push(res.data.data[i]);
								}
								that.setFriendList(that.friendList);
							} else {
								that.$data.friendListEnd = true;
							}
						}
					}).catch(function (error) {
						that.setBusy(false);
						console.log(error);
					});
				}
			}
		})
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _data = __webpack_require__(25);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _vuex = __webpack_require__(1);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _apis = __webpack_require__(5);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _yxlLogo = __webpack_require__(7);
	
	var _yxlLogo2 = _interopRequireDefault(_yxlLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'proreport',
		components: {
			yxlLogo: _yxlLogo2.default
		},
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			_axios2.default.get(_apis2.default.getSelfReport, {
				params: {
					'isWeiXin': to.query.isWeiXin ? to.query.isWeiXin : 0
				}
			}).then(function (res) {
				var res = res.data;
				if (res.code == 200) {
					_store2.default.commit('setFunreport', { report: res.data, gender: res.data.gender });
				} else if (res.code == 1001) {
					window.location.href = _apis2.default.shouquan + '?callback=' + encodeURIComponent(location.href);
				}
			}).then(function () {
				next(function (vm) {});
			}).catch(function (error) {
				console.log(error);
			});
		},
		created: function created() {
			if (this.$route.query.channel_id) {
				this.setChannelId(this.$route.query.channel_id);
			}
			if (this.GetQueryString("channel_id")) {
				this.setChannelId(this.GetQueryString("channel_id"));
			}
		},
		mounted: function mounted() {
			if (this.selfResult != undefined & this.selfResult.unlock != '1') {
				_router2.default.push({
					name: 'index',
					path: '/index',
					query: {
						channel_id: this.channel_id
					}
				});
			}
	
			var body = document.querySelector('body');
			document.title = '专业测评报告';
	
			this.setStayFun(true);
			document.querySelector('.page-proreport').style.minHeight = window.screen.availHeight + 'px';
			wx.ready(function () {
				wx.hideMenuItems({
					menuList: ['menuItem:share:qq', 'menuItem:share:timeline', "menuItem:share:appMessage", 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari", "menuItem:copyUrl"] });
			});
		},
		data: function data() {
			return {
				Onp: {
					lovers: 0,
					friends: 0,
					colleague: 0,
					parents: 0
				},
				Tab: 'youdian'
			};
		},
	
		computed: (0, _vuex.mapState)({
			funreport: function funreport(state) {
				return state.funreport;
			},
			selfResult: function selfResult(state) {
				return state.selfResult;
			},
			channel_id: function channel_id(state) {
				return state.channel_id;
			}
		}),
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getSelfReport']), (0, _vuex.mapMutations)(['setStayFun', 'setChannelId']), {
			toggleOnp: function toggleOnp(whom) {
				this.$data.Onp[whom] = !this.$data.Onp[whom];
			},
			switchTab: function switchTab(tabName) {
				this.$data.Tab = tabName;
			},
			toFunreport: function toFunreport() {
				this.setStayFun(true);
				_router2.default.push({
					path: '/funreport/:stay',
					name: 'funreport',
					query: {
						isWeiXin: this.$route.query.isWeiXin ? this.$route.query.isWeiXin : 0,
						channel_id: this.channel_id
					}
				});
			}
		})
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _yxlLogo = __webpack_require__(7);
	
	var _yxlLogo2 = _interopRequireDefault(_yxlLogo);
	
	var _qrcodeMask = __webpack_require__(9);
	
	var _qrcodeMask2 = _interopRequireDefault(_qrcodeMask);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'QuestionPage',
		components: {
			yxlLogo: _yxlLogo2.default,
			qrcodeMask: _qrcodeMask2.default
		},
		data: function data() {
			return {
				isFirstShare: true,
				qrCodeMask: false,
				submit: false
			};
		},
		created: function created() {
			if (this.isOwnEmpty(this.$store.state.questions)) {
				_router2.default.push({
					name: 'index',
					path: '/index'
				});
			} else {
				_router2.default.push({
					name: 'question',
					params: {
						questionId: this.$store.state.curQuestion
					}
				});
			}
			if (this.$route.query.channel_id) {
				this.setChannelId(this.$route.query.channel_id);
			}
			if (this.GetQueryString("channel_id")) {
				this.setChannelId(this.GetQueryString("channel_id"));
			}
		},
		mounted: function mounted() {
			document.title = '你是萌兽，还是猛兽？';
	
			var that = this;
			wx.ready(function () {
				console.log(that);
				wx.onMenuShareAppMessage({
					title: '你是萌兽，还是猛兽？',
					desc: '超准的心理测试，用动物看出你真正的性格！',
					link: "http://static.xinli001.com/animalPicture/index.html",
					imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg",
					type: '',
					dataUrl: '',
					success: function success() {
						zhuge.track('测评活动', {
							'被分享页面': '首页或答题页'
						});
					},
					cancel: function cancel() {}
				});
	
				wx.onMenuShareTimeline({
					title: '你是萌兽，还是猛兽？',
					link: 'http://static.xinli001.com/animalPicture/index.html',
					imgUrl: "http://static.xinli001.com/animalPicture/static/images/indexNq-share.jpg",
					success: function success() {
						zhuge.track('测评活动', {
							'被分享页面': '首页或答题页'
						});
					},
					cancel: function cancel() {}
				});
	
				wx.hideMenuItems({
					menuList: ['menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari"] });
			});
		},
		beforeUpdate: function beforeUpdate() {
			if (this.$store.state.questions[this.$store.state.curQuestion].selected == undefined) {
				this.$store.state.questions[this.$store.state.curQuestion].selected = '';
			}
			var pArray = document.querySelectorAll('.question-cont p');
			for (var i = 0; i < pArray.length; i++) {
				pArray[i].className = '';
			}
			this.curAnswer = this.$store.state.answers[this.curQuestion.question_id];
		},
	
		computed: (0, _extends3.default)({
			curAnswer: function curAnswer() {
				var state = this.$store.state;
				return state.answers[this.question.question_id] == undefined ? '' : state.answers[this.question.question_id];
			}
		}, (0, _vuex.mapState)({
			curQuestion: function curQuestion(state) {
				return state.curQuestion;
			},
			question: function question(state) {
				return state.questions[state.curQuestion];
			},
			optionIndex: function optionIndex() {
				return ['A', 'B', 'C', 'D'];
			},
	
			questionListLength: function questionListLength(state) {
				return state.questionListLength;
			},
			answers: function answers(state) {
				return state.answers;
			},
			selfResult: function selfResult(state) {
				return state.selfResult;
			},
			finishTest: function finishTest(state) {
				return state.finishTest;
			},
			channel_id: function channel_id(state) {
				return state.channel_id;
			}
		})),
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['pullQuestion', 'createFunReport']), (0, _vuex.mapMutations)(['setCurQuestion', 'setAnswers', 'setBusy', 'setChannelId']), {
			answerQuestion: function answerQuestion(selectedOption) {
				var pArray = document.querySelectorAll('.question-cont p');
				for (var i = 0; i < pArray.length; i++) {
					pArray[i].className = "";
				}
				event.target.className += 'selected';
				if (this.curQuestion <= this.questionListLength) {
					this.setAnswers({
						key: this.question.question_id,
						value: selectedOption
					});
	
					this.answers[this.question.question_id] = selectedOption;
					this.$data.curAnswer = selectedOption;
					if (this.curQuestion < this.questionListLength) {
						this.toNextQuestion();
					}
				}
			},
			toNextQuestion: function toNextQuestion() {
				var that = this;
				if (that.$store.state.answers[that.question.question_id + ""] != '') {
					if (that.$store.state.busy) {
						console.log('busy!!!!');
						return;
					}
					that.setBusy(true);
					setTimeout(function () {
						that.setCurQuestion(that.$store.state.curQuestion + 1);
						that.setBusy(false);
						_router2.default.push({
							name: 'question',
							params: {
								questionId: that.$store.state.curQuestion
							}
						});
					}, 500);
				}
			},
			toPrevQuestion: function toPrevQuestion() {
				if (this.curQuestion - 1 >= 0) {
					this.setCurQuestion(this.curQuestion - 1);
					_router2.default.push({
						name: 'question',
						params: {
							questionId: this.curQuestion
						}
					});
				}
			},
			submitAnswers: function submitAnswers() {
				var that = this;
				var params = {
					gender: this.$store.state.sex,
					params: this.$store.state.answers
				};
	
				if (!this.$data.submit) {
					var _that = this;
					this.createFunReport({
						dataPack: params,
						callback: function callback() {
							_router2.default.push({
								name: 'funreport',
								path: '/funreport',
								query: {
									channel_id: _that.channel_id
								}
							});
						},
						check: _that.getObjLength,
						questionListLength: _that.questionListLength
					});
					_that.$data.submit = true;
					setTimeout(function () {
						_that.$data.submit = false;
					}, 5000);
				} else {
					console.log('busy');
				}
			},
			toFunreport: function toFunreport() {
				_router2.default.push({
					name: 'funreport',
					path: '/funreport'
				});
			}
		})
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(6);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(1);
	
	var _axios = __webpack_require__(4);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _apis = __webpack_require__(5);
	
	var _apis2 = _interopRequireDefault(_apis);
	
	var _store = __webpack_require__(8);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _yxlLogo = __webpack_require__(7);
	
	var _yxlLogo2 = _interopRequireDefault(_yxlLogo);
	
	var _funHeadShare = __webpack_require__(117);
	
	var _funHeadShare2 = _interopRequireDefault(_funHeadShare);
	
	var _funBodyShare = __webpack_require__(114);
	
	var _funBodyShare2 = _interopRequireDefault(_funBodyShare);
	
	var _qrcodeMask = __webpack_require__(9);
	
	var _qrcodeMask2 = _interopRequireDefault(_qrcodeMask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'shareReportPage',
		components: {
			yxlLogo: _yxlLogo2.default,
			funHead: _funHeadShare2.default,
			funReport: _funBodyShare2.default,
			qrcodeMask: _qrcodeMask2.default
		},
	
		beforeRouteEnter: function beforeRouteEnter(to, from, next) {
			_axios2.default.get(_apis2.default.sharereport, {
				params: {
					id: to.params.reportId
				}
			}).then(function (res) {
				var res = res.data;
				if (res.code == 200) {
					_store2.default.commit('setShareReport', { report: res.data, gender: res.gender });
				} else if (res.code == 1001) {
					window.location.href = _apis2.default.shouquan + '?callback=' + encodeURIComponent(location.href);
				} else if (res.code = 400) {
					_router2.default.push({
						path: '/funreport',
						name: 'funreport'
					});
				}
			}).then(function () {
				next(function (vm) {
					console.log('load');
	
					var fromChannel = vm.GetQueryString("fromChannel") ? vm.GetQueryString("fromChannel") : 1;
					if (fromChannel != 1) {
						console.log("fromChannel:" + fromChannel);
						zhuge.track('测评活动', {
							'打开分享页渠道': '外部渠道'
						});
					}
				});
			}).catch(function (error) {
				console.log(error);
			});
		},
	
		computed: (0, _vuex.mapState)({
			selfResult: function selfResult(state) {
				return state.selfResult;
			},
			sharereport: function sharereport(state) {
				return state.sharereport;
			},
			channel_id: function channel_id(state) {
				return state.channel_id;
			},
			fromChannel: function fromChannel() {
				return this.GetQueryString("fromChannel") ? this.GetQueryString("fromChannel") : 1;
			}
		}),
		mounted: function mounted() {
			document.querySelector('.page-funreport').style.minHeight = window.screen.availHeight - 45 + 'px';
	
			document.title = '你是萌兽，还是猛兽？';
	
			var that = this;
			wx.ready(function () {
				wx.onMenuShareAppMessage({
					title: '天了噜，' + that.selfResult.nickname + ' 灵魂深处竟然是神兽' + that.sharereport.animal + '！',
					desc: '每个人身体里都有一只动物，代表着你最原始的兽性',
					link: 'http://static.xinli001.com/animalPicture/index.html?fromChannel=' + that.fromChannel + '#/sharereport/' + that.selfResult.activate_id + '?' + Math.random(),
					imgUrl: 'http://static.xinli001.com/animalPicture/' + that.sharereport.pic.replace('../', ''),
					type: 'link',
					dataUrl: '',
					success: function success() {
						zhuge.track('测评活动', {
							'被分享页面': '好友分享页'
						});
					},
					cancel: function cancel() {}
				});
	
				wx.onMenuShareTimeline({
					title: '天了噜，' + that.selfResult.nickname + ' 灵魂深处竟然是神兽' + that.sharereport.animal + '！',
					link: 'http://static.xinli001.com/animalPicture/index.html?fromChannel=' + that.fromChannel + '#/sharereport/' + that.selfResult.activate_id + '?' + Math.random(),
					imgUrl: 'http://static.xinli001.com/animalPicture/' + that.sharereport.pic.replace('../', ''),
					success: function success() {
						zhuge.track('测评活动', {
							'被分享页面': '好友分享页'
						});
					},
					cancel: function cancel() {}
				});
	
				wx.hideMenuItems({
					menuList: ['menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:QZone', "menuItem:openWithSafari", "menuItem:copyUrl"] });
			});
			this.setShareFrom(this.$route.params.reportId);
		},
	
		methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['setShareFrom', 'setChannelId']), {
			goIndex: function goIndex() {
				_router2.default.push({
					name: 'index',
					path: '/index',
					query: {
						channel_id: this.channel_id
					}
				});
			},
			gotoWz: function gotoWz() {
				if (this.fromChannel == 1) {
					zhuge.track('测评活动', {
						'进入微站渠道': '内部渠道'
					});
				} else {
					zhuge.track('测评活动', {
						'进入微站渠道': '外部渠道'
					});
				}
				window.location.href = 'http://' + this.selfResult.testurl;
			}
		})
	};

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(94)
	
	/* script */
	__vue_exports__ = __webpack_require__(50)
	
	/* template */
	var __vue_template__ = __webpack_require__(126)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-151f80b8"
	
	module.exports = __vue_exports__


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(96)
	
	/* script */
	__vue_exports__ = __webpack_require__(51)
	
	/* template */
	var __vue_template__ = __webpack_require__(128)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2ba0c034"
	
	module.exports = __vue_exports__


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(104)
	
	/* script */
	__vue_exports__ = __webpack_require__(52)
	
	/* template */
	var __vue_template__ = __webpack_require__(136)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a0bb636e"
	
	module.exports = __vue_exports__


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(99)
	
	/* script */
	__vue_exports__ = __webpack_require__(53)
	
	/* template */
	var __vue_template__ = __webpack_require__(131)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-48fbf8a0"
	
	module.exports = __vue_exports__


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(98)
	
	/* script */
	__vue_exports__ = __webpack_require__(54)
	
	/* template */
	var __vue_template__ = __webpack_require__(130)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4231e524"
	
	module.exports = __vue_exports__


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(97)
	
	/* script */
	__vue_exports__ = __webpack_require__(55)
	
	/* template */
	var __vue_template__ = __webpack_require__(129)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-310f9fcb"
	
	module.exports = __vue_exports__


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(103)
	
	/* script */
	__vue_exports__ = __webpack_require__(57)
	
	/* template */
	var __vue_template__ = __webpack_require__(135)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7a2aaba0"
	
	module.exports = __vue_exports__


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(100)
	
	/* script */
	__vue_exports__ = __webpack_require__(58)
	
	/* template */
	var __vue_template__ = __webpack_require__(132)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4aa4f8f9"
	
	module.exports = __vue_exports__


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(106)
	
	/* script */
	__vue_exports__ = __webpack_require__(59)
	
	/* template */
	var __vue_template__ = __webpack_require__(138)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c8dfe3de"
	
	module.exports = __vue_exports__


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(102)
	
	/* script */
	__vue_exports__ = __webpack_require__(60)
	
	/* template */
	var __vue_template__ = __webpack_require__(134)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5e17e08c"
	
	module.exports = __vue_exports__


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(105)
	
	/* script */
	__vue_exports__ = __webpack_require__(61)
	
	/* template */
	var __vue_template__ = __webpack_require__(137)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c03bd930"
	
	module.exports = __vue_exports__


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(101)
	
	/* script */
	__vue_exports__ = __webpack_require__(62)
	
	/* template */
	var __vue_template__ = __webpack_require__(133)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4f32a26f"
	
	module.exports = __vue_exports__


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(95)
	
	/* script */
	__vue_exports__ = __webpack_require__(63)
	
	/* template */
	var __vue_template__ = __webpack_require__(127)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-18db4a5a"
	
	module.exports = __vue_exports__


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "qrCodeMask"
	  }, [_c('div', {
	    staticClass: "mask"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "qrCode"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(18),
	      "height": "123",
	      "width": "123"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("关注公众号")]), _vm._v(" "), _c('p', [_vm._v("自动收到好友的性格分析报告")])])])
	}]}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "share"
	  }, [_c('div', {
	    staticClass: "shareMask"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "shareTip"
	  })])
	}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-funreport"
	  }, [_c('img', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "src": _vm.sharereport.pic.replace('../', './')
	    }
	  }), _vm._v(" "), _c('fun-head'), _vm._v(" "), _c('fun-report'), _vm._v(" "), _c('div', {
	    staticClass: "funreport-actions"
	  }, [_c('a', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.goIndex()
	      }
	    }
	  }, [_vm._v("我的动物画像")]), _vm._v(" "), (_vm.fromChannel == 1) ? _c('a', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.gotoWz()
	      }
	    }
	  }, [_vm._v("更多精彩测试")]) : _c('a', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.gotoWz()
	      }
	    }
	  }, [_vm._v("专业爱情测评")])]), _vm._v(" "), _c('yxl-logo')], 1)
	},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "funreport"
	  }, [_c('div', {
	    staticClass: "tagsNavatar"
	  }, [_c('ul', {
	    class: ['tags', _vm.funreport.key]
	  }, _vm._l((_vm.tags), function(item, $index) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.countTags(item, this)
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.funreport.pic.replace('animal', item).replace('../', './')
	      }
	    }), _vm._v(" "), _c('i', {
	      staticClass: "tagCount"
	    }, [_vm._v(_vm._s(_vm.tagObj[item].num) + "\n\t\t\t\t\t"), _c('i', {
	      staticClass: "add",
	      on: {
	        "animationend": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.removeAnimate()
	        }
	      }
	    }, [_vm._v("+1")]), _vm._v(" "), _c('i', {
	      staticClass: "minus",
	      on: {
	        "animationend": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.removeAnimate()
	        }
	      }
	    }, [_vm._v("-1")])])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "animal"
	  }, [_c('router-link', {
	    attrs: {
	      "to": '/download'
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.funreport.pic.replace('../', './')
	    }
	  })])], 1)]), _vm._v(" "), _c('p', {
	    staticClass: "saveTip"
	  }, [_vm._v("点击动物保存动物画像")]), _vm._v(" "), _c('p', {
	    staticClass: "short_description"
	  }, [_vm._v(_vm._s(_vm.funreport.short_description))])])
	},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "funreport-title"
	  }, [_c('div', {
	    staticClass: "fromWhom"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.selfResult.avatar
	    }
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "animal"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.funreport.pic.replace('animal.png', 'animalNameCh.png').replace('../', './')
	    }
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "dots"
	  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])
	}]}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "funreport-title"
	  }, [_c('div', {
	    staticClass: "animal"
	  }, [_c('div', {
	    staticClass: "ch"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.funreport.pic.replace('animal.png', 'animalName.png').replace('../', './')
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "en"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "friend"
	  }, [_c('div', {
	    staticClass: "friendList"
	  }, [(_vm.friendList.length > 0) ? _c('ul', [_vm._l((_vm.friendList), function(item, index) {
	    return _c('li', [_c('img', {
	      staticClass: "avatar",
	      attrs: {
	        "src": item.avatar
	      },
	      on: {
	        "click": function($event) {
	          _vm.friendreport(item.id)
	        }
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "text"
	    }, [_c('p', {
	      staticClass: "nickName"
	    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('p', {
	      staticClass: "desc"
	    }, [_vm._v("完成了本测评，ta的代表动物竟然是：")])]), _vm._v(" "), _c('div', {
	      staticClass: "animal"
	    }, [_c('img', {
	      attrs: {
	        "src": item.images
	      },
	      on: {
	        "click": function($event) {
	          _vm.friendreport(item.id)
	        }
	      }
	    })])])
	  }), _vm._v(" "), (_vm.busy) ? _c('p', {
	    staticClass: "busy"
	  }, [_vm._v("正在加载好友报告")]) : _vm._e()], 2) : _c('div', {
	    staticClass: "empty"
	  }, [_c('div', {
	    staticClass: "smile"
	  }), _vm._v(" "), _c('p', [_vm._v("分享本报告，此处有惊喜，记得常回来看看！")])]), _vm._v(" "), _vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "qrcode"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(18),
	      "alt": "qrcode"
	    }
	  })])
	}]}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-index"
	  }, [_c('img', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "src": __webpack_require__(32),
	      "height": "300",
	      "width": "300"
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "picSource"
	  }, [_vm._v("图片来源:123RF正版图库")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.isTested == 0) ? _c('ul', {
	    staticClass: "setSex"
	  }, [_c('li', {
	    staticClass: "setSex_male"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.answerSex('1')
	      }
	    }
	  }, [_vm._v("男生入口")])]), _vm._v(" "), _c('li', {
	    staticClass: "setSex_female"
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.answerSex('2')
	      }
	    }
	  }, [_vm._v("女生入口")])])]) : _vm._e(), _vm._v(" "), (_vm.isTested == 1) ? _c('ul', {
	    staticClass: "testedMenu"
	  }, [_c('li', {
	    staticClass: "resetIstested",
	    on: {
	      "click": function($event) {
	        _vm.redoDialog()
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "checkReport",
	    on: {
	      "click": function($event) {
	        _vm.checkReport()
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('yxl-logo'), _vm._v(" "), (_vm.redoDialogShow) ? _c('div', {
	    staticClass: "redoDialog"
	  }, [_c('div', {
	    staticClass: "redoMask"
	  }, [_vm._v("!")]), _vm._v(" "), _c('div', {
	    staticClass: "dialog"
	  }, [_c('h1', [_vm._v("WARNING")]), _vm._v(" "), _c('p', [_vm._v("新的测试报告将会覆盖原来的测试结果，这可能会导致您重复付费，确定要再测一次吗？")]), _vm._v(" "), _c('div', {
	    staticClass: "actions"
	  }, [_c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.redo()
	      }
	    }
	  }, [_vm._v("再测一次")]), _vm._v(" "), _c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.redoDialog()
	      }
	    }
	  }, [_vm._v("容朕想想")])])])]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "titles"
	  }, [_c('div', {
	    staticClass: "title_pic"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "title_en"
	  })])
	}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-question"
	  }, [_c('img', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "src": __webpack_require__(32)
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    staticClass: "question-pic"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.question.image
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    staticClass: "question-cont"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.question.question_title))]), _vm._v(" "), _vm._l((_vm.question.options), function(item, i) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.answerQuestion(item.option)
	        }
	      }
	    }, [_c('p', [_vm._v(_vm._s(_vm.optionIndex[i]) + ". " + _vm._s(item.title))])])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "question-nav"
	  }, [_c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: ((_vm.curQuestion > 1) & !_vm.submit),
	      expression: "(curQuestion > 1) & !submit"
	    }],
	    staticClass: "prevQues",
	    on: {
	      "click": function($event) {
	        _vm.toPrevQuestion()
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (((_vm.curQuestion) == _vm.questionListLength) & !_vm.submit),
	      expression: "((curQuestion) == questionListLength) & !submit"
	    }],
	    staticClass: "submitQues",
	    on: {
	      "click": function($event) {
	        _vm.submitAnswers()
	      }
	    }
	  }), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (((_vm.curQuestion) == _vm.questionListLength) & _vm.submit),
	      expression: "((curQuestion) == questionListLength) & submit"
	    }],
	    staticClass: "submitWait"
	  }, [_vm._v("提交中")])]), _vm._v(" "), _c('div', {
	    staticClass: "question-progress"
	  }, [_c('div', {
	    staticClass: "progress-bg"
	  }, [_c('i', {
	    style: ({
	      width: (_vm.curQuestion / _vm.questionListLength) * 100 + '%'
	    })
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "progress-text"
	  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.curQuestion) + "/" + _vm._s(_vm.questionListLength) + "\n\t\t\t")])]), _vm._v(" "), _c('yxl-logo'), _vm._v(" "), (_vm.finishTest) ? _c('div', {
	    staticClass: "hasDone"
	  }, [_c('div', {
	    staticClass: "mask"
	  }, [_vm._v("!")]), _vm._v(" "), _c('div', {
	    staticClass: "dialog"
	  }, [_c('h1', [_vm._v("WARNNING")]), _vm._v(" "), _c('p', [_vm._v("您已完成本次测试，请勿重复提交。")]), _vm._v(" "), _c('div', {
	    staticClass: "actions"
	  }, [_c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toFunreport()
	      }
	    }
	  }, [_vm._v("朕知道了")])])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.stayFun),
	      expression: "stayFun"
	    }],
	    staticClass: "page-funreport",
	    on: {
	      "touchmove": function($event) {
	        _vm.loadMoreFriend()
	      }
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "src": _vm.funreport.pic.replace('../', './')
	    }
	  }), _vm._v(" "), _c('fun-head'), _vm._v(" "), _c('fun-report'), _vm._v(" "), _c('div', {
	    staticClass: "funreport-actions"
	  }, [(!_vm.is_free & !_vm.shareLock) ? _c('div', [_c('p', {
	    staticClass: "unlock-tips"
	  }, [_vm._v("好奇的，来打赏" + _vm._s(_vm.price) + "元")]), _vm._v(" "), _c('p', {
	    staticClass: "unlock-tips"
	  }, [_vm._v("心理学家深度解读你的性格、爱情、职场特质")]), _vm._v(" "), _c('a', {
	    staticClass: "btn mg0",
	    on: {
	      "click": function($event) {
	        _vm.buyReport()
	      }
	    }
	  }, [_vm._v("好的，GO！")])]) : _vm._e(), _vm._v(" "), (_vm.is_free & !_vm.shareLock) ? _c('a', {
	    staticClass: "btn",
	    on: {
	      "click": function($event) {
	        _vm.funToShare()
	      }
	    }
	  }, [_vm._v("限时免费！马上解锁专业报告")]) : _vm._e(), _vm._v(" "), (_vm.is_free & !_vm.shareLock) ? _c('p', {
	    staticClass: "unlockPeople"
	  }, [_vm._v("已有" + _vm._s(_vm.selfResult.unlock_num) + "人成功解锁专业报告")]) : _vm._e(), _vm._v(" "), (_vm.shareLock) ? _c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toProReport()
	      }
	    }
	  }, [_vm._v("查看专业报告")]) : _vm._e(), _vm._v(" "), (_vm.shareLock) ? _c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleShare()
	      }
	    }
	  }, [_vm._v("看看好友的动物画像")]) : _vm._e()]), _vm._v(" "), (_vm.shareLock | !_vm.is_free) ? _c('div', [_c('friend-list')], 1) : _vm._e(), _vm._v(" "), (_vm.shareMask & _vm.shareLock) ? _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.toggleShare()
	      }
	    }
	  }, [_c('unlock-share')], 1) : _vm._e(), _vm._v(" "), (_vm.shareMask & !_vm.shareLock) ? _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.toggleShare()
	      }
	    }
	  }, [_c('free-share')], 1) : _vm._e(), _vm._v(" "), _c('yxl-logo'), _vm._v(" "), (_vm.qrCodeMask & _vm.isFirstShare) ? _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.oneQrcode()
	      }
	    }
	  }, [_c('qrcode-mask')], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "share"
	  }, [_c('div', {
	    staticClass: "shareMask"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "shareTip"
	  })])
	}]}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "funreport"
	  }, [_c('div', {
	    staticClass: "tagsNavatar"
	  }, [_c('ul', {
	    class: ['tags', _vm.funreport.key]
	  }, _vm._l((_vm.tags), function(item, $index) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.countTags(item, this)
	        },
	        "animationend": function($event) {
	          _vm.removeAnimate('rubberBand')
	        }
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.funreport.pic.replace('animal', item).replace('../', './')
	      }
	    }), _vm._v(" "), _c('i', {
	      staticClass: "tagCount"
	    }, [_vm._v(_vm._s(_vm.tagObj[item].num) + "\n\t\t\t\t\t"), _c('i', {
	      staticClass: "add",
	      on: {
	        "animationend": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.removeAnimate()
	        }
	      }
	    }, [_vm._v("+1")]), _vm._v(" "), _c('i', {
	      staticClass: "minus",
	      on: {
	        "animationend": function($event) {
	          if ($event.target !== $event.currentTarget) { return null; }
	          _vm.removeAnimate()
	        }
	      }
	    }, [_vm._v("-1")])])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "animal"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.funreport.pic.replace('../', './')
	    }
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "short_description"
	  }, [_vm._v(_vm._s(_vm.funreport.short_description))])])
	},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-proreport"
	  }, [_c('div', {
	    staticClass: "head"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.selfResult.avatar
	    }
	  })]), _vm._v(" "), _c('h1', [_vm._v("你的动物画像专业报告")])]), _vm._v(" "), _c('div', {
	    staticClass: "body"
	  }, [_c('div', {
	    staticClass: "desc"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.basic_discription)
	    }
	  })]), _vm._v(" "), _c('div', {
	    class: [_vm.funreport.key, 'position']
	  }, [_c('div', {
	    staticClass: "top t"
	  }, [_vm._v("外向")]), _vm._v(" "), _c('div', {
	    staticClass: "left t"
	  }, [_vm._v("关系主导")]), _vm._v(" "), _c('div', {
	    staticClass: "right t"
	  }, [_vm._v("工作主导")]), _vm._v(" "), _c('div', {
	    staticClass: "bottom t"
	  }, [_vm._v("内向")]), _vm._v(" "), _c('img', {
	    staticClass: "avatar",
	    style: (_vm.funreport.coordinate),
	    attrs: {
	      "src": _vm.selfResult.avatar
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "inPeopleEye"
	  }, [_c('div', {
	    class: ['onp', 'lovers', _vm.Onp.lovers ? 'open' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toggleOnp('lovers')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "whom"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.in_lover)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow"
	  })]), _vm._v(" "), _c('div', {
	    class: ['onp', 'friends', _vm.Onp.friends ? 'open' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toggleOnp('friends')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "whom"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.in_friends)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow"
	  })]), _vm._v(" "), _c('div', {
	    class: ['onp', 'colleague', _vm.Onp.colleague ? 'open' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toggleOnp('colleague')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "whom"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.in_colleagues)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow"
	  })]), _vm._v(" "), _c('div', {
	    class: ['onp', 'parents', _vm.Onp.parents ? 'open' : ''],
	    on: {
	      "click": function($event) {
	        _vm.toggleOnp('parents')
	      }
	    }
	  }, [_c('div', {
	    staticClass: "whom"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "desc",
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.will_be)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "arrow"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "yqd"
	  }, [_c('ul', {
	    staticClass: "tabs"
	  }, [_c('li', {
	    class: ['tab', 'youdian', _vm.Tab == 'youdian' ? 'show' : ''],
	    on: {
	      "click": function($event) {
	        _vm.switchTab('youdian')
	      }
	    }
	  }), _vm._v(" "), _c('li', {
	    class: ['tab', 'quedian', _vm.Tab == 'quedian' ? 'show' : ''],
	    on: {
	      "click": function($event) {
	        _vm.switchTab('quedian')
	      }
	    }
	  }), _vm._v(" "), _c('li', {
	    class: ['tab', 'jianyi', _vm.Tab == 'jianyi' ? 'show' : ''],
	    on: {
	      "click": function($event) {
	        _vm.switchTab('jianyi')
	      }
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "tab_conts"
	  }, [_c('li', {
	    class: ['tab_cont', 'youdian', _vm.Tab == 'youdian' ? 'show' : ''],
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.advantage)
	    }
	  }), _vm._v(" "), _c('li', {
	    class: ['tab_cont', 'quedian', _vm.Tab == 'quedian' ? 'show' : ''],
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.shortcoming)
	    }
	  }), _vm._v(" "), _c('li', {
	    class: ['tab_cont', 'jianyi', _vm.Tab == 'jianyi' ? 'show' : ''],
	    domProps: {
	      "innerHTML": _vm._s(_vm.funreport.suggest)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "jobs"
	  }, [_c('div', {
	    staticClass: "title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "desc"
	  }, [_vm._v(_vm._s(_vm.funreport.match_jobs))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "toFunreport"
	  }, [_c('a', {
	    staticClass: "btn",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toFunreport()
	      }
	    }
	  }, [_vm._v("趣味报告点这里")])]), _vm._v(" "), _c('yxl-logo')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "qrcode"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(18),
	      "alt": "qrcode"
	    }
	  })])
	}]}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-download"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.funreport.pic.replace('animal', 'animalHD').replace('../', './')
	    }
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "btn",
	    attrs: {
	      "to": '/funreport?stay=1'
	    }
	  }, [_vm._v("返回报告页")])], 1)
	},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('i', {
	    staticClass: "yxl-logo"
	  })
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.f0b6fc40dd47befe25d4.js